<template>
    <div>
        <!-- <img style="display: none;" id='logobarter' :src="imagepath" alt='logobarter' crossorigin="anonymous"> -->
        <div id="logoDiv" style="display: none;"></div>
        <a-spin :tip="spinMessage" :spinning="spinning">
        <base-header type="instore" class="pb-5 pt-5 pt-md-8">
        </base-header>

        <div class="container sticky-top sticky-header pt-3" style="background-color: #f5365c; visibility: hidden; border-radius: 0 0 5px 5px;">
            <div class="row ">
                <div class="col-auto">
                    <!-- <router-link :to="{ name: 'documents'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link> -->
                    <router-link :to="backLink" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link>
                </div>
                <div class="col p-0">
                    <div class="float-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                            <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                            </div>
                            <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <a v-if='originDocumentTypeId > 0' class="dropdown-item" @click='openOriginDocument(originDocumentNumber)'><i class="fa fa-angle-double-left"></i><span>{{originDocumentTypeName}} #{{originDocumentNumber}}</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')"><i class="fa fa-plus"></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                <a class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                            </template>
                        </base-dropdown>
                    <p v-if="accessRights.includes('T') && documentNumber>0  && orderSource!='shopee' && orderSource!='lazada' && currentDocumentTypeCode!='ORIPOX' && currentDocumentTypeCode!='OTHTRA' && currentDocumentTypeCode!='OTHPCK'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="print()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && currentDocumentTypeCode=='ORIPOX'">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="exportCSV()">CSV</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true, 'dotMatrix')">PDF DOT</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="print(true)">Print Standard</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true, 'dotMatrix')">Print Standard DOT</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(false)">Print Extended</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(false, 'dotMatrix')">Print Extended DOT</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (orderSource=='shopee' || orderSource=='lazada')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="print(true)">Document</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <i v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                    </div>
                </div>
                <div class='col-auto ml-2'>
                    <div class="float-right">
                        <button v-if="documentOrderStatus != 'Frozen' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN'" type="button" class="btn btn-light btn-sm" @click.prevent="freeze()">Freeze Inventory</button>
                        <!-- FOR MR. SPEEDY SAMPLE -->
                        <button v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Book Delivery</button>

                        <button v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>
                        <button v-if="documentStatus == 'Posted' && showCreateChildDocButton" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>{{createChildDocButtonLabel}}</button>
                        <button v-if="documentStatus == 'Posted' && showCreateChildDocButton && currentDocumentTypeCode=='ORIPOX' && asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                        <button v-if="accessRights.includes('A') && documentNumber==0" type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">Create {{currentDocumentTypeName}}</button>
                        <button v-if="accessRights.includes('W') && documentNumber>0 && documentStatus == 'Saved' || documentStatus == 'Upload Error'" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="isUpdateDisabled">Update </button>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                        </a-popconfirm>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                        </a-popconfirm>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                        </a-popconfirm>
                        <button v-if="accessRights.includes('C') && documentNumber!=0 && documentStatus == 'Saved' || documentStatus == 'Upload Error' && showconfirmUnconfirmButton" :disabled="isConfirmDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>
                        <button v-if="documentNumber!=0 && documentStatus == 'Confirmed' && showconfirmUnconfirmButton" type="button" class="btn btn-light btn-sm" @click.prevent="unconfirm()">Unconfirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7 spin-content">
            <div class="row regular-header">
                <div class="col-auto">
                    <router-link :to="backLink" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link>
                    <!-- <router-link :to="{ name: 'documents'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link> -->
                </div>
                <div class="col p-0">
                    <div class="float-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                            <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                            </div>
                            <!-- <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <a v-if='originDocumentTypeId > 0' class="dropdown-item" @click='openOriginDocument(originDocumentNumber)'><i class="fa fa-angle-double-left"></i><span>{{originDocumentTypeName}} #{{originDocumentNumber}}</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')"><i class="fa fa-plus"></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                            </template> -->
                            <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <a v-if='originDocumentTypeId > 0' class="dropdown-item" @click='openOriginDocument(originDocumentNumber)'><i class="fa fa-angle-double-left"></i><span>{{originDocumentTypeName}} #{{originDocumentNumber}}</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')" v-if="currentDocumentTypeCode !== 'OTHPWS'"><i class="fa fa-plus" ></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <!-- <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify')" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template> -->
                                <template v-if="currentDocumentTypeCode != 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                <a class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                            </template>
                        </base-dropdown>
                        <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && orderSource!="shopee" && orderSource!="lazada" && currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="OTHTRA" && currentDocumentTypeCode!="OTHPCK"'>
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="e => e.preventDefault()"> <b style="font-family: 'Arial', sans-serif;"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="print(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true, 'dotMatrix')">DOT PDF</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && currentDocumentTypeCode=='ORIPOX'">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="exportCSV()">CSV</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true, 'dotMatrix')">DOT PDF</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="print(true)">Print Standard</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(true, 'dotMatrix')">Print Standard DOT</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(false)">Print Extended</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="print(false, 'dotMatrix')">Print Extended DOT</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && (orderSource=="shopee" || orderSource=="lazada")'>
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="print(true)">Document</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <i v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click.prevent=""> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                    </div>
                </div>
                <div class='col-auto ml-2'>
                    <div class="float-right">
                        <button v-if="documentOrderStatus != 'Frozen' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN'" type="button" class="btn btn-light btn-sm" @click.prevent="freeze()">Freeze Inventory</button>
                        <button v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>

                        <!-- FOR MR. SPEEDY SAMPLE -->
                        <button v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Booking Details</button>
                        <button v-if="documentStatus == 'Posted' && showCreateChildDocButton" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>{{createChildDocButtonLabel}}</button>
                        <button v-if="documentStatus == 'Posted' && showCreateChildDocButton && currentDocumentTypeCode=='ORIPOX' && asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                        <button v-if="accessRights.includes('A') && documentNumber==0" type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">Create {{currentDocumentTypeName}}</button>
                        <button v-if="accessRights.includes('W') && documentNumber>0 && documentStatus == 'Saved' || documentStatus == 'Upload Error'" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="isUpdateDisabled">Update </button>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                        </a-popconfirm>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white" >Post</a>
                        </a-popconfirm>
                        <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                            <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                        </a-popconfirm>
                        <button v-if="accessRights.includes('C') && documentNumber!=0 && documentStatus == 'Saved' || documentStatus == 'Upload Error' && showconfirmUnconfirmButton" :disabled="isConfirmDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>
                        <button v-if="documentNumber!=0 && documentStatus == 'Confirmed' && showconfirmUnconfirmButton" type="button" class="btn btn-light btn-sm" @click.prevent="unconfirm()">Unconfirm</button>
                    </div>
                </div>
            </div>

            <!-- View Internal ID Modal -->
            <a-modal title="Internal Document ID" :visible="modalInternalDocumentId"
                    @cancel="handleCancel">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template>
                <b>Document Id: </b> {{this.documentId}}
            </a-modal>


            <!-- Header -->
            <div class="row mt-2">
                <div class="col">
                    <div class="card shadow">
                        <!-- doc type with id and document status -->
                        <div class="card-header px-4 py-3 bg-transparent">
                            <div class="row px-3">
                                <h6 v-if='documentNumber!=undefined && documentNumber!=0' class="heading-small p-0 m-0"> {{ friendlyCodeAndDocumentNo }} <br> {{ friendlyOriginDocumentNo }}</h6>
                                <h6 v-else class="heading-small"> Create {{currentDocumentTypeName}} </h6>
                                <div class="col d-flex justify-content-end">
                                    <h6 class="heading-small p-0 m-0 mr-2"> {{documentStatus}} </h6> <i :class="headerStatusIcon"></i>
                                </div>
                            </div>

                        </div>

                        <!-- document name and fields -->
                        <div class="card-body mx-4">
                            <!-- header label -->
                            <div class="row">
                                <div class="col p-0"><h3 class='font-weight-bold'>{{currentDocumentTypeName}} Header</h3></div>
                                <div class="col-auto p-0 mr-2 float-right">
                                    <a-tooltip placement="top" :title="currencyRateLabel" v-if="currentDocumentTypeCode !== 'OTHPWS'">
                                        <a-select 
                                            size="small"
                                            labelInValue
                                            :value="currency"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchCurrencies"
                                            @change="selectCurrency"
                                            :disabled="documentStatus == 'Posted' ? true : false"
                                            :notFoundContent="fetching ? undefined : null"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="c in currencies" :key="'currencies'+c.id.toString()">{{c.name}}</a-select-option>
                                        </a-select>
                                    </a-tooltip>
                                </div>
                                <div v-if='header.showDocumentHeader && showTradeToggle' class="col-auto p-0 float-right">
                                    <a-popconfirm title="This action will clear all document lines?"
                                        ok-text="Continue"
                                        cancel-text="Cancel"
                                        @confirm="toggleDocumentTrade"
                                        :disabled="isTradeToggleDisabled"
                                    >
                                        <a-switch :checked='isDocumentTrade' checked-children="Trade Items" un-checked-children="Non-Trade Items" :disabled="isTradeToggleDisabled"/>
                                    </a-popconfirm>
                                </div>
                                <div class="col-auto p-0 float-right">
                                  <a v-if="!isEditing"
                                     class="refresh-document"
                                     href="#"
                                     @click.prevent="refreshDocument">
                                    <label><a-icon type="reload" /></label>
                                  </a>
                                  <a-popconfirm
                                    v-else
                                    class="refresh-document"
                                    title="This action will reload the current Document. Any unsaved changes will be removed. Do you want to continue?"
                                    ok-text="Yes"
                                    cancel-text="Cancel"
                                    @confirm="refreshDocument">
                                    <label><a-icon type="reload" /></label>
                                  </a-popconfirm>
                                </div>
                            </div>

                            <!-- header fields -->
                            <div class="row mt-2">

                                <!-- Supplying Branch -->
                                <div v-if='header.showSupplyingSite' class="col mr-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Supplying Branch</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                        labelInValue
                                        showSearch
                                        :value="supplyingSite"
                                        placeholder="Select a supplying site"
                                        style="width: 100%"
                                        :filterOption="filterOption"
                                        @dropdownVisibleChange="fetchSites"
                                        @change="selectSupplyingSite"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled='isSupplyingSiteDisabled'
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sites" :key="'sites'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Supplier -->
                                <div v-if='header.showSupplier' class="col mr-1">
                                    <div class="row">
                                        <div v-if='header.showRecevingReport' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Receving Report No</h4></div>
                                        <div class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Supplier</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <template>
                                            <a-modal
                                                title="Changing Supplier"
                                                :visible="showChangeSupplierModal"
                                                :confirm-loading="confirmLoadingonSuppModal"
                                                @ok="changeCostBySupplier"
                                                @cancel="showChangeSupplierModal = false"
                                                >
                                                <p>Changing supplier will automatically change cost of all items below. Do you want to change the supplier</p>
                                                </a-modal>
                                        </template>

                                          <!-- /barter-11/bxi-backend/-/issues/2252 -->
                                          <!-- Created a pop-up modal for clearing document line -->
                                        <template>
                                            <a-modal
                                                :title="popUpModal.message"
                                                :visible="popUpModal.isVisible"
                                                @ok="popUpModal.initializeProcess"
                                                @cancel="popUpModal.isVisible = false"
                                                :cancelButtonProps="{ style: { display: popUpModal.isAutoPopulate ? 'none': null }}"
                                                :closable="false"
                                                >
                                                <p>{{popUpModal.text}}</p>
                                                </a-modal>
                                            <a-modal
                                                title="Adding Item(s)"
                                                :visible="showAddingProgress.isVisible"
                                                :closable="false"
                                                :footer="null"
                                                >
                                                <p>{{`${showAddingProgress.productAdded} out of ${showAddingProgress.productCount}`}}</p>
                                                
                                                <a-progress :percent="showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0" size="small" />
                                                <!-- <p>{{`${showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0}% Completed`}}</p> -->
                                                <!-- <button @click.prevent="showAddingProgress.isVisible = false"  class="btn btn-sm btn-dark"> Stop</button> -->
                                                </a-modal>
                                        </template>

                                       <div v-if='header.showRecevingReport' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='receivingReport' placeholder="Receiving Report Number" :disabled='isRecevingReportDisabled'/>
                                        </div>
                                        <div class="col p-0 pr-2">
                                            <a-auto-complete ref="supplierAutoCompleteInput"
                                                style="width: 100%"
                                                placeholder="Search supplier"
                                                @select="selectSupplier"
                                                :value="supplier.label"
                                                @search="fetchSuppliers"
                                                @focus="fetchSuppliers"
                                                @blur="showSupplierModal"
                                                :disabled='isSupplierDisabled'
                                                :allowClear='true'
                                            >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="s in suppliers" :key="'selectSupplier'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                </template>
                                            </a-auto-complete>

                                        </div>
                                        <div class="col-auto p-0" v-if="showSupplierOptions && supplier.key > 0 || currentDocumentTypeCode =='ORIPOX' || currentDocumentTypeCode =='OTHPWS' ">
                                            <a-dropdown>
                                                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                <i class="fa fa-ellipsis-v btn-sm"> </i>
                                                </a>
                                                <a-menu slot="overlay">
                                                <a-menu-item key="1">
                                                    <!-- <a class="btn btn-success btn-sm text-white">Open</a> -->
                                                    <a v-if="supplier.key > 0 || currentDocumentTypeCode=='ORIPOX' || currentDocumentTypeCode=='OTHPWS'" type="button" class="float-right btn btn-light btn-sm" @click.prevent="checkDocumentLine">Auto Populate Products By Supplier</a>
                                                </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </div>
                                    </div>
                                </div>

                                <!-- For this Site -->
                                <div v-if='header.showForThisSite' class="col ml-1">
                                    <div class="row">
                                        <h4 class="btn-blockheading-small font-weight-normal">For This Site </h4>
                                        <div v-if="showApplyDocumentToOtherSitesButton()"
                                             class="float-right"
                                             style="flex-grow: 1">
                                            <button type="primary"
                                                      class="btn float-right ml-1 btn-primary btn-sm"
                                                      @click.prevent="toggleApplyDocumentToOtherSitesDrawer(true)">
                                                Apply Document to Other Sites
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <a-select
                                            labelInValue
                                            :value="forThisSite"
                                            placeholder="Select a site"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchForThisSites"
                                            @change="selectForThisSite"
                                            :disabled='isForThisSiteDisabled'
                                            :notFoundContent="fetching ? undefined : null"
                                            >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in forThisSites" :key="'forThisSites'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Revenue Branch -->
                                <div v-if='header.showRevenue' class="col ml-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Revenue Crediting</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                            v-model="revenue"
                                            placeholder="Select a Revenue site"
                                            style="width: 100%"
                                            @change="selectRevenue"
                                            :filterOption="filterOption"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="isRevenueDisabled"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in revenueOption" :key="s.key">{{s.value}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Requesting Branch -->
                                <div v-if='header.showRequestingSite' class="col ml-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">{{RequestingLabel}} Branch</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                            showSearch
                                            labelInValue
                                            :value="requestingSite"
                                            :placeholder="'Select a '+RequestingLabel+' site'"
                                            style="width: 100%"
                                            :filterOption="filterOption"
                                            @dropdownVisibleChange="fetchSites"
                                            @change="selectRequestingSite"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="isRequestingSiteDisabled"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sites" :key="'selectRequestingSite'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <!-- Party -->
                                <div v-if='header.showParty' class="col">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Party</h4></div>
                                    <div class="row mt-2">
                                        <a-input style="width: 100%" v-model='party' placeholder="Party" :disabled='isPartyDisabled'/>
                                    </div>
                                </div>

                                <!-- Sublocation -->
                                <div v-if='header.showSublocation' class="col">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Sublocation</h4></div>
                                    <div class="row mt-2">

                                        <a-select
                                        labelInValue
                                        :value="siteSublocation"
                                        placeholder="Select a sublocation"
                                        style="width: 100%"
                                        :filterOption="false"
                                        @dropdownVisibleChange="fetchPcountSublocations"
                                        @change="selectSiteSublocation"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled='isSiteSublocationDisabled'
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sublocations" :key="'sublocations'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>


                                    </div>
                                </div>

                                <!-- SO DD SI -->
                                <div v-if='header.showSublocationHeader' class="col mr-1">

                                    <!-- Label and Input, Site -->
                                    <div v-if='header.showSublocationSite' class="row">
                                        <div v-if='header.showSalesOrder' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Sales Order No</h4></div>
                                        <div v-if='header.showDeliveryDocument' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Delivery Document No</h4></div>
                                        <div v-if='header.showSublocationSite' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Site Name</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <div v-if='header.showSalesOrder' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='salesOrder' placeholder="Sales Order Number" :disabled='isSalesOrderDisabled'/>
                                        </div>
                                        <div v-if='header.showDeliveryDocument' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='deliveryDocument' placeholder="Delivery Document Number" :disabled='isDeliveryDocumentDisabled'/>
                                        </div>
                                        <div v-if='header.showSublocationSite' class="col p-0 mr-1">
                                            <a-auto-complete
                                                style="width: 100%"
                                                placeholder="Search site"
                                                :filter-option="autocompleteFilterOption"
                                                @select="selectDistributionSite"
                                                :value="distributionSite.label"
                                                @search="fetchDistributionSites"
                                                @focus="fetchDistributionSites"
                                                :disabled='isDistributionSiteDisabled'
                                                :allowClear='true'
                                            >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="s in sites" :key="'sites1'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                </template>
                                            </a-auto-complete>
                                        </div>
                                    </div>

                                    <!-- Label and Input, Site -->
                                    <div class="row mt-2">
                                        <div v-if='header.showOrderSource' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Order Source</h4></div>
                                        <div v-if='header.showSublocationOrigin' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationOriginLabel}}</h4></div>
                                        <div v-if='header.showSublocationDestination' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationDestinationLabel}}</h4></div>
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Name</h4></div>
                                        <div v-if='header.showSalesman' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Salesman Name</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <!-- Order Source -->
                                        <div v-if='header.showOrderSource' class="col p-0 mr-1">
                                            <a-select v-model='orderSource' placeholder='Order Source' style="width: 100%;" input-classes="form-control" :disabled="isOrderSourceDisabled">
                                                <a-select-option v-for="s in orderSources" :key="s.toString()">{{s}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Sublocation Origin -->
                                        <div v-if='header.showSublocationOrigin' class="col p-0 mr-1">
                                            <a-select
                                            labelInValue
                                            :value="originSublocation"
                                            placeholder="Select a sublocation"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchSublocations"
                                            @change="selectOriginSublocation"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isOriginSublocationDisabled'
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in sublocations" :key="'sublocations1'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Sublocation Destination -->
                                        <div v-if='header.showSublocationDestination' class="col p-0 mr-1">
                                            <a-select
                                            labelInValue
                                            :value="destinationSublocation"
                                            placeholder="Select a sublocation"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchSublocations"
                                            @change="selectDestinationSublocation"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isDestinationSublocationDisabled'
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in sublocations" :key="'sublocations2'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Customer -->
                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input-group compact>
                                                <a-auto-complete
                                                    style="width: 90%"
                                                    placeholder="Search customer"
                                                    :filter-option="autocompleteFilterOption"
                                                    @select="selectCustomer"
                                                    :value="customer.label"
                                                    @search="fetchCustomers"
                                                    @focus="fetchCustomers"
                                                    :disabled='isCustomerDisabled'
                                                >
                                                    <template slot="dataSource">
                                                        <a-select-option v-for="c in customers" :key="'customers'+c.id.toString()" :text="c.name">{{c.name}}</a-select-option>
                                                    </template>
                                                </a-auto-complete>

                                                <a-button style="width: 10%" @click.prevent="createCustomer()" :disabled="isCustomerCreateDisabled">
                                                    <a-icon style="margin-bottom: 3px" type="plus-circle" />
                                                </a-button>

                                            </a-input-group>


                                        </div>
                                        <!-- Salesman -->
                                        <div v-if='header.showSalesman' class="col p-0 mr-1">
                                            <a-input-group compact>
                                                <a-auto-complete
                                                    style="width: 90%"
                                                    placeholder="Search salesman"
                                                    :filter-option="autocompleteFilterOption"
                                                    @select="selectSalesman"
                                                    :value="salesman.label"
                                                    @search="fetchSalesmen"
                                                    @focus="fetchSalesmen"
                                                    :disabled='isSalesmanDisabled'
                                                >
                                                    <template slot="dataSource">
                                                        <a-select-option v-for="s in salesmen" :key="'salesman'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                    </template>
                                                </a-auto-complete>
                                            </a-input-group>
                                        </div>
                                    </div>

                                     <!-- Label and Input, Customer Address -->
                                    <div class="row mt-2">
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Address</h4></div>
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Contact</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='customerAddress' placeholder="Customer Address" :disabled='true'/>
                                        </div>

                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input-group compact>
                                                <a-select v-model="selectedCustomerContact" @select="selectCustomerContact" style="width: 30%">
                                                    <a-select-option value="Telephone">Telephone</a-select-option>
                                                    <a-select-option value="Mobile">Mobile</a-select-option>
                                                    <a-select-option value="Fax">Fax</a-select-option>
                                                    <a-select-option value="Email">Email</a-select-option>
                                                </a-select>
                                                <a-input style="width: 70%" v-model='activeCustomerContact' placeholder="Customer Contact" :disabled='true'/>
                                            </a-input-group>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Additional Options, when header with record is Posted -->
                            <div v-if='documentStatus=="Posted"' class="row mt-2">
                                <div class="col p-0">
                                    <h6 class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                    <a-date-picker v-model='documentDate' @change="disabledDate" placeholder="Document Date" style="width: 100%" :disabled='true'/>
                                </div>
                                <div v-if="showTargetDate" class="col p-0 mx-2">
                                    <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                    <h6 v-else class="heading-small text-muted">Target Date</h6>
                                    <a-date-picker v-model='targetDate' placeholder="Target Date" style="width: 100%" :disabled='true'/>
                                </div>
                                <div v-if="showCancellationDate" class="col p-0">
                                    <h6 class="heading-small text-muted">Cancellation Date</h6>
                                    <a-date-picker v-model='cancellationDate' placeholder="Cancellation Date" style="width: 100%" :disabled='true'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Body -->
            <div v-if='isHeaderOnly == false'>
                <div v-if='showDocumentBodyHeader'>
                    <div v-if="documentStatus=='Saved' || documentStatus=='Upload Error'" class='mt-4'>
                        <base-dropdown class='' hidden>
                            <base-button slot="title" type="danger" class="dropdown-toggle btn-sm">
                                {{productFormMode}} Product
                            </base-button>
                            <a v-for="productFormMode in productFormModeOptions" :key="'productFormModeOptions'+productFormMode.value" :value="productFormMode.value" class="dropdown-item" href="#" @click.prevent="changeProductFormMode(productFormMode.value)">{{productFormMode.label}}</a>
                        </base-dropdown>
                    </div>
                    <div v-else>
                            <h3 class='font-weight-bold mt-4'>{{productFormMode}} Products</h3>
                    </div>
                </div>
                <div v-else>
                    <h3 v-if="currentDocumentTypeCode=='OTHCNS'" class='font-weight-bold mt-4'>Physical Documents </h3>
                    <h3 v-else class='font-weight-bold mt-4'>Products </h3>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <div class="card shadow">
                            <div v-if='showDocumentBodyHeader'>
                                <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton' class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                    <div class="row mb-2">
                                        <div class="col-auto">
                                            <base-dropdown  v-model="formattedsearchFilter" >
                                                <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('barcode')">Barcode</a>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('name')">Name</a>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('stock_no')">Stock</a>
                                                <!-- <a class="dropdown-item" @click.prevent="changeSearchFilter('code')">Code</a> -->
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('reference_code')">Reference Code</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-5">
                                            <!-- <form v-on:submit.prevent="onEnterScanner"> -->
                                                <autocomplete
                                                    ref="autocomplete"
                                                    :placeholder="placeholder"
                                                    :source="productEndpoint"
                                                    input-class="form-control"
                                                    :resultsFormatter='filterExistingProducts'
                                                    results-property="data"
                                                    :results-display="formattedDisplay"
                                                    :request-headers="authHeaders"
                                                    @selected="getProduct"
                                                    @clear="clearProduct"
                                                    :disableInput='isProductSearchDisabled'
                                                    v-on:keyup.native.enter="onEnterScanner">
                                                </autocomplete>
                                            <!-- </form> -->
                                        </div>

                                        <div class="col">
                                            <a-input addonBefore="Product Name" size="large" v-model="productName" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                        </div>
                                        <div v-if='showFilteredBySupplier' class="col-auto pt-2 float-right">
                                            <a-checkbox :v-model='filteredBySupplier' @change='filteredBySupplierChange'>Filtered by supplier</a-checkbox>
                                        </div>
                                        <div v-else class="col-auto pt-2 float-right px-0">
                                            <base-dropdown class="nav-link float-right" position="right">
                                                <div class="media align-items-center" slot="title">
                                                <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                                </div>
                                                <template>
                                                    <div class="dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <a v-if="((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null" class="dropdown-item" @click.prevent="showDrawer('massAdd')">
                                                        <i class="fa fa-upload"></i>
                                                        <span>Import</span>
                                                    </a>
                                                    <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                        <i class="fa fa-upload"></i>
                                                        <span>Import With Allocation</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportCsvDocument()">
                                                        <i class="fas fa-file-csv"></i>
                                                        <span>Export CSV</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportExcelDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export Excel Sheet</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export With Allocation</span>
                                                    </a>

                                                    <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                        <i class="fas fa-bars"></i>
                                                        <span>Customize List</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="showSortDrawer('sort')">
                                                        <i class="fas fa-sort"></i>
                                                        <span>Sort</span>
                                                    </a>
                                                    <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                        <i class="fas fa-sync-alt"></i>
                                                        <span>Refresh Inventory</span>
                                                    </a>

                                                </template>
                                            </base-dropdown>
                                        </div>
                                    </div>
                                    <div class="row pt-2">
                                        <div v-if='showQuantity' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Quantity</h6>
                                            <a-input v-model='quantity' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled"/>
                                        </div>
                                        <div v-if='showActualYield' class="col">
                                            <a-tooltip>
                                                <template slot="title">
                                                    Tolerance Quantity: {{tolerance_quantity}}
                                                </template>
                                                <h6 class="heading-small text-muted text-nowrap">Actual Yield Quantity</h6>
                                                <a-input v-model='actual_yield' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled"/>
                                            </a-tooltip>
                                        </div>
                                        <div class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Unit</h6>
                                            <a-select
                                                labelInValue
                                                :value="productComposition"
                                                style="width: 100%;"
                                                :filterOption="false"
                                                @dropdownVisibleChange="fetchProductCompositions"
                                                @change="selectProductComposition"
                                                :notFoundContent="fetching ? undefined : null"
                                                :disabled="isDocumentLineFormDisabled"
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in productCompositions" :key="'productCompositions'+s.key.toString()">{{s.label}}</a-select-option>
                                            </a-select>
                                        </div>

                                        <template v-if='showPwsCosts'>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Ordering</h6>
                                                <a-input min='0' v-model='oldOrdering' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Landed</h6>
                                                <a-input min='0' v-model='oldLanded' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Price</h6>
                                                <a-input min='0' v-model='oldRetailPrice' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Ordering</h6>
                                                <a-input min='0' v-model='newOrdering' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Landed</h6>
                                                <a-input min='0' v-model='newLanded' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newLanded')" :disabled="isDocumentLineFormDisabled"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Price</h6>
                                                <a-input min='0' v-model='newRetailPrice' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newPrice')" :disabled="isDocumentLineFormDisabled"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Mark Up %</h6>
                                                <a-input min='0' v-model='markUp' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('markUp')" :disabled="isDocumentLineFormDisabled"/>
                                            </div>
                                        </template>

                                        <div v-if='showUnitCost' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">{{productPriceChoice.split('_').pop()}}</h6>
                                            <a-input min='0' v-model='unitCost' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculateSelectedProduct; costUpdated = true" :disabled="isUnitCostDisabled()"/>
                                        </div>
                                        <div v-if='showDiscount' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Discount</h6>
                                            <a-select mode="tags" :maxTagCount='1'  maxTagPlaceholder='...' v-model='discountText' style="width: 100%;" @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled"></a-select>
                                        </div>
                                        <div v-if='showUnitNetCost' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Unit Net Price</h6>
                                            <a-input v-model='unitNetCost' input-classes="form-control" disabled/>
                                        </div>
                                        <div v-if='showSubtotal' class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                            <span class="mr-auto font-weight-bold h3 ">Subtotal: {{subTotal}}</span>
                                        </div>

                                        <div class="col d-flex align-items-end" v-if="selectedDocumentLines && selectedDocumentLines.length > 0 && productName == ''">
                                            <base-dropdown v-if="selectedDocumentLines.length == 1" class="nav-link pr-2 float-right" position="right">
                                                <div class="media align-items-center" slot="title">
                                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: black;'></i>
                                                </div>
                                                <template>
                                                    <div class="dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <div class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                         <i class="fas fa-layer-group"></i>
                                                        <span>View Stock Card</span>
                                                    </div>
                                                    <div v-if="selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>Enter/View Serial Number</span>
                                                    </div>
                                                    <div v-if='allowSublocationAllocation' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Sublocation Allocation</span>
                                                    </div>
                                                    <div v-if='allowSiteAllocation' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Site Allocation</span>
                                                    </div>
                                                    <div v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                        <i class="fas fa-hourglass-end"></i>
                                                        <span>Lot Code and Expiry</span>
                                                    </div>
                                                </template>
                                            </base-dropdown>
                                            <button type="button" class="btn btn-danger btn-block align-bottom" @click="mass_delete_line()" >Delete</button>
                                        </div>
                                        <div class="col d-flex align-items-end" v-else>
                                            <a-popconfirm
                                                title="Input quantity is more than the available quantity, do you want to proceed?"
                                                :visible="addProductConfirmationVisible"
                                                ok-text="Yes"
                                                cancel-text="Cancel"
                                                @visibleChange="handleAddProductVisibleChange"
                                                @confirm="addProduct"
                                                @cancel="addProductCancel"
                                                :disabled="isDocumentLineFormDisabled"
                                            >
                                                <a type="button" class="btn btn-primary btn-block align-bottom text-white mt-2">+ Add Product</a>
                                            </a-popconfirm>
                                        </div>
                                    </div>

                                    <div v-if="rewardCode != null" class="row mt-3">
                                        <div class="col-auto float-right">
                                            <small><span class="fa fa-info-circle text-blue"/> &nbsp; Promo Applied - {{promoName}} ({{rewardCode}})</small>
                                        </div>
                                    </div>

                                </div>
                                <div v-else class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                    <div class="row">
                                        <div class="col">
                                            <a-input-search size='large' v-on:keyup="searchProducts" @search="searchProducts" :placeholder="placeholder" v-model='productSearchInput'>
                                                <a-select slot="addonBefore" defaultValue="Barcode" @select="changeSearchFilter">
                                                    <a-select-option value='barcode'>Barcode</a-select-option>
                                                    <a-select-option value='product_name'>Name</a-select-option>
                                                    <a-select-option value='stock_no'>Stock No</a-select-option>
                                                    <a-select-option value='ref_code'>Ref Code</a-select-option>
                                                    <!-- <a-select-option value='product_id'>Code</a-select-option> -->
                                                </a-select>
                                            </a-input-search>
                                        </div>

                                        <div class="col-auto d-flex align-items-end justify-content-end p-0" >
                                            <base-dropdown  class="nav-link pr-2 float-right" position="right">
                                                <div class="media align-items-center" slot="title">
                                                <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                                </div>
                                                <template>
                                                    <div class="dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <a v-if="selectedDocumentLines.length == 1" class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>View Stock Card</span>
                                                    </a>
                                                    <a v-if="selectedDocumentLines.length == 1 && selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>Enter/View Serial Number</span>
                                                    </a>
                                                    <a v-if='allowSublocationAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Sublocation Allocation</span>
                                                    </a>
                                                    <div v-if='allowSiteAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Site Allocation</span>
                                                    </div>
                                                    <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                        <i class="fa fa-upload"></i>
                                                        <span>Import With Allocation</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportCsvDocument()">
                                                        <i class="fas fa-file-csv"></i>
                                                        <span>Export CSV</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportExcelDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export Excel Sheet</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export With Allocation</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                        <i class="fas fa-bars"></i>
                                                        <span>Customize List</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="showSortDrawer()">
                                                        <i class="fas fa-sort"></i>
                                                        <span>Sort</span>
                                                    </a>
                                                    <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                        <i class="fas fa-sync-alt"></i>
                                                        <span>Refresh Inventory</span>
                                                    </a>
                                                    <a v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                        <i class="fas fa-hourglass-end"></i>
                                                        <span>Lot Code and Expiry</span>
                                                    </a>
                                                </template>
                                            </base-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentDocumentTypeCode=='OTHCNS' && documentStatus!='Posted' &&  documentStatus!='Voided'" class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                <div class="row mb-2">
                                    <div class="col-auto">
                                        <base-dropdown  v-model="formattedsearchFilter" >
                                            <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('document_no')">Document No</a>
                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('document_id')">Document ID</a>
                                        </base-dropdown>
                                    </div>
                                    <div class="col-4">
                                        <autocomplete
                                            ref="autocomplete"
                                            :placeholder="placeholder"
                                            :source="documentEndpoint"
                                            input-class="form-control"
                                            :resultsFormatter='filterExistingDocuments'
                                            results-property="data"
                                            :results-display="formattedDocumentDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getDocument"
                                            @clear="clearDocument">
                                        </autocomplete>
                                    </div>
                                    <div class="col">
                                        <a-input addonBefore="Document ID" size="large" v-model="documentID" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                    </div>
                                    <div class="col-auto" v-if="selectedDocumentLines && selectedDocumentLines.length > 0">
                                        <button type="button" class="btn btn-danger btn-block align-bottom" @click="mass_delete_document_line()" >Delete</button>
                                    </div>
                                    <div class="col-auto" v-else>
                                        <a-popconfirm
                                            title="are you sure?"
                                            :visible="addPCountDocumentConfirmationVisible"
                                            ok-text="Yes"
                                            cancel-text="Cancel"
                                            @visibleChange="handleAddDocumentVisibleChange"
                                            @confirm="addPCount"
                                            @cancel="addPCountCancel"
                                        >
                                            <a type="button" class="btn btn-primary btn-block align-bottom text-white">+ Add Physical Documents</a>
                                        </a-popconfirm>
                                    </div>
                                    <div class="col-auto pt-2 float-right px-0">
                                        <base-dropdown class="nav-link float-right" position="right">
                                            <div class="media align-items-center" slot="title">
                                            <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                            </div>
                                            <template>
                                                <div class="dropdown-header noti-title">
                                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                                </div>
                                                <a class="dropdown-item" @click="exportCsvDocument()">
                                                    <i class="fas fa-file-csv"></i>
                                                    <span>Export CSV</span>
                                                </a>
                                                <a class="dropdown-item" @click="exportExcelDocument()">
                                                    <i class="fas fa-file-excel"></i>
                                                    <span>Export Excel Sheet</span>
                                                </a>
                                                <div class="dropdown-item" v-if="selectedDocumentLines.length == 1 && selectedDocumentLines && selectedDocumentLines.length > 0" @click.prevent="showStockCard(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                    <span>View Document Lines</span>
                                                </div>
                                                <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                    <i class="fas fa-sync-alt"></i>
                                                    <span>Refresh Inventory</span>
                                                </a>
                                            </template>
                                        </base-dropdown>
                                    </div>
                                </div>
                            </div>

                            <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton' class="row mt-4 ml-2 mr-2">
                                <div class="col-auto">
                                    <base-dropdown v-model="formattedsearchFilterAddedProduct" >
                                        <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilterAddedProduct)}}</base-button>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('barcode')">Barcode</a>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('name')">Name</a>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('stock_no')">Stock</a>
                                        <!-- <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('code')">Code</a> -->
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('ref_code')">Reference Code</a>
                                    </base-dropdown>
                                </div>
                                <div class="col">
                                    <a-input-search size="large" v-on:keyup="searchAddedProducts" @search="searchAddedProducts" :placeholder="addedProductPlaceholder" v-model='addedProductSearchInput'/>
                                </div>
                            </div>

                            <div class="card-body" style="background: #FFFFFF; min-height: 40vh;">
                                <div class="table-responsive pt-2">
                                    <VueTabulator ref="tabulator"
                                                  v-model="data"
                                                  :options="options"
                                                  @cell-edited="tabulatorCellEdit"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Summary -->
            <h3 class='font-weight-bold mt-4'>Summary</h3>
            <div class="row mt-2">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body">


                            <div v-if='showTotalQuantity' class="row">
                                <div class="col">
                                    <span class="mr-auto h2 font-weight-bold">Total Quantity: {{totalQuantity}}</span>
                                </div>
                                <div v-if="showVatExclusiveCheckbox && showVatExclusiveCheckboxConfig" class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                    <a-checkbox :checked="vatExclusiveCheckbox" @change="toggleVatExclusive">Show price and discount exclusive of VAT</a-checkbox>
                                </div>
                            </div>

                            <hr v-if='showTotalQuantity' class='my-3'>

                            <div v-if='showSummaryCalculation && ((document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount) || currentDocumentTypeCode == "ORISOX")' class="row pb-1">
                                <div class="col" v-if="showHeaderDiscount">
                                    <h6 class="heading-small text-muted">Header Discount</h6>
                                    <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='headerDiscount' placeholder='Discount' style="width: 100%;" @change="onHeaderDiscountChange" input-classes="form-control" :disabled="isHeaderDiscountDisabled"></a-select>
                                </div>
                                <div class="col" v-if="showSupportDiscount">
                                    <h6 class="heading-small text-muted">Supports Discount</h6>
                                    <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='supportDiscount'  @change="onSupportDiscountChange" placeholder='Discount' style="width: 100%;" input-classes="form-control" :disabled="isSupportsDiscountDisabled"></a-select>
                                </div>
                            </div>

                            <div v-if='showSummaryCalculation' class="row pb-4">
                                <div class="col">
                                    <h6 class="heading-small text-muted">Gross Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (grossAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (grossAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='grossAmountDisplay' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Item Discount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (itemDiscount / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (itemDiscount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='itemDiscount' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col" v-if="document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount">
                                    <h6 class="heading-small text-muted">Overall Discount</h6>
                                    <a-input placeholder="0.00" v-model='overallDiscount' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Net Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='netAmountDisplay' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col" v-if='vatExclusiveCheckbox || displayVatAmount'>
                                    <h6 class="heading-small text-muted">VAT Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (vatAmount / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (vatAmount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                    <a-input placeholder="0.00" v-model='vatAmount' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col" v-if="displayNetAmountWOVat">
                                    <h6 class="heading-small text-muted">{{displayNetAmountWOVatLabel}}
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountWithoutTax / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountWithoutTax * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='netAmountWithoutTax' style="width: 100%" :disabled='true'/>
                                </div>
                                <div class="col" v-if='vatExclusiveCheckbox'>
                                    <h6 class="heading-small text-muted">Total with VAT
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (totalWithVat / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (totalWithVat * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                    <a-input placeholder="0.00" v-model='totalWithVat' style="width: 100%" :disabled='true'/>
                                </div>
                            </div>
                            <span v-if='documentStatus!="Posted"' class="h4 font-weight-bold">Document Date</span>
                            <div v-if='documentStatus!="Posted"' class="row pt-1">
                                <div class="col">
                                    <h6 class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                    <a-date-picker v-model='documentDate' @change="changeDate" placeholder="Document Date" style="width: 100%" :disabled='isDocumentDateDisabled'/>
                                </div>
                                <div v-if="showTargetDate" class="col">
                                    <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                    <h6 v-else class="heading-small text-muted">Target Date</h6>
                                    <a-date-picker v-model='targetDate' @change="()=>{isEditing = true}" placeholder="Target Date" style="width: 100%" :disabled='isTargetDateDisabled'/>
                                </div>
                                <div v-if="showCancellationDate" class="col">
                                    <h6 class="heading-small text-muted">Cancellation Date</h6>
                                    <a-date-picker v-model='cancellationDate' @change="()=>{isEditing = true}" placeholder="Cancellation Date" style="width: 100%" :disabled='isCancellationDateDisabled'/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' >
                    Advanced Information {{showAdvancedInfo? '↟' : '↡'}}
                </button>
            </div>

            <h3 v-if='showAdvancedInfo' class='font-weight-bold'>Advanced Info</h3>
            <div v-if='showAdvancedInfo' class="row mt-2 advanced-info">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body">
                            <div class="row pb-4">
                                <div class="col" v-if="document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount">
                                    <h6 class="heading-small text-muted">Terms</h6>
                                    <a-select
                                            labelInValue
                                            :value="paymentTerm"
                                            placeholder="Select a payment term"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPaymentTerms"
                                            @change="selectPaymentTerm"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isPaymentTermDisabled'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in paymentTerms" :key="'paymentTerms'+s.id.toString()">{{s.days}}</a-select-option>
                                    </a-select>
                                </div>

                                <div class="col" v-if="showShippingMethod">
                                    <h6 class="heading-small text-muted">Shipping Method</h6>
                                    <a-select
                                            labelInValue
                                            :value="shippingMethod"
                                            placeholder="Select a shipping method"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchShippingMethods"
                                            @change="selectShippingMethod"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isShippingMethodDisabled'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in shippingMethods" :key="'shippingMethods'+s.id.toString()">{{s.name}}</a-select-option>
                                    </a-select>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Purpose</h6>
                                    <a-select
                                            labelInValue
                                            :value="purpose"
                                            placeholder="Select purpose"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPurposes"
                                            @change="selectPurpose"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isPurposeDisabled'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in purposes" :key="'purposes'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">{{referenceLabel}}</h6>
                                    <a-input style="width: 100%" @change="()=>{isEditing = true}" :maxLength="Number(50)" v-model='reference' placeholder="Reference" :disabled='isReferenceDisabled'/>
                                </div>
                            </div>
                            <div class="row pt-1">
                                <div class="col">
                                    <h6 class="heading-small text-muted">{{remarkLabel}}</h6>
                                    <a-input style="width: 100%" :maxLength="Number(255)" v-model='remark' placeholder="Remark">
                                        <a v-if='documentNumber > 0' slot="addonAfter" @click='saveRemark()' class="heading-small text-muted">Save</a>
                                    </a-input>
                                </div>
                            </div>
                        </div>

                        <div class="card-body pt-0" v-if='showChargesTable'>
                            <div class="row pb-2">
                                <div class="col ">
                                    <h6 class="heading-small text-muted">Charges</h6>
                                </div>
                                <div class="col-2 d-flex align-items-end" v-if="chargeSelectedRowKeys && chargeSelectedRowKeys.length > 0">
                                    <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()" :disabled="documentStatus == 'Voided'" >Delete Charge</button>
                                </div>
                                <div class="col-2 d-flex align-items-end">
                                    <button type="button" class="btn btn-primary btn-sm btn-block align-bottom" @click="showDrawer('charges')" :disabled='isAddChargeDisabled'>Add Charge</button>
                                </div>
                            </div>
                            <a-table :rowSelection="chargeRowSelection" rowKey='line_no' :columns="chargeColumns" :dataSource="chargeData" :pagination="false" size="small"></a-table>

                            <a-drawer
                                :width="480"
                                placement="right"
                                @close="closeDrawer('charges')"
                                :visible="chargeDrawerVisible"
                            >
                                <h6 class="heading-small text-muted mb-4 text-truncate">Add Charge</h6>
                                <form>
                                <base-input label="Description" placeholder="" v-model="chargeDescription" input-classes="form-control" />
                                <base-input label="Charge Type">
                                    <select class="form-control" v-model="chargeType" @change='selectChargeType'>
                                        <option v-for="option in chargeTypeOptions" v-bind:key="'chargeTypeOptions'+option.key" v-bind:value="option.key">
                                            {{option.value}}
                                        </option>
                                    </select>
                                </base-input>
                                <base-input label="Weight (kg)" placeholder="" v-model="chargeWeight" input-classes="form-control" :disabled='isChargeWeightDisabled' @input='calculateChargeAmount'/>
                                <base-input label="Rate /kg" placeholder="" v-model="chargeRate" input-classes="form-control" :disabled='isChargeRateDisabled' @input='calculateChargeAmount'/>
                                <base-input label="Amount" placeholder="" v-model="chargeAmount" input-classes="form-control" :disabled='isChargeAmountDisabled' />
                                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                    <button type="button" class="btn btn-primary float-right" @click='addCharge()' >Add</button>
                                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('charges')">Close</button>
                                </div>
                                </form>
                            </a-drawer>
                        </div>
                    </div>
                </div>
            </div>
            <hr>

            <!-- Drawer for Payments -->
            <a-drawer :width="480" placement="right"  @close="closeDrawer('payments')" :visible="paymentDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Choose Payment Method</h6>
                <form>
                    <a-spin :spinning="spinning">
                        <base-alert v-if="paymentErrors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in paymentErrors" :key="error">{{ error }}</li>
                        </base-alert>

                        <base-input label="Payment Mode">
                            <base-radio name="paymaya" class="mb-3" v-model="paymentMode" value="paymaya">
                                Paymaya
                            </base-radio>
                            <base-radio name="dragonpay" class="mb-3" v-model="paymentMode" value="dragonpay">
                                Dragonpay
                            </base-radio>

                            <base-input v-if="paymentMode == 'dragonpay'" label="Payment Method">
                                <br/>
                                <a-select showSearch style="width: 100%" placeholder="Please select payment method" optionFilterProp="children"  v-model="paymentMethod">
                                    <a-select-option v-for="option in paymentMethods" :key="'paymentMethods'+option.procId" :value="option.procId">{{option.shortName}}</a-select-option>
                                </a-select>
                            </base-input>


                            <base-radio name="bank" class="mb-3" v-model="paymentMode" value="bank">
                                Bank Transfer
                            </base-radio>

                            <base-input v-if="paymentMode == 'bank'" label="Reference Number">
                                <br/>
                                <a-input style="width: 100%" v-model='bankTransferReference' placeholder="Reference Number" />
                            </base-input>
                        </base-input>
                    </a-spin>
                    <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click='pay(documentNumber)' >
                            <span v-if="paymentMode == 'bank'">Confirm</span>
                            <span v-else>Send Link</span>
                        </button>
                        <!-- @click="closeDrawer('payments')" -->
                        <button v-if="currentDocumentTypeCode != 'OTHSIN'" type="button" class="btn btn-danger float-right mr-2" @click="payLater()">Proceed Without Payment</button>
                    </div>
                </form>

            </a-drawer>

            <!-- Drawer for Initail Deposit -->
            <a-drawer :width="480" placement="right"  @close="closeDrawer('initialDeposit')" :visible="initialDepositDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Initial Deposit</h6>
                <form>
                    <a-spin :spinning="spinning">
                        <base-alert v-if="initialDepositErrors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in initialDepositErrors" :key="error">{{ error }}</li>
                        </base-alert>
                        <base-input label="Amount">
                            <a-input-number v-model="initialDeposit.amount" :min="1" step=".01" :max="Number(grossAmountDisplay)" style="width: 100%" input-classes="form-control" />
                        </base-input>
                        <base-input label="Reference" placeholder="" v-model="initialDeposit.reference" input-classes="form-control"/>
                    </a-spin>
                    <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click='payInitialDeposit(documentNumber)' >
                            <span>Confirm</span>
                        </button>
                        <!-- @click="closeDrawer('payments')" -->
                    </div>
                </form>
            </a-drawer>

            <!-- Drawer for Applying Document to Other Sites -->
            <DocumentApplyToOtherSitesDrawer
              :documentNumber="this.documentNumber"
              :currentDocumentSite="this.forThisSite"
              :showDrawer="applyDocumentToOtherSitesDrawer"
              @closeDrawer="toggleApplyDocumentToOtherSitesDrawer"
              @notification="(args) => $notification[args.type]({ message: args.msg.message, description: args.msg.description, style: getNotificationStyle(args.type) })"/>

            <!-- Drawer for Booking -->
            <a-modal
               title="Recompute Needed"
               :visible="recomputeModal"
               okText="Yes"
               cancelText="Recompute"
               @ok="bookingProper"
               @cancel="recomputeBooking"
             >
                There was a change on the destination point. Do you want to proceed with the original destination point?
            </a-modal>
            <a-drawer  v-if="bookingDrawerVisible" :width="1000" placement="right"  @close="closeDrawer('booking')" :visible="bookingDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Booking Details</h6>


                <div v-if="activeBooking">
                    <a-card v-if="bookingDetails.order != undefined" title="Booking Details">
                        <a-card-grid style="width:50%;text-align:center">
                          <small>Amount</small>
                          <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                        </a-card-grid>
                        <a-card-grid style="width:50%;text-align:center" :hoverable="false">
                         <small>Status</small>
                         <h3>{{bookingDetails.order.status_description}}</h3>
                        </a-card-grid>
                    </a-card>
                </div>
                <div v-else>
                    <a-card v-if="bookingDetails.order != undefined" title="Booking Amount">
                        <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                    </a-card>
                </div>
                <!-- <a v-if="addressEditMode == false" href="#" @click.prevent="addressEditMode = true"><small>Edit</small></a>
                <a v-else href="#" @click.prevent="addressEditMode = false"><small>Save</small></a> -->

                <form class="row mt-3" style="overflow: scroll;">

                <div class="col-md-4">
                    <a-steps progress-dot :current="2" direction="vertical">
                      <a-step title="Pickup Address" :description="siteAddress"/>
                      <a-step title="Destination Address" :description="customerAddress" />
                    </a-steps>
                </div>

                <!-- <GmapMarker ref="myMarker" :position="google && new google.maps.LatLng(1.38, 103.8)" /> -->
                <div v-if="activeBooking" class="col-md-8">
                    <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                      <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                      <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                      <google-marker :position="markers[1].position" :draggable="false"></google-marker>
                    </google-map>
                    <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                </div>
                <div v-else class="col-md-8">
                    <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                      <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                      <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                      <google-marker :position="markers[1].position" :draggable="true" @dragend="handleDestinationChange" :key="mapKey"></google-marker>
                    </google-map>
                    <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                </div>

                <div class="mt-3 col-md-6">
                    <h5 class="navbar-heading text-muted">PICKUP CONTACT DETAILS</h5>
                    <!-- <base-input alternative="" label="Pickup Address" v-model="siteAddress" type="text" /> -->
                    <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Name" v-model="siteContactPerson" type="text"/>
                    <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Number" v-model="siteContactNumber" type="text"/>
                </div>

                <div class="mt-3 col-md-6">
                    <h5 class="navbar-heading text-muted">DESTINATION CONTACT DETAILS</h5>
                    <!-- <base-input alternative="" label="Destination Address" v-model="customerAddress" type="text" /> -->
                    <base-input :disabled="activeBooking" alternative="" label="Destination Contact Name" type="text" v-model="customer.label"/>
                    <base-input :disabled="activeBooking" alternative="" label="Destination Contact Number" type="text" v-model="customerContactMobile"/>
                </div>

                <br/>

                <div class="mt-3 col-md-12">
                    <base-input label="Vehicle Type">
                        <base-radio name="8" class="mb-3" v-model="deliveryMode" value="8" :disabled="activeBooking">
                            Motor Bike
                        </base-radio>
                        <base-radio name="7" class="mb-3" v-model="deliveryMode" value="7" :disabled="activeBooking">
                            Car
                        </base-radio>
                    </base-input>
                    <br/> <br/><br/>
                </div>



                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="activeBooking == true && bookingDetails.order.status == 'new'" type="button" class="btn btn-warning float-right" @click.prevent="cancelBooking()">Cancel Booking</button>
                    <button v-if="activeBooking == false" type="button" class="btn btn-success float-right" @click.prevent="proceedBooking()">Book</button>
                    <button v-if="activeBooking == false" type="button" class="btn btn-primary float-right" @click.prevent="recomputeBooking()">Recompute</button>
                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('booking')">Close</button>
                </div>
                </form>
            </a-drawer>

            <!-- Drawer for Document Action History -->
            <a-drawer :width="800" placement="right" @close="closeDrawer('history')" :visible="historyDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Action History</h6>
                <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('history')">Close</button>
                </div>
            </a-drawer>

            <!-- Drawer for Stock Card -->
            <stock-card v-if="selectedStockCardProduct != null" :product="selectedStockCardProduct" :key="'stockCard'+stockCardKey" :visible="stockCardVisible"></stock-card>

            <!-- Drawer for Customer Form -->
            <a-drawer title="" :width="1000" placement="right" @close="onClose" :visible="customerDrawerVisible">
                <customer-form :key="'CustomerForm'+customerDrawerKey" v-on:refreshPage="refreshPage" @closeDrawer="closeDrawer"></customer-form>
            </a-drawer>

            <!-- Drawer for Document Line Mass Add -->
            <a-drawer :width="480" placement="right" :key="'documentLineMassAdd'+massAddDrawerKey" @close="closeDrawer('massAdd')" :visible="massAddDrawerVisible">
                <h6 class="heading-small text-muted mb-4">Mass Add Products in Document Lines</h6>
                <base-alert v-if="massAddProductErrors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in massAddProductErrors" :key="error">{{ error }}</li>
                </base-alert>
                <base-alert v-if="massAddProductErrorsDL.length" type="info">
                    <b>Download list:</b>
                    <li v-if="dlDUplicateSkus == 1"><a href="#" @click="printDupSKUs">Duplicate Barcode/s</a></li>
                    <li v-if="dlSkusNotFound == 1"><a href="#" @click="printSKUsNotFound">Barcode/s not found</a></li>

                </base-alert>
                <div>
                    <a-spin tip="Validating CSV file" :spinning="spinning">
                        <label v-if="header.showSaveProductVia">
                            Save each product via:
                            <a-select
                                v-model="saveMassUploadProductVia"
                                style="width: 120px">
                                <a-select-option value="barcode">
                                    Barcode
                                </a-select-option>
                                <a-select-option value="stock_no">
                                    Stock No
                                </a-select-option>
                            </a-select>
                        </label>

                        <br><br>

                        <a-upload-dragger :before-upload="beforeUpload"
                            :remove="handleRemove"
                            :fileList="fileList"
                            :multiple="false" accept=".csv, .CSV">
                            <span class="fa fa-file-import" style="font: 20pt;" />
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                                 Upload your product list in a CSV file following the specified format.
                                 Please upload maximum of {{ maxLines }} lines per batch.
                                 You can download template below.
                            </p>
                        </a-upload-dragger>

                        <br><br>

                        <a-collapse>
                            <a-collapse-panel header="Templates" key="1">
                            <a-list bordered>
                                <a-list-item>
                                <a-list-item-meta description="Contains required data to create a document">
                                    <a @click.prevent="downloadTemplate('1')" slot="title">Download Basic Document Template</a>
                                </a-list-item-meta>
                                <div><a @click.prevent="downloadTemplate('1')"><span class="fa fa-file-download"/></a></div>
                                </a-list-item>
                            </a-list>
                            </a-collapse-panel>
                        </a-collapse>

                        <br><br>

                        <div class="row">
                            <div class="col-md-12">
                                <base-input label="Import Mode">
                                    <base-radio name="0" class="mb-3" v-model="importMode" value="O">
                                        Add-In
                                    </base-radio>
                                    <base-radio name="1" class="mb-3" v-model="importMode" value="1">
                                        Override
                                    </base-radio>
                                </base-input>
                            </div>
                        </div>

                    </a-spin>
                </div>
                <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="massAddProductErrors.length < 1 && csvData != '' && spinning == false" class="btn btn-primary float-right" @click.prevent="importFile">Import</button>
                </div>
            </a-drawer>

            <!-- Drawer for Document Line Mass Add with Allocation -->
            <a-drawer :width="480" placement="right" @close="closeDrawer('massAddWithAllocation')" :visible="massAddWithAllocationDrawerVisible">
                <h6 class="heading-small text-muted mb-4">Mass Add Products with Allocation in Document Lines</h6>
                <base-alert v-if="massAddWithAllocationProductErrors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in massAddWithAllocationProductErrors" :key="error">{{ error }}</li>
                </base-alert>
                <div>
                    <a-spin tip="Validating CSV file" :spinning="spinning">
                        <a-upload-dragger :before-upload="beforeUploadWithAllocation"
                            :remove="handleRemove"
                            :fileList="fileWithAllocationList"
                            :multiple="false" accept=".xlsx, .xls">
                            <span class="fa fa-file-import" style="font: 20pt;" />
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                                 Upload your product list in a CSV file following the specified format.
                                 Please upload maximum of {{ maxLines }} lines per batch.
                                 You can download template below.
                            </p>
                        </a-upload-dragger>
                    </a-spin>
                </div>
                <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="massAddWithAllocationProductErrors.length < 1 && spinning == false" class="btn btn-primary float-right" @click.prevent="importWithAllocationFile">Import</button>
                </div>
            </a-drawer>

            <!-- Drawer for Sublocation Allocation -->
            <a-drawer :width="520" placement="right" :key="'sublocationAllocation'+sublocationAllocationKey" @close="closeDrawer('sublocationAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="sublocationAllocationVisible">
                <h6 class="heading-small text-muted mb-4">{{selectedSublocationAllocationProduct.product_name}}</h6>
                <div>
                    <base-alert v-if="sublocationAllocationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in sublocationAllocationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col"><h4><b>Quantity: </b>{{selectedSublocationAllocationProduct.quantity}}</h4></div>
                        <div class="col"><h4><b>Remaining Quantity: </b> {{selectedSublocationAllocationProduct.quantity - drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0) }}</h4></div>
                    </div>

                    <hr class="mt-1 mb-2">

                    <div class="row">
                        <div class="col">Sublocation</div>
                        <div class="col">Sublocation Quantity</div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <a-select
                                labelInValue
                                :value="drawerSublocation"
                                placeholder="Select a sublocation"
                                style="width: 100%"
                                :filterOption="false"
                                @dropdownVisibleChange="fetchDrawerSublocations"
                                @change="selectDrawerSublocations"
                                :notFoundContent="fetching ? undefined : null"
                            >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="s in drawerSublocations" :key="'drawerSublocations'+s.id.toString()">{{s.name}}</a-select-option>
                            </a-select>
                        </div>
                        <div class="col">
                            <a-input v-model='drawerSublocationQuantity' placeholder="Sublocation Quantity" />
                        </div>
                    </div>

                    <div class="row mt-2 mx-1 mb-3">
                        <a-button @click='addDrawerSublocationQuantity' block>Add Sublocation Quantity</a-button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Sublocation</th>
                                    <th scope="col">Quantity</th>
                                    <th class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in drawerCurrentSublocationAllocation" v-bind:key="'drawerCurrentSublocationAllocation'+index">
                                    <td class="align-middle">{{ (drawerSublocations.find(x => x.id === parseInt(data.sublocation_id))) ? drawerSublocations.find(x => x.id === parseInt(data.sublocation_id)).name : "Invalid Data. Please Remove" }}</td>
                                    <td class="align-middle">{{data.quantity}}</td>
                                    <td class="text-center"><a-button size="small" @click="removeSublocationAllocation(index)">Remove</a-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSublocationAllocation' type="primary" block>Save</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- Drawer for Site Allocation -->
            <a-drawer :width="520" placement="right" :key="'siteAllocation'+siteAllocationKey" @close="closeDrawer('siteAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="siteAllocationVisible">
                <h6 class="heading-small text-muted mb-4">{{selectedSiteAllocationProduct.product_name}}</h6>
                <div>
                    <base-alert v-if="siteAllocationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in siteAllocationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col"><h4><b>Total Quantity: </b>{{selectedSiteAllocationProduct.quantity}}</h4></div>
                    </div>

                    <div class="row" v-if="currentDocumentTypeCode != 'OTHPCK'">
                        <div class="col">
                            <h4>
                                <b>Remaining Quantity: </b>
                                <span v-if="(siteAllocationRemainingQuantity!=null && siteAllocationRemainingQuantity!='') || siteAllocationRemainingQuantity==0">{{siteAllocationRemainingQuantity}}</span>
                                <span v-else>{{selectedSiteAllocationProduct.quantity}}</span>
                            </h4>
                        </div>
                    </div>

                    <hr class="mt-1 mb-2">

                    <div class="row">
                        <div class="col">Site</div>
                        <div class="col">Site Quantity</div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <a-select
                                labelInValue
                                show-search
                                :value="drawerSite"
                                placeholder="Select a site"
                                style="width: 100%"
                                :filterOption="false"
                                @dropdownVisibleChange="fetchDrawerSites"
                                @change="selectDrawerSites"
                                @search="handleSearchDrawerSites"
                                :notFoundContent="fetching ? undefined : null"
                            >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="s in drawerSites" :key="'drawerSites'+s.id.toString()">{{s.name}}</a-select-option>
                            </a-select>
                        </div>
                        <div class="col">
                            <a-input v-model='drawerSiteQuantity' placeholder="Site Quantity" />
                        </div>
                    </div>

                    <div class="row mt-2 mx-1 mb-3">
                        <a-button @click='addDrawerSiteQuantity' block>Add Site Quantity</a-button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Site</th>
                                    <th scope="col">Quantity Assigned</th>
                                    <th scope="col">Quantity Available</th>
                                    <th scope="col">On-Hand Quantity</th>
                                    <th scope="col">Balance</th>
                                    <th v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in drawerCurrentSiteAllocation" v-bind:key="'drawerCurrentSiteAllocation'+index">
                                    <td class="align-middle">{{ (drawerSites.find(x => x.id === parseInt(data.site_id))) ? drawerSites.find(x => x.id === parseInt(data.site_id)).name : "Invalid Data. Please Remove" }}</td>
                                    <td class="align-middle">
                                        <a-input v-if="isEditAllocation && isEditAllocationIndex == index" v-model='data.temp_quantity' min="1" type="number" />
                                        <span v-else >{{data.quantity}}</span>
                                    </td>
                                    <td class="align-middle">{{data.available_quantity}}</td>
                                    <td class="align-middle">{{selectedSiteAllocationProduct.on_hand_quantity}}</td>
                                    <td class="align-middle">{{(parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) > 0 ? (parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) : 0}}</td>
                                    <td v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center">
                                        <a-button size="small" v-if="isEditAllocation && isEditAllocationIndex == index" @click="saveAllocation(index)">Save</a-button>
                                        <a-button size="small" v-else @click="editAllocation(index)">Edit</a-button>
                                        <a-button size="small" @click="removeSiteAllocation(index)">Remove</a-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSiteAllocation' type="primary" block>Save</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- Drawer for Document Image -->
            <a-drawer :width="960" placement="right" :key="'documentImage'+documentImageKey" @close="closeDrawer('document_image')" :body-style="{ paddingBottom: '80px' }" :visible="documentImageDrawerVisible">

                <h6 class="heading-small text-muted mb-4 text-truncate">Document Image Upload</h6>

                <div class="container">
                    <a-spin tip="Processing Image Upload" :spinning="spinning">
                        <div class="row">
                            <div class='col'>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="file" ref="file" v-on:change="handleFileUpload()">
                                    <label class="custom-file-label" for="file">Choose file</label>
                                </div>
                            </div>
                            <div class='auto-col'>
                                <a-button class='float-right' size="large" v-on:click="submitFile()">Submit</a-button>
                            </div>
                        </div>
                        <div class="row pt-2 ml-2">
                            <div class='auto-col'>
                                {{ file.name }}
                            </div>
                        </div>

                        <div class='row'>
                            <img style="max-width: 100%; max-height: 100%;" :src="imageFileUrl">
                        </div>
                    </a-spin>
                </div>

            </a-drawer>

            <!-- Drawer for Serialization -->

            <a-drawer :width="520" placement="right" :key="'SerializationKey'+serializationKey" :maskClosable = "false" @close="closeDrawer('serialization')" :body-style="{ paddingBottom: '80px' }" :visible="serializationVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Serial Number -  {{ selectedSerialProduct.product_name }}</h6>
                <p>{{`${currentDrawerSerials.length} out of ${ updatedSerialCount } Serial Number(s) inputted`}}</p>
                <a-progress :percent="Math.floor((currentDrawerSerials.length / updatedSerialCount ) * 100)" size="small" :format="() => `${currentDrawerSerials.length} / ${updatedSerialCount}`"/>
                <div>
                    <base-alert v-if="serializationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in serializationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col">
                            <a-input addon-before="Serial Number" style="width: 100%" v-model='inputSerialNumber' @keyup.enter="submitDrawerSerials"/>
                        </div>
                        <div class='col-auto'>
                            <a-button type="primary" v-if="documentStatus!='Posted'" @click='submitDrawerSerials' :disabled='inputSerialNumber==""' >Submit</a-button>
                        </div>
                    </div>

                    <hr>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th class="text-center" scope="col"></th>
                                    <th scope="col">Serial Number</th>
                                    <th class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in currentDrawerSerials" v-bind:key="'currentDrawerSerials'+index">
                                    <td class="align-middle"><a-checkbox :checked="data.status == 'A'" disabled /></td>
                                    <td class="align-middle">{{data.serial_no}}</td>
                                    <td class="text-center"><a-button size="small" @click="removeSerialNumber(index)">Remove</a-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSerialization' type="primary" block>Save</a-button>
                    </div>

                </div>
            </a-drawer>

            <!-- Drawer For Refences -->
            <a-drawer
                :width="520"
                placement="right"
                @close="closeDrawer('references')"
                :visible="referenceDrawerVisible"
                v-if="this.document_config != null"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Document References</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->

              <div class="row">
                <div class="col text-left">
                  <small>Reference Name</small>
                </div>
                <div class="col text-left">
                  <small>Value</small>
                </div>
              </div>

              <div v-for="reference in document_config.document_type_settings.references" :key="reference.name" class="row pt-2">
                <div class="col">{{reference.name}}</div>
                <div class="col text-left" v-if="documentStatus != 'Posted'">
                    <a-input v-if="_.isEmpty(reference.value)" placeholder="Enter value here" v-model="reference.input"/>
                    <a-select v-else style="width: 100%" placeholder="Choose value" v-model="reference.input">
                        <a-select-option v-for="value in reference.value.split(',')" :key="value" :value="value">{{value}}</a-select-option>
                    </a-select>
                </div>
                <div v-else class="col text-left">
                    <div v-if="_.isUndefined(reference.input)"> - </div>
                    <div v-else>
                        <!-- {{reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)}} -->
                        <div v-if="reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) !== null">
                            <!-- <a-avatar :src="reference.input" :size="200"/> -->
                            <!-- {{reference.input}} -->
                            <a :href="reference.input"><a-avatar :size="250" :src="reference.input" /></a>
                        </div>
                        <div v-else>{{reference.input}}</div>
                    </div>
                </div>
              </div>
            </a-drawer>

            <!-- Drawer For Extras -->
            <a-drawer
                :width="520"
                placement="right"
                @close="closeDrawer('extras')"
                :visible="extrasDrawerVisible"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Extras</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->

              <div class="row">
                <div class="col text-left">
                  <small>Extra Atrribute</small>
                </div>
                <div class="col text-left">
                  <small>Value</small>
                </div>
              </div>

              <div v-for="(attribute, value) in documentExtras" :key="attribute" class="row pt-2">
                <div class="col">{{value}}</div>
                <div class="col text-left">
                    {{attribute}}
                </div>
              </div>
            </a-drawer>

            <!-- Drawer For View Allocation -->
            <a-drawer
                :width="1500"
                placement="right"
                @close="closeDrawer('view_allocation')"
                :visible="viewAllocation"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Site Allocation</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->
                <div class="table-responsive pt-2">
                    <VueTabulator ref="tabulator1" v-model="documentLines" :options="optionsViewAllocation"/>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="mr-auto font-weight-bold">Total Allocated Quantity: {{totalAllocatedQty}}</span>
                    </div>
                    <div class="col"></div>
                </div>
            </a-drawer>

            <!-- Drawer for Document Payment -->
            <a-drawer :width="960" placement="right" :key="'documentPayment'+documentPaymentsKey" @close="closeDrawer('document_payments')" :body-style="{ paddingBottom: '80px' }" :visible="documentPaymentsDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Payments</h6>
                <table style="width:100%">
                    <tr>
                        <th>Payment Mode</th>
                        <th>Amount</th>
                        <th>Reference</th>
                        <th>Payment Date</th>
                    </tr>
                    <tr v-for="p in documentPaymentsList" v-bind:key="'documentPaymentsList'+p.id">
                        <td>{{ p.payment_mode }}</td>
                        <td>{{ p.amount }}</td>
                        <td>{{ p.reference }}</td>
                        <td>{{ moment(p.payment_date).format('MM/DD/YYYY HH:mm') }}</td>
                    </tr>
                </table>
            </a-drawer>

            <!-- Drawer for Ecom Document -->
            <a-drawer title="" :width="600" placement="right" @close="closeDrawer('ecomForm')" :visible="documentEcomDrawerVisible" v-if="documentEcomDrawerVisible">
                <div>
                    <document-ecom-form @closeDrawer="ecomCloseDrawer" v-on:refreshPage="refreshPage" @postOrder="ecomPost" @deleteRow="deleteRow" :ecomAction="ecomAction" :documentDetails="documentDetails"> </document-ecom-form>
                </div>
            </a-drawer>
            <!-- Drawer for lot code and expiry Allocation -->
            <a-drawer :width="520" placement="right" @close="closeDrawer('lotCodeExpiry')" :body-style="{ paddingBottom: '80px' }" :visible="lotCodeExpiryVisible">
                <h3 class="heading-large text-muted mb-4">ITEM: {{ selectedLotCodeExpiryProduct.product_name }} <br> QTY: {{ selectedLotCodeExpiryProduct.quantity }} </h3>
                <div>
                    <hr class="mt-1 mb-2">
                    <div class="row">
                        <div class="col text-left">
                            <h5>Lot Code</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a-input v-if="!isLotCodeExpiryDisabled" v-model='inputLotCode' placeholder="Lot Code" />
                            <a-select v-else v-model='inputLotCode' @select='selectlotcodeSource' placeholder='Select Lot Code' style="width: 100%;" input-classes="form-control">
                                <a-select-option v-for="s in lotcodeSources" :key="s['id']"> {{ s['lotcode'] }} | {{ moment(String(s['expired_at'])).format('YYYY-MM-DD') }}</a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col text-left">
                            <h5>Expiry</h5>
                        </div>
                        <div class="col text-left">
                            <h5 v-if="!isLotCodeExpiryDisabled">Quantity</h5>
                            <h5 v-else>Available Quantity: {{ lotcodeAvailableQty }}</h5>
                        </div>
                        <div class="col-auto">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a-date-picker v-model='inputExpiryAt' :disabled="isLotCodeExpiryDisabled" :disabled-date="disabledDate" placeholder="Expiry" format="YYYY-MM-DD" />
                        </div>
                        <div class="col">
                            <a-input min="0" type="number" v-model='inputLotCodeQuantity' placeholder="Quantity" />
                        </div>
                        <div class='col-auto'>
                            <a-button type="primary" v-if="documentStatus!='Posted'" @click='submitDrawerLotCodeExpiry' :disabled='inputLotCode=="" || inputExpiryAt == ""' >Add</a-button>
                        </div>
                    </div>
                    <hr>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Lot Codes</th>
                                    <th scope="col">Expiry Dates</th>
                                    <th scope="col">Quantity</th>
                                    <th class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in currentDrawerLotCodeExpiry" v-bind:key="'lotCodeExpiryKey'+index">
                                    <td class="align-middle">{{data.lot_code}}</td>
                                    <td class="align-middle">{{new Date(data.expiry_at).toLocaleString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}}</td>
                                    <td class="align-middle" v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{data.actual_quantity}}</td>
                                    <td class="align-middle" v-else>{{data.quantity}}</td>
                                    <td class="text-center"><a-button size="small" type="danger"  v-if="documentStatus!='Posted'" @click="removeLotCodeExpiry(index)">Remove</a-button></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" align="right">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Lot Code Total Content Quantity</h3>
                                        <h3 v-else>Lot Code Total Quantity</h3>
                                    </td>
                                    <td colspan="2" align="left"><h3>{{ lotcodeTotalQty }}</h3></td>
                                </tr>
                                <tr>
                                    <td colspan="2" align="right">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Line Content Quantity</h3>
                                        <h3 v-else>Line Quantity</h3>
                                    </td>
                                    <td colspan="2" align="left">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{ selectedLotCodeExpiryProduct.quantity * selectedLotCodeExpiryProduct.content_quantity }}</h3>
                                        <h3 v-else>{{ selectedLotCodeExpiryProduct.quantity }}</h3>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerLotCodeExpiry' type="primary" block>Save Lot Code Expiry</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- drawer for customizeList -->
            <a-drawer title="" width="480" placement="right" @close="()=>{isDrawerVisible = false}" :visible="isDrawerVisible" >
                    <b>Customize Fields</b>
                    <br/>
                    <small>Check the fields that you want to see on the list.</small>
                    <br/>
                    <h3 class="heading-small text-muted list-group-item">Available Fields</h3>
                    <li v-for="field in filteredColumnFields" :key="field.name" class="list-group-item">
                      <a-checkbox :checked="field.value"  @change="onCheck" :id="field.name">
                        {{field.name}}
                      </a-checkbox>
                    </li>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
                      <button class="btn btn-primary float-right" @click.prevent="closeCustomizeListDrawer" > Update List </button>
                    </div>
            </a-drawer>
            <!-- drawer for sort -->
            <a-drawer
                title=""
                :width="800"
                placement="right"
                @close="onCloseSortDrawer"
                :visible="sortDrawerVisibility"
                >
                    <h6 class="heading-small text-muted mb-4">Sort</h6>
                        <sort-drawer :documentTypeCode="currentDocumentTypeCode" @saveSort="saveSort"></sort-drawer>
            </a-drawer>
        </div>
        </a-spin>
    </div>
</template>

<script>

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';
    // import {gmapApi} from 'vue2-google-maps';
    import Pusher from 'pusher-js' // import Pusher
    import StockCard from '../Products/StockCard.vue';
    import { mapState } from "vuex";
    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage.js';
    import Autocomplete from "vuejs-auto-complete";
    import ValidateField from '../../components/validateFormUtils.js';
    import moment from 'moment';
    import axios from "axios";
    import CustomerForm from '../Customer Profiles/CustomerForm.vue';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import DocumentEcomForm from '../Documents/DocumentEcomForm.vue'
    import DocumentApplyToOtherSitesDrawer from './Drawers/DocumentApplyToOtherSitesDrawer.vue';
    import XLSX from 'xlsx';
    import {Epsonfont} from '@/assets/fonts/Epson1-normal'
    import {Epsonfontbold} from '@/assets/fonts/Epson1-bold'
    import SortDrawer from './Drawers/SortDrawer.vue';
    // import PrintMixin from './PrintMixin' //print() function inside this
    var component_x;
    //START OF HISTORY TABLE
    const historyColumns = [
        {
        title: 'Action',
        dataIndex: 'action',
        },
        {
        title: 'Action By',
        dataIndex: 'action_by',
        },
        {
        title: 'Action At',
        dataIndex: 'action_at',
        },
    ];
    const historyData = [];

    const columns = []

    const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

    //Start of Charge Table
    const chargeColumns = [
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
        },
    ];
    //End of Charge Table

    //DocumentSettings
    const DistributionDocuments = {
        header: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showSublocationSite: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showPurpose: true,
        },
        headerOriSox: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesman: true,
            showSublocationSite: true,
            showSublocationDestination: true,
            showOrderSource: false,
        },
        headerRelDde: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOthSin: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showDeliveryDocument: true,
            showOrderSource: true,
        },
        headerRecCsr: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showDeliveryDocument: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOroRso: {
            showDocumentHeader: true,
            showRevenue:false,
            showRequestingSite: true,
        }
    }
    const InterbranchDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showSupplyingSite: true,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        }
    }
    const PurchaseDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
        },
        headerOriPox: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        },
        headerOthSbi: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
            showRecevingReport: true,
        },
    }
    const LocalDocuments = {
        headerAdjustments: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: true,
            showParty: true,
        }
    }
    const PCount = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
            showSublocation: true

        }
    }
    const PriceWorkSheet = {
        header: {
            showDocumentHeader: true,
            showSupplier: true,
            showParty: false,
            showForThisSite: true,
            showApplyDocumentToOtherSitesButton: true,
            showSaveProductVia: true,
        }
    }
    const TransferAllocationDocumentPicking = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: true,
        }
    }
    const CountSet = {
        header: {
            showDocumentHeader: false,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
        }
    }

    export default {
        // mixins: [PrintMixin],
        components: {
            Autocomplete,
            StockCard,
            CustomerForm,
            DocumentEcomForm,
            DocumentApplyToOtherSitesDrawer,
            SortDrawer
            // VueGoogleAutocomplete
        },
        data: function() {
            return {
                backLink: "/documents?type=" + secureStorage.getItem("documentTypeInternalCode"),
                isRefreshInventory: false,
                friendlyCodeAndDocumentNo: '',
                friendlyOriginDocumentNo: '',
                documentId: '',
                documentNo: 0,
                importMode: 0,
                confirmLoadingonSuppModal: false,
                showChangeSupplierModal: false,
                modalInternalDocumentId: false,

                // for customizing column fields per document type
                documentTableFilteredList: secureStorage.getItem("documentTableFilteredList"),
                defaultColumnFields : [
                  { name: "line_no", value: true },
                  { name: "stock_no", value: true },
                  { name: "product_name", value: true },
                  { name: "barcode", value: true },
                  { name: "unit_id", value: true },
                  { name: "quantity", value: true },
                  { name: "price", value: true },
                  { name: "cost", value: true },
                  { name: "subtotal", value: true },
                  { name: "discount_text", value: true },
                  { name: "on_hand_quantity", value: true },
                  { name: "remarks", value: true }
                ],
                filteredColumnFields : [],
                isDrawerVisible: false,

                popUpModal:{
                  isVisible: false,
                  toClear:false,
                  isAutoPopulate:false,
                  initializeProcess:"",
                  message:"",
                  text:""
                },
                showAddingProgress:{
                  isVisible: false,
                  productCount:0,
                  productAdded:0
                },
                
                //1935
                overallDiscountWithoutSupportDiscount: 0,

                // BOOKING DATA
                bookingId: null,
                activeBooking: false,
                recomputeModal: false,
                recompute: false,
                applyDocumentToOtherSitesDrawer: false,
                saveMassUploadProductVia: "barcode",
                originalGeoLocation: {},
                bookingDetails: {},
                printFontSizeIncrease: 0,
                printValueHeaderPos: 0,
                printValueFooterPos: 0,
                // printPaperSize: 'a4',
                mapKey: 0,
                center: {
                  lat: 10.0,
                  lng: 10.0
                },
                markers: [{
                  id: 1,
                  position: {
                    lat: 10.0,
                    lng: 10.0
                  }
                }, {
                  id: 2,
                  position: {
                    lat: 11.0,
                    lng: 11.0
                  }
                }],
                from_address: {},

                suppDetails: {},

                options: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:23,
                    // http://tabulator.info/docs/4.2/page#element
                    paginationSizeSelector: [13,23,33,43,53],
                    selectable:true,
                    rowSelectionChanged: this.rowSelectionChanged,
                    //downloadDataFormatter: this.downloadDataFormatter,
                    downloadConfig:{
                        columnCalcs:false,
                    },
                    addRowPos:"bottom",
                    movableColumns:true,
                    index: "product_id",
                    columns: [
                        {
                            frozen: true,
                            formatter:"rowSelection",
                            titleFormatter:"rowSelection",
                            headerSort:false,
                        },
                        {
                            title: '#',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Supplier Stock No.',
                            field: 'supplier_stock_no',
                            sorter: 'number',
                            formatter: this.supplierStockNumber,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Design',
                            field: 'design',
                            sorter: 'string',
                            formatter: this.designFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Size',
                            field: 'size',
                            sorter: 'number',
                            // formatter: this.sizeFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Color',
                            field: 'color',
                            sorter: 'string',
                            formatter: this.colorFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        // {
                        //     title: 'Code',
                        //     field: 'product_id',
                        //     sorter: 'number',
                        //     visible: false,
                        //     download: false,
                        // },
                        {
                            title: 'Ref Code',
                            field: 'ref_code',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit',
                            field: 'unit_id',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            formatter: this.unitFormatter,
                            editorParams: this.unitLookup,
                            editable: this.isCellEditable,
                            accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ordered Quantity',
                            field: 'ordered_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Available Quantity',
                            field: 'actual_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Requested Quantity',
                            field: 'requested_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reason',
                            field: 'reason_id',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            download: false,
                            formatter: this.reasonFormatter,
                            editorParams: this.reasonLookup,
                            //editable: this.isCellEditable,
                            //accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Actual Yield Quantity',
                            field: 'actual_yield',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivery Quantity',
                            field: 'delivery_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Goods Issue Quantity',
                            field: 'goods_issue_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Frozen Quantity',
                            field: 'frozen_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Balance Quantity',
                            field: 'content_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivered Quantity',
                            field: 'content_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Cost',
                            field: 'price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: true,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Cost (PHP)',
                            field: 'price_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },

                        {
                            title: 'PI Price',
                            field: 'price_pi',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Cost',
                            field: 'cost',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Cost (PHP)',
                            field: 'cost_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross',
                            field: 'total_gross',
                            sorter: 'number',
                            align: 'right',
                            mutator: this.totalGrossMutator,
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross (PHP)',
                            field: 'total_gross_php',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            align: 'right',
                            download: true,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (PHP)',
                            field: 'subtotal_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Amount',
                            field: 'discount',
                            sorter: 'number',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount',
                            field: 'discount_text',
                            sorter: 'string',
                            editor: 'input',
                            align: 'right',
                            download: false,
                            validator: this.validateTableDiscount,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Landed',
                            field: 'old_landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Landed',
                            field: 'landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Retail Price',
                            field: 'old_retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Retail Price',
                            field: 'retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Markup %',
                            field: 'markup_percent',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Original',
                            field: 'old_original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Original',
                            field: 'original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Ordering',
                            field: 'old_ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Ordering',
                            field: 'ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Whosale Price',
                            field: 'old_wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Whosale Price',
                            field: 'wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Least Price',
                            field: 'old_least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Least Price',
                            field: 'least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Special Price',
                            field: 'old_special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Special Price',
                            field: 'special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'On-Hand Quantity',
                            field: 'on_hand_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Amount',
                            field: 'invoice_amount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Discount',
                            field: 'invoice_discount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (v)',
                            field: 'unit_price_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (v)',
                            field: 'net_price_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (v)',
                            field: 'subtotal_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (nv)',
                            field: 'unit_price_no_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (nv)',
                            field: 'price_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (nv)',
                            field: 'subtotal_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Effective Discount',
                            field: 'effective_discount',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Incoming Quantity',
                            field: 'incoming_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: '#',
                            width: '10%',
                            field: 'code_and_document_no',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document ID',
                            width: '10%',
                            field: 'id',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reference',
                            width: '10%',
                            field: 'reference_1',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document Date',
                            width: '10%',
                            field: 'document_date',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Quantity',
                            width: '10%',
                            field: 'total_quantity',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Status',
                            width: '10%',
                            field: 'status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Order Status',
                            width: '15%',
                            field: 'order_status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Created By',
                            width: '15%',
                            field: 'created_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Updated By',
                            width: '15%',
                            field: 'updated_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Remark',
                            field: 'remarks',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Salesman',
                            field: 'salesman_name',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Extras',
                            field: 'line_extras',
                            editor: 'textarea',
                            visible: false,
                            download: false,
                            editable: true,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Sublocation Alloation',
                            field: 'sublocation_allocation',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Product Type',
                            field: 'product_type',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Serial No',
                            field: 'document_line_serials_text',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Lot Code',
                            field: 'document_line_lot_code',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Expiry',
                            field: 'document_line_expiry',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        }
                    ],
                },
                historyData,
                historyColumns,

                processingCsvUpload: false,
                CsvUploadParams: {},

                //Global
                spinning: false,
                spinMessage: 'Loading..',
                documentNumber: -1,
                originDocumentNumber: -1,
                originDocumentTypeId: 0,
                originDocumentTypeName: null,
                documentStatus: null,
                documentOrderStatus: null,

                notifMessage: [],
                document_config: null,
                currentDocumentTypeId: null,
                currentDocumentTypeName: null,
                currentDocumentTypeCode: null,
                currentDocumentTypeFriendlyCode: null,
                currentDocumentTypeFriendlyCodeWithId: "",
                headerStatusIcon: '',

                //Configuration
                maximumDocumentLineNumber: 200,
                decimalPlaces: 2,

                //Document Header
                    header: {
                        showDocumentHeader: false,
                        showSupplier: false,
                        showSupplyingSite: false,
                        showRequestingSite: false,
                        showPurpose: false,
                        showParty: false,
                    },

                    //For all
                    fetching: false,
                    sites: [],

                    //Suppliers
                    supplier: [],
                    suppliers: [],
                    isSupplierDisabled: false,
                    showSupplierOptions: false,
                    isTradeToggleDisabled: false,
                    showTradeToggle: false,

                    //Supplying Site
                    supplyingSite: [],
                    isSupplyingSiteDisabled: false,

                    //Requesting Site
                    requestingSite: [],
                    isRequestingSiteDisabled: false,

                    //Revenue Site
                    revenue:'',
                    isRevenueDisabled: false,

                    //Distributon
                    sublocations: [],
                    distributionSite: [],
                    isDistributionSiteDisabled: false,
                    originSublocation: [],
                    isOriginSublocationDisabled: false,
                    destinationSublocation: [],
                    isDestinationSublocationDisabled: false,
                    sublocationOriginLabel: 'Sublocation Origin',
                    sublocationDestinationLabel: 'Sublocation Destination',
                    showHeaderDiscount: false,

                    customer: [],
                    customers: [],
                    isCustomerDisabled: false,
                    isCustomerCreateDisabled: false,

                    salesman: {},
                    salesmen: [],
                    isSalesmanDisabled: false,

                    salesOrder: 0,
                    isSalesOrderDisabled: true,

                    deliveryDocument: 0,
                    isDeliveryDocumentDisabled: true,

                    isRecevingReportDisabled: true,
                    receivingReport: 0,

                    // Purpose and Party
                    purpose: [],
                    purposes: [],
                    party: '',

                    isPurposeDisabled: false,
                    isPartyDisabled: false,

                    //Add Product / Search Product
                    showDocumentBodyHeader: true,
                    productFormMode: "Add",
                    productFormModeOptions: [
                        { label: 'Add Products to this Document', value: 'Add' },
                        { label: 'Search within this Document', value: 'Search' },
                    ],
                    productSearchInput: '',
                    addedProductSearchInput: '',

                    selectedParentProduct: [],
                    selectedProduct: [],

                    //Search Filter
                    placeholder: "Search product by barcode",
                    addedProductPlaceholder: "Search added product by barcode",
                    searchFilter: "barcode",
                    searchFilterAddedProduct: "barcode",

                    //Product Search
                    authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                    isProductSearchDisabled: false,

                    //Product Name
                    isProductNameEditConfigDisabled: false,
                    isProductNameDisabled: true,
                    productName: '',
                    inputProduct: '',
                    productPriceChoice: 'landed_cost', //Default from config is landed_cost

                    //Document Line Form
                    isDocumentLineFormDisabled: true,
                    quantity: '',
                    actual_yield: '',
                    tolerance_quantity: '',
                    unit: [],
                    units: [],
                    productComposition: [],
                    productCompositions: [],
                    unitQuantity: 1,
                    unitCost: '',
                    discountText: [],
                    unitNetCost: '',
                    subTotal: '0.00',
                    retailPrice: 0,

                    promoName: null,
                    rewardCode: null,
                    rewardDiscountAmount: 0,

                    discountTotal: 0,

                    showPwsCosts: false,
                    showQuantity: true,
                    showActualYield: false,
                    showUnitCost: true,
                    showDiscount: true,
                    showUnitNetCost: true,
                    showSubtotal: true,

                    //isDirtyData
                    isEditing: false, // track unsaved changes
                    isChangeAction: false,

                    //Document Form Table

                    selectedDocumentLines: [],
                    origData: [],
                    data: [],
                    columns,

                //Summary
                totalQuantity: 0,
                grossAmountDisplay: 0.00,
                netAmountDisplay: 0.00,
                grossAmount: 0.00,
                itemDiscount: 0.00,
                overallDiscount: 0.00,
                netAmount: 0.00,
                vatAmount: 0.00,
                totalWithVat: 0.00,
                taxRate: 0,
                grossAmountwithoutTax: 0.00,
                netAmountWithoutTax: 0.00,

                documentDate: moment(new Date()),
                targetDate:  moment(new Date()),
                cancellationDate: moment(new Date()).add('30', 'days'),
                showTargetDate: true,
                showCancellationDate: true,

                headerDiscount: [],

                supportDiscount: [],
                showSupportDiscount: false,
                isSupportDiscountValid: true,

                isHeaderDiscountDisabled: false,
                isDocumentDateDisabled: false,
                isTargetDateDisabled: false,
                isCancellationDateDisabled: false,

                vatExclusiveCheckbox: false,
                showVatExclusiveCheckboxConfig: true,
                showVatExclusiveCheckbox: false,
                showSummaryCalculation: true,
                showTotalQuantity: true,

                //Advanced Info
                paymentTerm: [],
                paymentTerms: [],

                shippingMethod: [],
                shippingMethods: [],
                showShippingMethod: false,

                showAdvancedInfo: false,
                isReferenceDisabled: false,
                isPaymentTermDisabled: false,
                isShippingMethodDisabled: false,
                isSupportsDiscountDisabled: false,

                reference : '',
                remark: '',
                remarkLabel: 'Remark',

                //Charge Table and Drawer
                chargeData: [],
                chargeSelectedRowKeys: [],
                chargeColumns,
                chargeDrawerVisible: false,
                chargeType: 'R',
                chargeTypeOptions: [
                    {key: "R", value: "Regular Charge"},
                    {key: "W", value: "Weighted Charge"}
                ],
                isAddChargeDisabled: false,

                chargeDescription: null,
                chargeWeight: 0,
                chargeRate: 0,
                chargeAmount: 0,
                isChargeWeightDisabled: true,
                isChargeRateDisabled: true,
                isChargeAmountDisabled: false,
                showChargesTable: false,

                //Booking Integration
                showBookingButton: false,
                bookingDrawerVisible: false,
                siteAddress: null,
                siteContactPerson: null,
                siteContactNumber: null,
                addressEditMode: false,
                deliveryMode: "8",
                orderParemeters: {},

                // payments
                paymentDrawerVisible: false,
                initialDepositDrawerVisible:false,
                paymentMode: "paymaya",
                paymentMethod: null,
                paymentMethods: [],
                bankTransferReference: '',
                baseUrl: "https://test.dragonpay.ph/api/collect/v2",

                // Document Footer Actions
                isSaveDisabled: false,
                isUpdateDisabled: false,
                isPostDisabled: false,
                showconfirmUnconfirmButton: false,
                showCreateChildDocButton: false,
                createChildDocButtonLabel: '',
                showDeliverButton: false,
                showPayButton: false,

                accessRights: [],

                //Document Action History
                historyDrawerVisible: false,
                tabulator: null,
                tabulator1:null,

                stockCardVisible: false,
                selectedStockCardProduct: null,
                stockCardKey: 0,


                sublocationAllocationVisible: false,
                selectedSublocationAllocationProduct: {},
                sublocationAllocationKey: 0,

                siteAllocationVisible: false,
                selectedSiteAllocationProduct: {},
                siteAllocationKey: 0,

                massAddDrawerVisible: false,
                massAddDrawerKey: 0,

                onHandQuantity: 0,

                orderSource: [],
                isOrderSourceDisabled: false,
                orderSources: [],
                isOrderSourceMode: false,

                customerDrawerVisible: false,
                customerDrawerKey: 0,
                customerAddress: "",
                customerContactMobile: "",
                customerContactTelephone: "",
                customerContactFax: "",
                customerContactEmail: "",
                selectedCustomerContact: "",
                activeCustomerContact: '',

                map: undefined,
                forPaymentIsPosting: false,
                continueAutoCreatePoExceedRr: false,
                continueWithPriceDiscrepancy: false,
                forPaymentIsProcessed: false,
                paymentErrors: [],
                initialDepositErrors:[],
                massAddProductErrors:[],
                massAddProductErrorsDL: [],
                dlDUplicateSkus: 0,
                dlDUplicateSkusItems: [],
                dlSkusNotFound: 0,
                dlSkusNotFoundItems: [],
                showPrint: false,
                postDate: null,

                isHeaderOnly: false,
                isDocumentTrade: true,

                addProductConfirmationVisible: false,

                forThisSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
                forThisSites: [],

                //PWS
                oldOrdering: null,
                oldLanded: null,
                oldRetailPrice: null,
                newOrdering: null,
                newLanded: null,
                newRetailPrice: null,
                markUp: null,
                showFilteredBySupplier: false,
                filteredBySupplier: false,
                isForThisSiteDisabled: false,

                //Currency
                currency: [],
                currencies: [],
                currencyRate: 0,
                defaultCurrencyRate:0,
                hasDefaultCurrency:false,
                currencyDetails:{},
                showConversionRate:false,

                // References
                referenceDrawerVisible: false,

                drawerSublocation: {key: 0, label: "Please select a sublocation"},
                drawerSublocations: [],
                drawerSublocationSiteId: null,
                drawerSublocationQuantity: '',
                drawerCurrentSublocationAllocation: [],
                sublocationAllocationErrors: [],
                allowSublocationAllocation: false,

                //Transfer Allocation
                drawerSite: {key: 0, label: "Please select a site"},
                drawerSites: [],
                drawerSiteId: null,
                drawerSiteQuantity: '',
                drawerCurrentSiteAllocation: [],
                allowSiteAllocation: false,
                siteAllocationErrors: [],

                createdBy: '',
                postedBy: '',

                serializationKey: 0,
                serializationVisible: false,
                serializationErrors: [],
                selectedSerialProduct: {},
                currentDrawerSerials: [],
                currentDrawerSerialsInstance: [],
                updatedSerialCount:0,
                inputSerialNumber: '',

                file: '',
                documentImageKey: 0,
                documentImageDrawerVisible: false,
                imageFileUrl: '',

                documentPaymentsKey: 0,
                documentPaymentsDrawerVisible: false,
                documentPaymentsList: [],

                siteSublocation: [],
                isSiteSublocationDisabled: false,

                postedASMDSM: false,
                documentEcomDrawerVisible:false,
                ecomAction:null,
                documentDetails:[],
                imagepath: secureStorage.getItem("account_logo"),
                documentID:null,
                isPCountDocumentSearchDisabled:false,
                addPCountDocumentConfirmationVisible: false,
                selectedDocumentID:null,
                selectedDocumentLineRows:null,
                continuePostCountSetDocument:false,
                isSetOtherItemInventoryToZero:false,
                initialDeposit:{
                    amount:0,
                    reference:null,
                    payment_mode:"Initial Deposit",
                    status:"A",
                    payment_date: moment(new Date())
                },

                asnModule: 0,
                maxLines: 0,
                autoCreateAlterSupp: false,
                filterBySupp: false,
                fileList: [],
                suppItems: [],
                csvData: '',
                documentExtras: {},
                extrasDrawerVisible: false,
                autoPostDD: false,
                autoPostDDAndSI:false,
                openCSR: false,
                configuredExtras: {},
                validationdocutypes : ["OTHPUR", "ORIPOX", "ORIASN", "RECDEL", "RECPOS"],
                HideDeleteAndAddProductButton:false,
                supplierDetails:{},
                forceFetchCurrency:false,
                isCurrencyToPhp:false,
                filterExistingProductData:[],
                isRunDefaultCurrency:false,
                defaultCurrencyDetails:{},
                isEditAllocation:false,
                isEditAllocationIndex:0,
                siteAllocationRemainingQuantity:null,
                massAddWithAllocationProductErrors:[],
                fileWithAllocationList:[],
                massAddWithAllocationDrawerVisible:false,
                processingXlsxUpload: false,
                xlsxUploadFormData: {},
                viewAllocation:false,
                documentLines:[],
                continueWithPrintPdf:true,
                printDefault:true,
                costUpdated:false,
                optionsViewAllocation: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:20,
                    columns: [
                        {
                            title: 'Line No',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                        },
                        {
                            title: 'Cost',
                            field: 'price',
                            formatter: 'money',
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            formatter: 'money',
                        },
                    ]
                },
                totalAllocatedQty:0,
                referenceLabel:"Reference",
                displayNetAmountWOVat:false,
                displayVatAmount:false,
                displayNetAmountWOVatLabel:"Net Amount w/o VAT",
                lotCodeExpiryVisible: false,
                inputLotCode: "",
                inputLotCodeQuantity: 0,
                inputExpiryAt: undefined,
                lotCodeExpiryKey: 0,
                selectedLotCodeExpiryProduct: {},
                currentDrawerLotCodeExpiry: [],
                revenueCreditingMode:'',
                RequestingLabel:'Requesting',
                revenueOption:[
                    {key: "R", value: "Requesting"},
                    {key: "T", value: "Target"}
                ],
                revenueSiteId:0,
                continueAutoCreateTr:false,
                isConfirmDisabled:false,
                supplierCurrencyRate:0,
                supplierCurrencyId:-1,
                currencyRateLabel:null,
                sortOrder: [],
                sortDrawerVisibility: false,
                sortInput: {},
                isLotCodeExpiryDisabled: false,
                lotcodeSources: [],
                lotcodeSource: [],
                lotcodeTotalQty: 0,
                lotcodeAvailableQty: 0
            }
        },
        // Track Unsaved Changes on Document
        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                this.isEditing = false
                window.removeEventListener("beforeunload", this.preventNav);
            })

        },

        // async beforeRouteLeave(to, from, next) {
        //     var data = this.tabulator.getData();
        //     if (data.length > 0) {
        //         this.isEditing = !(component_x.origData === JSON.stringify(data))
        //     }
        //     if (this.isEditing && !this.isChangeAction) {
        //         if (!window.confirm("Leave without saving?")) {
        //             return;
        //         }
        //     }
        //     next();
        // },

        async beforeRouteLeave(to, from, next) {
            if (this.isDirty && !this.isChangeAction) {
              this.$confirm({
                title:"Document line has been modified",
                content: "There are unsaved changes in the document.\n Clicking 'Ok' will discard changes. Do you want to proceed?",
                onOk(){
                  next()
                }
              })
            }else{
              next();
            }    
        },

        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted: async function() {
            //[ERK] Turn off ASN button
            let qryasnModule = await HTTPRequest.getRequest(this.endPoint + "system_module_categories?code=PTP-006", null, null)
            this.asnModule = qryasnModule.length

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "logobarter";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF


            if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                this.backLink = "/products_v2?type=OTHPWS"
            } else {
                this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
            }

            if (this.$route.params.id != undefined){
                if (this.$route.params.id > 0){
                    if(this.$route.params.id) secureStorage.setItem("temp_document_id", this.$route.params.id);
                } else {
                    secureStorage.setItem("temp_document_id", 0);
                }
            }

            this.documentNumber = secureStorage.getItem('temp_document_id');
            this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
            this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
            this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
            this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
            this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
            this.initializeDocument();
            this.getSettings()

            

        },
        computed: {
            ...mapState(['endPoint', 'parentId', 'parameters', 'serverType', 'publicUrl']), 
            isDirty(){return this.isEditing},
            // google: gmapApi,
            chargeRowSelection() {
                // eslint-disable-next-line
                const { chargeSelectedRowKeys } = this;
                return {
                    onChange: (chargeSelectedRowKeys) => {
                        var charges = [];
                        this.chargeData.forEach(function(x){
                            charges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.chargeSelectedRowKeys = _.intersection(chargeSelectedRowKeys, charges)
                    }
                }
            },
            formattedsearchFilter(){
                return (this.searchFilter == 'product_id') ? 'code' : this.searchFilter
            },
            formattedsearchFilterAddedProduct(){
                return (this.searchFilterAddedProduct == 'product_id') ? 'code' : this.searchFilterAddedProduct
            },
        },
        created() {
            this.subscribe()
        },
        methods:{
          showCustomizeListDrawer() {
            this.isDrawerVisible = true
          },
          checkCustomizedFields(docTypeCode) {
            const currentSettings = this.documentTableFilteredList.filter(({ docType }) => docType === docTypeCode)
            if (currentSettings.length > 0) {
              const { customFields } = currentSettings[0]
              if (customFields.length !== 0) {
                this.filteredColumnFields = customFields
              } 
            } 
          },
          onCheck(e) {
            const { checked, id } = e.target
            const tempValue = this.filteredColumnFields.map((field) => {
              if (field.name === id) {
                return { ...field, value: checked }
              }
              return field
            })
            this.filteredColumnFields = tempValue
          },
          closeCustomizeListDrawer() {
            const listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
            let data = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
            if (listIsZero.length === 0) this.filteredColumnFields = data
            if (this.documentTableFilteredList !== null) {
              const isExisting = this.documentTableFilteredList.filter(({ docType }) => docType === this.currentDocumentTypeCode)
              if (isExisting.length === 0) {
                secureStorage.setItem("documentTableFilteredList", [...this.documentTableFilteredList, { docType: this.currentDocumentTypeCode, customFields: data }])
              } else {
                const newState = this.documentTableFilteredList.map((prevState) => {
                  if (prevState.docType === this.currentDocumentTypeCode) {
                    return { ...prevState, customFields: data }
                  }
                  return prevState
                })
                secureStorage.setItem("documentTableFilteredList", newState)
              }
            } else {
              secureStorage.setItem("documentTableFilteredList", [{ docType: this.currentDocumentTypeCode, customFields: data }])
            }
            this.renderColumnFields()
            this.isDrawerVisible = false
          },
            disabledDate(current) {
                return current < moment(this.documentDate, "YYYY-MM-DD").add(1, 'days');
            },
            selectlotcodeSource(value) {
                this.lotcodeSources.map(item => {
                  if(item['id'] == value){
                    this.inputExpiryAt = item['expired_at']
                    this.inputLotCodeQuantity = 0
                    this.lotcodeAvailableQty = item['available_quantity']
                  }
                })
            },
            showInternalDocumentId(){
                this.modalInternalDocumentId = true;
            },
            handleCancel(e){
                this.modalInternalDocumentId = false;
            },
            showSortDrawer(){
                this.sortDrawerVisibility = true;
            },
            async saveSort(value) {
                if(value != null && value != '' && value != '[]' ){
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.setItem(storeName, JSON.stringify(value));
                    await this.sortDocument(value)
                }else{
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.removeItem(storeName); 
                    this.tabulator.setSort([{column: 'line_no', dir: 'asc'}])
                }
                this.onCloseSortDrawer();
            },
            onCloseSortDrawer(){
                this.sortDrawerVisibility = false
            },
            async sortDocument(val){
                let newVal = []
                val.forEach((val) => {
                    newVal.push({column: val.field_name, dir: val.order_by})
                })
                await this.tabulator.setSort(newVal);
                // console.log(me, this.tabulator.getSorters())
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
            },
            isUnitCostDisabled(){
                if(this.currentDocumentTypeCode === 'ORISOX'){
                     if(this.isDocumentLineFormDisabled || this.isOrderSourceMode){
                        return true
                    }else {
                        return false
                    }
                }else{
                    if(this.isDocumentLineFormDisabled){
                        return true
                    }else{
                        return false
                    }
                }
            },
            printDupSKUs() {
                let csv = 'Barcode\n' + this.dlDUplicateSkusItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Duplicate Barcodes.csv';
                anchor.click();

            },
            printSKUsNotFound() {
                let csv = 'Barcode\n' + this.dlSkusNotFoundItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Barcodes Not Found.csv';
                anchor.click();

            },
            async selectSiteSublocation (siteSublocation) {
                var arr = {
                    key:siteSublocation.key.replace('sublocations',''),
                    label:siteSublocation.label
                }
                siteSublocation = arr
                Object.assign(this, {
                    siteSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            async submitFile(){
                this.spinning = true;
                let data = new FormData();
                data.append('file', this.file);

                //Get S3 uploader endpoint
                var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
                var config = {
                    method: 'post',
                    url: uploader_endpoint['endpoint'] + '?profile=' + secureStorage.getItem('documentTypeName') + '&account_name=' + secureStorage.getItem("accountName"),
                    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File"},
                    data : data
                };
                var response_data;
                await axios(config)
                    .then(function (response) {
                        response_data = response.data
                    })
                    .catch(function (error) {
                        //console.log(error)
                });
                this.imageFileUrl = response_data.path || ''
                this.spinning = false;

                var documentPayload = {document_id: this.documentNumber, image_url: this.imageFileUrl}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/save_image_url', null, documentPayload)

            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            },
            async saveDrawerSublocationAllocation(){
                await this.tabulator.updateData([{product_id: this.selectedSublocationAllocationProduct.product_id, sublocation_allocation: this.drawerCurrentSublocationAllocation}])
                this.closeDrawer('sublocationAllocation');
            },
            async saveDrawerSiteAllocation(){
                await this.tabulator.updateData([{product_id: this.selectedSiteAllocationProduct.product_id, site_allocation: this.drawerCurrentSiteAllocation}])
                this.closeDrawer('siteAllocation');
            },
            async saveDrawerLotCodeExpiry(){
                var lineqty = (this.currentDrawerLotCodeExpiry.length > 0) ? this.currentDrawerLotCodeExpiry.map(row => row.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)
                if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && this.currentDocumentTypeCode.includes("REC")){
                    this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>Quantity is not equal, do you want to override?</div>,
                        onOk: () => {
                            this.applyLotCodes(lineqty)
                        },
                        onCancel() {}
                    });
                    return
                } else if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && this.currentDocumentTypeCode.includes("REL")){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Line Quantity and Lot Code Total Quantity should be equal!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else if(lineqty == 0){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot Code & Expiry date is required for this item!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    await this.tabulator.updateData([{product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: (lineqty), document_line_locations: this.currentDrawerLotCodeExpiry}])
                    //Recalculate
                    await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id)
                    this.calculateSummary();
                    this.closeDrawer('lotCodeExpiry')
                }
            },
            async applyLotCodes(lineqty) {
                 await this.tabulator.updateData([{product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: lineqty, document_line_locations: this.currentDrawerLotCodeExpiry}])
                 //Recalculate
                 await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id)
                 this.calculateSummary();
                 this.closeDrawer('lotCodeExpiry')
            },
            async submitDrawerLotCodeExpiry() {
                if(this.inputExpiryAt == undefined || this.inputExpiryAt == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Expiry date is required",
                        style: getNotificationStyle('error')
                    });
                    return
                }
                if(this.inputLotCode == undefined || this.inputLotCode == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Lot Code is required"
                    });
                    return
                }

                let selectedLotCode = 0
                this.lotcodeSources.map(item => {
                    if(item['id'] == this.inputLotCode)
                        selectedLotCode = item['lotcode']
                })

                let lotCodeError = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if((item['lot_code'] == selectedLotCode && this.isLotCodeExpiryDisabled) || (item['lot_code'] == this.inputLotCode && moment(String(item['expiry_at'])).format('YYYY-MM-DD') == moment(String(this.inputExpiryAt)).format('YYYY-MM-DD') && !this.isLotCodeExpiryDisabled))
                        lotCodeError++
                })

                if(this.isLotCodeExpiryDisabled && Number(this.inputLotCodeQuantity) > Number(this.lotcodeAvailableQty)) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code quantity is greater than available quantity!",
                        style: getNotificationStyle('error')
                    });
                    return
                }

                if(lotCodeError > 0) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code selected or encoded is already on the list!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)
                    
                    this.currentDrawerLotCodeExpiry.push(
                        {
                            line_no: this.selectedLotCodeExpiryProduct.line_no,
                            lot_code: (this.currentDocumentTypeCode.includes("REL")) ? selectedLotCode : this.inputLotCode,
                            //expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : (new Date(this.inputExpiryAt)).toISOString(),
                            expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : moment(this.inputExpiryAt, "YYYY-MM-DD"),
                            status: "A",
                            quantity: Number(this.inputLotCodeQuantity / contentqty),
                            actual_quantity: Number(this.inputLotCodeQuantity),
                            content_quantity: this.selectedLotCodeExpiryProduct.content_quantity.toString()
                        }
                    )
                    this.inputLotCode = ''
                    this.inputLotCodeQuantity = 0
                    this.inputExpiryAt = ''
                    this.lotcodeTotalQty = 0
                    this.lotcodeAvailableQty = 0
                    this.currentDrawerLotCodeExpiry.map(item => {
                        if (contentqty == 1)
                            this.lotcodeTotalQty += Number(item['quantity'])
                        else 
                            this.lotcodeTotalQty += Number(item['actual_quantity'])
                    })
                }
            },
            updateSerialLineStatus(index){
                if(this.currentDrawerSerials[index].status == "D"){
                    this.currentDrawerSerials[index].status = "A"
                }else{
                    this.currentDrawerSerials[index].status = "D"
                }
            },
            removeSerialNumber(index){
                this.currentDrawerSerials.splice(index, 1);
            },
            removeSublocationAllocation(index){
                this.drawerCurrentSublocationAllocation.splice(index, 1);
            },
            removeSiteAllocation(index){
                this.drawerCurrentSiteAllocation.splice(index, 1);
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            removeLotCodeExpiry(index){
                this.currentDrawerLotCodeExpiry.splice(index, 1);
                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })
            },
            addDrawerSublocationQuantity: function () {
                this.sublocationAllocationErrors = [];
                if (this.drawerSublocation.key > 0 && this.drawerSublocationQuantity > 0) {
                    var is_sublocation_existing = this.drawerCurrentSublocationAllocation.find(x => x.sublocation_id === this.drawerSublocation.key);
                    if (is_sublocation_existing == undefined) {
                        this.drawerCurrentSublocationAllocation.push(
                            {'sublocation_id': this.drawerSublocation.key,
                            "quantity": this.drawerSublocationQuantity}
                        )

                        var total_sublocation_quantity = this.drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                        if (total_sublocation_quantity > this.selectedSublocationAllocationProduct.quantity) {
                            this.sublocationAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSublocationAllocationProduct.quantity)
                            this.drawerCurrentSublocationAllocation.pop();
                        }

                        this.drawerSublocationQuantity = ''
                        this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    } else {
                        this.sublocationAllocationErrors.push('Sublocation already exists')
                    }
                } else {
                    this.sublocationAllocationErrors.push('Sublocation and Quantity must have values')
                }
            },
            addDrawerSiteQuantityValidation(){
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Site', this.drawerSite.key));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            addDrawerSiteQuantity: function () {
                if(!this.addDrawerSiteQuantityValidation()){
                    var is_site_existing = this.drawerCurrentSiteAllocation.find(x => x.site_id === this.drawerSite.key);
                    if (this.currentDocumentTypeCode == 'OTHPCK') {
                        if (is_site_existing == undefined) {
                            this.siteAllocationErrors.push('Site selected is not available below')
                        } else {
                            if (is_site_existing.quantity < this.drawerSiteQuantity){
                                this.siteAllocationErrors.push('You have exceeded the site maximum allowed quantity: ' +is_site_existing.quantity)
                            }else{
                                is_site_existing.available_quantity = this.drawerSiteQuantity
                            }
                        }
                    } else {
                        if (is_site_existing == undefined) {
                            this.drawerCurrentSiteAllocation.push(
                                {'site_id': this.drawerSite.key,
                                "quantity": this.drawerSiteQuantity,
                                "code":this.drawerSite.code}
                            )
                            var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                            this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            if (total_site_quantity > this.selectedSiteAllocationProduct.quantity) {
                                this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                                this.drawerCurrentSiteAllocation.pop();
                            }else {
                                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            }
                            this.drawerSiteQuantity = ''
                            this.drawerSite = {key: 0, label: "Please select a site"}
                        } else {
                            this.siteAllocationErrors.push('Site already exists')
                        }
                    }
                }
            },
            selectDrawerSublocations (drawerSublocation) {
                var arr = {
                    key:drawerSublocation.key.replace('drawerSublocations',''),
                    label:drawerSublocation.label
                }
                drawerSublocation = arr
                Object.assign(this, {
                    drawerSublocation,
                    drawerSublocations: [],
                    fetching: false,
                })
            },
            selectDrawerSites (drawerSite) {
                var currencyDetails = this.drawerSites.find(c => parseInt(c.id) == parseInt(drawerSite.key.replace('drawerSites','')))
                var arr = {
                    key:drawerSite.key.replace('drawerSites',''),
                    label:drawerSite.label,
                    code:currencyDetails.code,
                }
                drawerSite = arr
                Object.assign(this, {
                    drawerSite,
                    drawerSites: [],
                    fetching: false,
                })
            },

            async fetchDrawerSublocations(){
                if (this.drawerSublocationSiteId) {
                    this.fetching = true
                    this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                    this.fetching = false
                }
            },

            async fetchDrawerSites(){
                this.fetching = true
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                this.fetching = false
            },
            isUrl(string) {
                var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
                //console.log("-----------")
                //console.log(res !== null)
                return (res !== null)
            },
            async fetchCurrencies() {
                this.fetching = true
                if(this.currencies.length <= 0 || this.forceFetchCurrency){
                    var params = '?default_currency='+this.hasDefaultCurrency
                    this.hasDefaultCurrency == true ? params+='&default_currency_id='+this.defaultCurrencyDetails.id : ""
                    try{
                        params += this.supplierDetails.currency_id!=undefined && this.supplierDetails.currency_id!=null ? '&currency_id='+this.supplierDetails.currency_id : ''
                    }catch (e){
                        console.log(e)
                    }
                    this.currencies = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_document_currencies' + params, null)
                    this.forceFetchCurrency = false
                }
                this.fetching = false
            },
            async selectCurrency (currency) {
                var arr = {
                    key:currency.key.replace('currencies',''),
                    label:currency.label
                }
                currency = arr
                var currencyDetails = this.currencies.find(c => parseInt(c.id) == parseInt(currency.key))
                var rate = currencyDetails.conversion || 0
                this.currencyRate = rate;
                Object.assign(this, {
                    currency,
                    fetching: false,
                    currencyDetails:currencyDetails,
                })
                await this.showConversionCurrencyRate()
                this.calculateSummary();
            },

            async saveRemark(){
                this.isEditing = true
                var documentPayload = {document_id: this.documentNumber, remark: this.remark}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/edit_remark', null, documentPayload)
                if(post_request.id > 0){
                    this.documentActionNotification('Save', 'success')
                }else{
                    this.documentActionNotification('Save', 'error')
                }
            },

            exportExcelDocument(){
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download("xlsx", this.currentDocumentTypeFriendlyCodeWithId+".xlsx", {sheetName:"Document"});
            },
            exportCsvDocument(){
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download("csv", this.currentDocumentTypeFriendlyCodeWithId+".csv", {delimiter:","});
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            pwsErrorMessages(errors) {
              if (this.currentDocumentTypeCode != "OTHPWS") return;

              if (!errors.validUniqueCodeHeader) {
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';
                const invalidSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'barcode' : 'stock no';
                this.massAddProductErrors.push(`Invalid ${invalidSaveVia} column. CSV first column must be ${currentSaveVia}`);
              }

              if (errors.invalidOrdering.length > 0)
                this.massAddProductErrors.push(`Invalid New Ordering in ${errors.uniqueCodeText}: ${errors.invalidOrdering.join(", ")}`);

              if (errors.invalidPrice.length > 0)
                this.massAddProductErrors.push(`Invalid New Price in ${errors.uniqueCodeText}: ${errors.invalidPrice.join(", ")}`);

              if (errors.negativeOrdering.length > 0)
                this.massAddProductErrors.push(`Negative New Ordering in ${errors.uniqueCodeText}: ${errors.negativeOrdering.join(", ")}`);

              if (errors.negativePrice.length > 0)
                this.massAddProductErrors.push(`Negative New Price in ${errors.uniqueCodeText}: ${errors.negativePrice.join(", ")}`);

              if (errors.negativeLanded.length > 0)
                this.massAddProductErrors.push(`Negative New Landed in ${errors.uniqueCodeText}: ${errors.negativeLanded.join(", ")}`);
            },
            pwsMassProductUploadValidation(lines, linePointer) {
              let validUniqueCodeHeader = true;
              let blankUniqueCodeCount = 0;
              let invalidOrdering = '';
              let invalidPrice = '';
              let negativeOrdering = '';
              let negativePrice = '';
              let negativeLanded = '';

              if (linePointer == 0) {
                const csvHeaders = lines[0].split(',');
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';

                if (csvHeaders[0].toString().toLowerCase() != currentSaveVia) validUniqueCodeHeader = false;

                return { validUniqueCodeHeader,
                         blankUniqueCodeCount, negativeLanded,
                         invalidOrdering, invalidPrice,
                         negativeOrdering, negativePrice };
              }


              const productLine = lines[linePointer].split(',');
              // Check if barcode/stock no is blank
              if (lines[linePointer].length > 0 && productLine[0].length == 0)
                blankUniqueCodeCount += 1

              if (blankUniqueCodeCount == 0) {
                const parsedOrdering = parseFloat(productLine[1])
                if (isNaN(parsedOrdering)) {
                  // Check if New Ordering is present
                  invalidOrdering = `${productLine[0]}`;
                } else if (parsedOrdering < 0) {
                  // Check if New Ordering is negative
                  negativeOrdering = `${productLine[0]}`;
                }

                const parsedLanded = parseFloat(productLine[2])
                if (!isNaN(parsedLanded) && parsedLanded < 0) {
                  // Check if New Landed is negative
                  negativeLanded = `${productLine[0]}`;
                }

                const parsedPrice = parseFloat(productLine[3])
                if (isNaN(parsedPrice)) {
                  // Check if New Price is blank
                  invalidPrice = `${productLine[0]}`;
                } else if (parsedPrice < 0) {
                  // Check if New Price is negative
                  negativePrice = `${productLine[0]}`;
                }
              }

              return { validUniqueCodeHeader,
                       blankUniqueCodeCount, negativeLanded,
                       invalidOrdering, invalidPrice,
                       negativeOrdering, negativePrice };
            },
            beforeUpload(file) {
                this.fileList = [];
                const reader = new FileReader();
                reader.onload = async e => {
                    //     this.processCsvMassAdd(e.target.result);
                    this.massAddProductErrors = [];
                    this.massAddProductErrorsDL = [];
                    this.csvData = '';

                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
                    let productCount = 0;
                    let blankUniqueCodeCount = 0;
                    let pwsErrors = { validUniqueCodeHeader: true, uniqueCodeText: '', invalidOrdering: [], invalidPrice: [],
                                      negativeOrdering: [], negativePrice: [], negativeLanded: [] }

                    const exemptedDocTypes = !["OTHPWS"].includes(this.currentDocumentTypeCode)

                    pwsErrors.uniqueCodeText = lines[0].split(',')[0];

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.');

                    for(var i = 0; i < lines.length; i++) {
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty') && exemptedDocTypes)
                            this.massAddProductErrors.push('Column names are incorrect and invalid.');

                        if(i > 0 && lines[i].includes(',') && exemptedDocTypes) {

                            if(typeof lines[i].split(',')[1] === 'string')
                                qtylist.push(parseInt(lines[i].split(',')[1]));
                            else
                                qtylist.push(parseInt(lines[i].split(',')[1]) || 0);

                            skulist.push(lines[i].split(',')[0]);

                            this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1]) || 0
                            if(i < lines.length)
                                this.csvData += '\n'
                        }

                        if (i > 0 && productCount == 0) {
                          // Check if there's any product present
                          productCount = lines[i].replace(",","").length;
                        }

                        if (this.currentDocumentTypeCode == "OTHPWS" && pwsErrors.validUniqueCodeHeader) {
                          const pwsValidation = this.pwsMassProductUploadValidation(lines, i);

                          if (!pwsValidation.validUniqueCodeHeader) {
                            pwsErrors.validUniqueCodeHeader = false;
                            break;
                          }

                          blankUniqueCodeCount += pwsValidation.blankUniqueCodeCount;
                          if (pwsValidation.invalidOrdering) pwsErrors.invalidOrdering.push(pwsValidation.invalidOrdering);
                          if (pwsValidation.invalidPrice) pwsErrors.invalidPrice.push(pwsValidation.invalidPrice);
                          if (pwsValidation.negativeOrdering) pwsErrors.negativeOrdering.push(pwsValidation.negativeOrdering);
                          if (pwsValidation.negativePrice) pwsErrors.negativePrice.push(pwsValidation.negativePrice);
                          if (pwsValidation.negativeLanded) pwsErrors.negativeLanded.push(pwsValidation.negativeLanded);
                        }

                        if (!exemptedDocTypes) {
                            this.csvData += lines[i] + '\n'
                        }
                    }
                    // console.log(this.csvData)
                    // Get duplicate sku's/barcode
                    const findDuplicates = (skulist) => {
                        let sorted_arr = skulist.slice().sort();
                        let results = [];
                        for (let i = 0; i < sorted_arr.length - 1; i++) {
                            if (sorted_arr[i + 1] == sorted_arr[i]) {
                                results.push(sorted_arr[i]);
                            }
                        }
                        return results;
                    }

                    // Result duplicate sku's/barcode -> download list
                    if(findDuplicates(skulist).length > 0) {
                        this.massAddProductErrors.push('With duplicate Barcodes');
                        this.dlDUplicateSkus = 1
                        this.dlDUplicateSkusItems = findDuplicates(skulist)
                        this.massAddProductErrorsDL.push('With duplicate Barcodes');
                    } else {
                        this.dlDUplicateSkus = 0
                    }

                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else if(qty == 0 && this.currentDocumentTypeCode == 'OTHPCN')
                            return false
                        else
                            return qty < 1
                    });

                    // Result 0 / - quantity

                    // 2021-08-23 - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1686
                    // Allow 0 quantity for PCOUNT document [OTHPCN]
                    if(zQty.length > 0 && exemptedDocTypes){
                      this.massAddProductErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }

                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);

                    // Result blank skus
                    if(bSku.length > 0 && exemptedDocTypes)
                        this.massAddProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Check if PWS Uploaded file has no product indicated
                    if (productCount == 0)
                        this.massAddProductErrors.push('File has no data');

                    // Check if PWS Uploaded file has some lines without barcode/stock no
                    if (blankUniqueCodeCount > 0)
                        this.massAddProductErrors.push(`${blankUniqueCodeCount} blank ${lines[0].split(',')[0]}`);

                    // Render PWS Error messages if there's any
                    this.pwsErrorMessages(pwsErrors);

                    // Check if CSV has no error
                    // Proceed validating if barcodes are valid

                    if(this.massAddProductErrors.length < 1){
                      this.spinning = true;

                      // Hot Fix - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1639
                      // Check supplier in header if exist for product mass update
                      if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp) {
                        await this.getSuppItems(skulist)
                      } else {
                        this.spinning = false;
                      }

                      if (this.massAddProductErrors.length == 0 && this.massAddProductErrorsDL.length == 0) {
                        this.fileList = [...this.fileList, file];
                      }
                    }
                    this.massAddProductErrors = this._.compact(this.massAddProductErrors);

                };
                reader.readAsText(file);
                this.spinning = false;
                return false;
            },
            async getSuppItems(skulist){
                const supplier_param = (this.supplier.key != null && this.supplier.key != "") ? "supplier_ids="+this.supplier.key+"&" : ""
                // var suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&type=document", null);
                let suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products/check_supplier_products?"+supplier_param+"per_page=500", null);
                let supplierProducts = suppItems.products || [];
                var pageCount = suppItems.total_pages
                this.suppItems = [];

                supplierProducts.map(product => {
                  this.suppItems.push(product.barcode)
                })

                // Get succeeding records
                if(pageCount > 1) {
                  for (var i = 2; i <= pageCount; i++) {
                    // suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&page="+i+"&type=document");
                    suppItems = await HTTPRequest.getRequest(`${component_x.endPoint}products/check_supplier_products?${supplier_param}per_page=500&page=${i}`, null);
                    supplierProducts = suppItems.products || [];
                    supplierProducts.map(product => {
                      this.suppItems.push(product.barcode)
                    })
                  }
                }

                let errorBarcodes = []
                this.spinning = false;
                skulist.map(item => {
                  if (!this.suppItems.includes(item)) {
                    errorBarcodes.push(item);
                  }
                })

                const arrNF = skulist.filter(i => !this.suppItems.includes(i))
                if(arrNF.length > 0) {
                    this.massAddProductErrors.push(`The following barcodes are not under the selected supplier or does not exist: ${arrNF.join(', ')}`);
                    this.massAddProductErrorsDL.push('With duplicate Barcodes');
                    this.dlSkusNotFound = 1
                    this.dlSkusNotFoundItems = arrNF
                }

                return true;
            },
            importFile(){
                this.spinning = true;
                const reader = new FileReader();
                reader.onload = e => {
                    // this.processCsvMassAdd(e.target.result);
                    this.processCsvMassAdd(this.csvData);
                };
                reader.readAsText(this.fileList[0]);
                this.spinning = false;
                this.documentStatus = 'Uploading';
                return false;
            },
            async processCsvMassAdd(csvtext){
                this.spinning = true;
                this.CsvUploadParams = {'csv_lines': csvtext, 'import_mode': this.importMode}
                this.processingCsvUpload = true
                if (this.documentNumber > 1) {
                    this.update();
                } else {
                    this.save();
                }

                this.spinning = false;
                this.closeDrawer('massAdd');
            },
            subscribe(){
                var pusher = new Pusher('b74fa07f1048125271b8', {
                  cluster: 'ap1'
                });
                pusher.subscribe('my-channel')
                pusher.bind('my-event', data => {
                    // Delivery Document # "+ data.message.order.points[0].client_order_id + "
                    this.bookingDetails = data.message
                    // this.$notification['info']({
                    //   message: 'Status Change',
                    //   description: "Your booking status has changed."
                    // });
                })
            },
            haversineDistance(coords1, coords2, isMiles) {
                function toRad(x) {
                  return x * Math.PI / 180;
                }

                var lon1 = coords1[0];
                var lat1 = coords1[1];

                var lon2 = coords2[0];
                var lat2 = coords2[1];

                var R = 6371; // km

                var x1 = lat2 - lat1;
                var dLat = toRad(x1);
                var x2 = lon2 - lon1;
                var dLon = toRad(x2)
                var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                  Math.sin(dLon / 2) * Math.sin(dLon / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;

                if(isMiles) d /= 1.60934;

                return d;
            },
            handleDestinationChange(location){
                var newPosition = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng()
                }
                var distance = this.haversineDistance([newPosition.lng, newPosition.lat], [this.originalGeoLocation[1].position.lng, this.originalGeoLocation[1].position.lat], false)
                if(distance < 1){
                    this.markers[1].position = newPosition;
                } else {
                    this.markers[1].position = this.originalGeoLocation[1].position;
                    this.mapKey++;
                    this.$message['error'](
                      "Cannot pin to new location. Distance from original should be within 1 km radius."
                    )
                }

                this.recompute = true;
            },
            getFromAddress(from_address, placeResultData, id) {
                this.from_address = from_address;
            },
            getToAddress(to_address, placeResultData, id){
                this.to_address = to_address;
            },
            handleError(error){
                alert(error)
            },
            filteredBySupplierChange(e){
                this.filteredBySupplier = e.target.checked
            },
            selectCustomerContact(value){
                switch(value) {
                    case 'Telephone':
                        this.activeCustomerContact = this.customerContactTelephone
                        break;
                    case 'Mobile':
                        this.activeCustomerContact = this.customerContactMobile
                        break;
                    case 'Fax':
                        this.activeCustomerContact = this.customerContactFax
                        break;
                    case 'Email':
                        this.activeCustomerContact = this.customerContactEmail
                        break;
                }
            },
            createCustomer(){
                this.customerDrawerVisible = true
                this.customerDrawerKey++
            },
            onClose() {
                this.errors = [];
                this.customerDrawerVisible = false
                this.customerDrawerKey++
            },
            // closeDrawer(){
            //     this.onClose()
            // },
            async refreshPage(event) {
                var new_customer_data = JSON.parse(event.target.response)
                if (new_customer_data.id > 0 && new_customer_data.name != undefined) {
                    this.customer = {key: new_customer_data.id, label: new_customer_data.name}
                    if (new_customer_data.id){
                        var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+new_customer_data.id, null);
                        this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                        this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                        this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                        this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                        this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                        this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                        this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                        this.isProductSearchDisabled = false;
                    }
                }

                this.onClose()
                this.documentActionNotification('Create customer', 'success')
            },
            moment,
            selectForThisSite (forThisSite) {
              let arr = {
                key:forThisSite.key.replace('forThisSites',''),
                label:forThisSite.label
              }
              forThisSite = arr
              Object.assign(this, {
                forThisSite,
                forThisSites: [],
                fetching: false,
              })
            },
            showApplyDocumentToOtherSitesButton() {
              if (this.header.showApplyDocumentToOtherSitesButton &&
                  this.documentStatus == "Confirmed") {
                return true;
              }
              return false;
            },
            toggleApplyDocumentToOtherSitesDrawer(open) {
              this.applyDocumentToOtherSitesDrawer = open;
            },
            showStockCard(product){
                this.stockCardVisible = true
                this.selectedStockCardProduct = product[0].product_id;
                this.stockCardKey++;
            },
            async recalculateLine(product_id){
                var data = this.tabulator.getData();
                var line_no = data.find(item => product_id === item.product_id).line_no
                if(data.find(item => line_no === item.line_no)){
                    //Quantity Change
                    var cost = data.find(item => line_no === item.line_no).cost
                    var quantity = data.find(item => line_no === item.line_no).quantity
                    var subtotal = Number(quantity) * Number(cost)
                    await this.tabulator.updateData([{product_id: product_id, subtotal: subtotal}])

                    //Discount Change and Unit Cost Change
                    var discount_text = _.compact((data.find(item => line_no === item.line_no).discount_text).split(','));
                    var discountTotal = 0;
                    var unitNetCost = data.find(item => line_no === item.line_no).price
                    var decimalPlaces = this.decimalPlaces
                    if (discount_text.length > 0) {
                        var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                        var numberRegex = /^[0-9]+(\.[0-9][0-9]?)?$/;
                        // eslint-disable-next-line
                        var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                        discount_text.forEach(function(row) {
                            var discount;
                            var discountAmount;
                            if (lessDiscount.test(row)) {
                                discount = row.slice(1)
                                discountAmount = (unitNetCost) - (discount)
                                unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                            } else if (numberRegex.test(row)) {
                                discount = row;
                                discount = (discount / quantity)
                                discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discountAmount = (unitNetCost) * (discount / 100)
                                unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                            }
                            if (lessDiscount.test(row)) {
                                discountTotal = discountTotal + (discount * quantity);
                            } else {
                                discountTotal = discountTotal + (discountAmount * quantity);
                            }

                        });
                    }

                    if (this.currentDocumentTypeCode =='RELDDE') {
                        if (unitNetCost < 0) unitNetCost = 0
                        subtotal = (quantity * unitNetCost).toFixed(this.decimalPlaces)
                        await this.tabulator.updateData([{product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal}])
                    } else {
                        if (unitNetCost < 0) unitNetCost = 0
                        var totalGross = data.find(item => line_no === item.line_no).total_gross
                        if (discountTotal >= totalGross) discountTotal = totalGross
                        subtotal = (quantity * unitNetCost).toFixed(this.decimalPlaces)

                        await this.tabulator.updateData([{product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal, total_gross: totalGross}])
                    }
                }
            },
            async saveDrawerSerialization() {
              this.currentDrawerSerials = this.currentDrawerSerials.filter(item => item.status == "A")
              await this.tabulator.updateData([{ product_id: this.selectedSerialProduct.product_id, quantity: this.currentDrawerSerials.length, document_line_serials: this.currentDrawerSerials }])
              //Recalculate
              await this.recalculateLine(this.selectedSerialProduct.product_id)
              this.calculateSummary();
              this.serializationVisible = false
                // this.closeDrawer('serialization');
            },
            async submitDrawerSerials() {
                //  ------CHECKING IF SERIAL EXIST IN A PRODUCT
                // console.log("---PRODUCT")
                // console.log(this.selectedSerialProduct)

                var ctr_chk = 0
                var releasing_documents = ["RELTRX", "RELADJ", "RELCSI", "ORISOX", "RELSLO", "RELDDE"]
                if( !releasing_documents.includes(this.currentDocumentTypeCode) ){
                    var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + `inventory_serials?product_id=${this.selectedSerialProduct.product_id}&serial_no=${this.inputSerialNumber}&status=A`, null);
                    ctr_chk = inventory_serials.data.length
                }

                if( ctr_chk > 0){
                    this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Cannot add serial. Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                    // alert("Cannot add serial. Serial already exist.")
                } else {
                    if (this.currentDocumentTypeCode.includes("REL")) {
                       var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            exists.status = "A"
                            this.inputSerialNumber = ''
                        } else {
                            this.inputSerialNumber = ''
                        }
                    } else {
                        var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                        } else {
                            this.currentDrawerSerials.push({line_no: this.selectedSerialProduct.line_no, serial_no: this.inputSerialNumber, status: "A"})
                        }
                        this.inputSerialNumber = ''
                    }
                }
            },
            async showSerialization(product){
                var site_id = secureStorage.getItem("defaultSiteId");
                this.selectedSerialProduct = product[0];
                if (this.currentDocumentTypeCode.includes("REL")) {
                    if (product[0].document_line_serials) {
                        var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);
                        var selected = product[0].document_line_serials.map(x => x.serial_no)
                        var not_selected = inventory_serials.filter(item => !selected.includes(item.serial_no))
                        var merged = product[0].document_line_serials.concat(not_selected)
                        this.currentDrawerSerials = merged;
                    } else {
                        var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);
                        this.currentDrawerSerials = inventory_serials;
                    }
                } else {
                    if (this.documentStatus == null) {
                        this.currentDrawerSerials = product[0].document_line_serials || [];
                    } else {
                        if (product[0].document_line_serials) {
                            this.currentDrawerSerials = product[0].document_line_serials || [];
                        } else {
                            var document_line_serials = await HTTPRequest.getRequest(component_x.endPoint + "document_line_serials/?document_line_id="+product[0].id, null);
                            this.currentDrawerSerials = document_line_serials.data;
                        }
                    }
                }
                this.updatedSerialCount = Number(product[0].quantity)
                this.currentDrawerSerialsInstance = [...this.currentDrawerSerials]
                this.serializationVisible = true
                this.serializationKey++;
            },
            async showDocumentPayment(status){
                var document_payments = await HTTPRequest.getRequest(component_x.endPoint + "document_payments?document_id="+this.documentNumber, null);
                this.documentPaymentsList = document_payments["data"]
                if(status==undefined){
                    this.documentPaymentsDrawerVisible = true
                    this.documentPaymentsKey++;
                }
            },
            async showSublocationAllocation(product){
                this.sublocationAllocationVisible = true
                this.selectedSublocationAllocationProduct = product[0];
                this.sublocationAllocationKey++;

                var document_type_code = '';
                var document_trans_code = '';
                var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                    document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                    document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                }

                var site_id = secureStorage.getItem("defaultSiteId");
                if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                    site_id = this.distributionSite.key
                }
                if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' )){
                    site_id = this.supplyingSite.key
                }
                if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX' )){
                    site_id = this.requestingSite.key
                }
                if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                    site_id = this.forThisSite.key
                }

                this.drawerSublocationSiteId = (this.drawerSublocationSiteId > 0) ? this.drawerSublocationSiteId : site_id

                this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                if (product[0].sublocation_allocation != undefined) this.drawerCurrentSublocationAllocation = product[0].sublocation_allocation
            },
            async showSiteAllocation(product){
                this.siteAllocationVisible = true
                this.selectedSiteAllocationProduct = product[0];
                this.siteAllocationKey++;

                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                if (product[0].site_allocation != undefined) this.drawerCurrentSiteAllocation = product[0].site_allocation
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            async showLotCodeExpiry(product){
                this.selectedLotCodeExpiryProduct = product[0];
                if (this.documentStatus == null) {
                    this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                } else {
                    if (product[0].document_line_locations) {
                        this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                    } else {
                        var document_line_locations = await HTTPRequest.getRequest(component_x.endPoint + "document_line_locations/?document_line_id="+product[0].id, null);
                        this.currentDrawerLotCodeExpiry = document_line_locations.data;
                    }
                }

                //If REL documents  - retrieve lotcode per site per item
                if(this.isLotCodeExpiryDisabled) {
                    var lotCodes = await HTTPRequest.getRequest(component_x.endPoint + "inventories/site_product_inventory_with_lotcode_expiry?product_id="+ product[0].product_id +"&product_type=" + product[0].product_type +"&site_id=" + secureStorage.getItem("defaultSiteId"), null);
                    this.lotcodeSources = lotCodes;
                }

                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })

                this.lotCodeExpiryVisible = true
                //if (product[0].document_line_lotcode != undefined) this.drawerLotCode = product[0].document_line_lotcode;
                //if (product[0].document_line_expiry != undefined) this.drawerExpiryAt = product[0].document_line_expiry;
                //if (product[0].document_line_locations != undefined && product[0].document_line_locations.length > 0){
                //    this.drawerLotCode = product[0].document_line_locations[0].lot_code
                //    this.drawerExpiryAt = product[0].document_line_locations[0].expiry_at
                //}
                this.lotCodeExpiryKey++;
            },
            handleScroll () {
                var regular = document.getElementsByClassName("regular-header");
                var sticky = document.getElementsByClassName("sticky-header");
                if(window.scrollY>=160){
                    regular[0].style.visibility = 'hidden';
                    sticky[0].style.visibility = 'visible';
                } else {
                    regular[0].style.visibility = 'visible';
                    sticky[0].style.visibility = 'hidden';
                }
            },
            rowSelectionChanged(data, rows){
                this.selectedDocumentLines = data
                this.selectedDocumentLineRows = rows
            },
            totalGrossMutator(value, data){
                var total_gross = data.quantity * data.price
                return total_gross;
            },
            searchProducts(){
                if (this.productSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilter
                    this.tabulator.addFilter(this.searchFilter, "like", this.productSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            searchAddedProducts(){
                if (this.addedProductSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilterAddedProduct
                    this.tabulator.addFilter(this.searchFilterAddedProduct, "like", this.addedProductSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            validateTableDiscount(cell, value){
                var discount_text = value.split(',');
                var isValid = true
                // eslint-disable-next-line
                var discountRegex = /(^L[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?\%$)/;
                if (discount_text != '') {
                    discount_text.forEach(function(row) {
                        if (!discountRegex.test(row)) isValid = false;
                    });
                }
                return isValid;
            },
            isCellEditable(cell){
                var column = cell.getColumn().getField();
                if ((this.documentStatus == 'Posted' ) || (this.documentStatus == 'Voided' ) || (this.documentStatus == 'Confirmed') || this.currentDocumentTypeCode=="OTHSIN"){
                    return false
                } else {
                    if (!this.accessRights.includes('W')){
                        return false
                    } else {
                        if (this.currentDocumentTypeCode=="RELDDE") {
                            if (this.documentNumber > 0) {
                                if (column == 'goods_issue_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                if (column == 'delivery_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            }
                        }
                        else if(this.currentDocumentTypeCode=="ORISOX"){
                            if (column == 'price') {
                                return false
                            } else {
                                return true
                            }
                        }
                        else if(this.currentDocumentTypeCode=="OTHSBI"){
                            if (column == 'price_pi') {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="RECCSR"){
                            if (column == 'remarks' || column == 'quantity') {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="OTHPCK"){
                            if (column == 'quantity') {
                                if (this.originDocumentNumber > 0){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else if(this.currentDocumentTypeCode=="ORORSO"){
                            if (column == 'requested_quantity') {
                                if (secureStorage.getItem("defaultSiteId").toString() == this.requestingSite.key && this.forThisSite.key != secureStorage.getItem("defaultSiteId").toString()){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else {
                            return true
                        }
                    }
                }
            },
            validateQuantity(cell, value){
                    console.log(this.currentDocumentTypeCode)
                if (value < 0){
                    return false;
                }else {
                    var field = cell._cell.column.field;
                    var ordered_quantity = 0;
                    var actual_quantity = 0;
                    var quantity = 0;
                    var isValid = true;
                    console.log(this.currentDocumentTypeCode)
                    if (this.currentDocumentTypeCode=="RELDDE"){
                        if (value > 0){
                            if (field == 'delivery_quantity'){
                                if (this.isOrderSourceMode) {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                } else {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    actual_quantity = cell._cell.row.data.actual_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value > actual_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                }
                            } else if (field == 'goods_issue_quantity') {
                                ordered_quantity = cell._cell.row.data.ordered_quantity
                                if (value > Number(ordered_quantity)) isValid = false
                                if (value < 1) isValid = false
                                return isValid;
                            } else{
                                return true;
                            }
                        }else {
                            return true;
                        }
                    } else {
                        if (field == 'quantity') {
                            if (value < 0) isValid = false
                            return isValid;
                        }else {
                            return true;
                        }
                    }
                }
            },
            //event when document line table has been edited
            async tabulatorCellEdit(e){
                this.isEditing = true;
                const { field } = e._cell.column
                if(field === "quantity"){
                  const { product_type } = e._cell.row.data
                  const { value: quantity, oldValue:oldQuantity} = e._cell
                  if (product_type === "S") {
                    this.showSerialization([{...e._cell.row.data, quantity, oldQuantity}])
                  }
                }
               
                var product_id = e._cell.row.data.product_id
                var line_no = e._cell.row.data.line_no

                if (e._cell.column.field == 'delivery_quantity'){
                    await this.tabulator.updateData([{product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (e._cell.column.field == 'goods_issue_quantity'){
                    await this.tabulator.updateData([{product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"){
                  // Insert code here
                }else{
                    if (e._cell.column.field == 'unit_id'){
                        var productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+e._cell.row.data.product_id+'/get_product_unit_compositions', null)
                        var selectedUnit = Number(e._cell.value)
                        var selectedProductId = productCompositions.find(x => x.unit_id == selectedUnit).key
                        var selectedProduct = await HTTPRequest.getRequest(this.endPoint + '/products/'+ selectedProductId);

                        var unitCost = eval('selectedProduct.'+this.productPriceChoice)
                        var unitNetCost = eval('selectedProduct.'+this.productPriceChoice)

                        // var site_id = secureStorage.getItem("defaultSiteId");
                        // var isRel = this.currentDocumentTypeCode.includes("REL");
                        // var isRec = this.currentDocumentTypeCode.includes("REC");
                        // if (isRel || isRec) {
                        //     var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+selectedProductId+'&site_id='+site_id, null)
                        //     if (inventory_cost.cost && Number(inventory_cost.cost) != 0){
                        //         unitCost = inventory_cost.cost
                        //         unitNetCost = inventory_cost.cost
                        //     } else {
                        //         unitCost = unitCost
                        //         unitNetCost = unitNetCost
                        //     }
                        // }else {
                        //     unitCost = unitCost
                        //     unitNetCost = unitNetCost
                        // }

                        if (selectedProduct){
                            this.notifMessage = []
                            if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                                var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+selectedProduct.id+'&site_id='+this.supplyingSite.key, null)
                                if (inventory.error) {
                                    this.notifMessage.push(inventory.error)
                                    this.documentActionNotification('Add document line', 'error')
                                    e.restoreOldValue();
                                    return
                                } else{
                                    this.delete_line(e._cell.row.data.line_no)
                                    var onHandQuantity = inventory.quantity
                                    var productName = selectedProduct.name
                                    var quantity = 1
                                    unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                                    var discountText = []
                                    unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                                    var discountTotal = 0
                                    var subTotal =  (quantity * unitCost).toFixed(this.decimalPlaces)

                                    this.addRegularProduct(selectedProduct, productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, onHandQuantity, '', '', 0);
                                }
                            }
                        }
                    }

                    if (e._cell.column.field == 'markup_percent'){
                    let landedCost = e._cell.row.data.landed_cost;
                    let markUpPercent = e._cell.value;
                    let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);
                    if (newRetailPrice < 0) newRetailPrice = 0;
                    await this.tabulator.updateData([{product_id: product_id, retail_price: newRetailPrice}]);
                    }

                    if (e._cell.column.field == 'landed_cost'){
                    let landedCost = e._cell.value;
                    let retailPrice = e._cell.row.data.retail_price;
                    let markUpPercent = '';
                    if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                        markUpPercent = 0;
                        if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                    }
                    if (markUpPercent < 0) markUpPercent = 0;
                    await this.tabulator.updateData([{product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    if (e._cell.column.field == 'retail_price'){
                    let landedCost = e._cell.row.data.landed_cost;
                    let retailPrice = e._cell.value;
                    let markUpPercent = '';
                    if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                        markUpPercent = 0;
                        if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                    }
                    if (markUpPercent < 0) markUpPercent = 0;
                    await this.tabulator.updateData([{product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    var data = this.tabulator.getData();

                    if(data.find(item => line_no === item.line_no)){
                        //Quantity Change
                        var cost = data.find(item => line_no === item.line_no).cost
                        quantity = data.find(item => line_no === item.line_no).quantity
                        var subtotal = Number(quantity) * Number(cost)

                        // Recalculate subtotal_without_vat, price_without_vat, tax_amount
                        var subtotal_without_vat = data.find(item => line_no ===item.line_no).subtotal_without_vat * quantity
                        var price_without_vat = data.find(item => line_no ===item.line_no).price_without_vat * quantity
                        var tax_amount =  data.find(item => line_no ===item.line_no).tax_amount * quantity

                        await this.tabulator.updateData([{product_id: product_id, subtotal: subtotal,subtotal_without_vat:subtotal_without_vat, price_without_vat:price_without_vat, tax_amount:tax_amount}])

                        //Discount Change and Unit Cost Change
                        var discount_text = data.find(item => line_no === item.line_no).discount_text
                        if (discount_text !=null){
                            discount_text.split(',')
                        }
                        discount_text = _.compact(discount_text);
                        discountTotal = 0;
                        unitNetCost = data.find(item => line_no === item.line_no).price
                        var decimalPlaces = this.decimalPlaces
                        if (discount_text.length > 0) {
                            var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                            var numberRegex = /^[0-9]+(\.[0-9][0-9]?)?$/;
                            // eslint-disable-next-line
                            var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                            discount_text.forEach(function(row) {
                                var discount;
                                var discountAmount;
                                if (lessDiscount.test(row)) {
                                    discount = row.slice(1)
                                    discountAmount = (unitNetCost) - (discount)
                                    unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                } else if (numberRegex.test(row)) {
                                    discount = row;
                                    discount = (discount / quantity)
                                    discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                    unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                } else if (percentDiscount.test(row)) {
                                    discount = row.slice(0,-1)
                                    discountAmount = (unitNetCost) * (discount / 100)
                                    unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                }
                                if (lessDiscount.test(row)) {
                                    discountTotal = discountTotal + (discount * quantity);
                                } else {
                                    discountTotal = discountTotal + (discountAmount * quantity);
                                }

                            });
                        }
                        if (this.currentDocumentTypeCode =='RELDDE') {
                            if (unitNetCost < 0) unitNetCost = 0
                            subtotal = (quantity * unitNetCost).toFixed(this.decimalPlaces)
                            await this.tabulator.updateData([{product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal}])
                        } else {
                            if (unitNetCost < 0) unitNetCost = 0
                            var totalGross = data.find(item => line_no === item.line_no).total_gross
                            if (discountTotal >= totalGross) discountTotal = totalGross
                            subtotal = (quantity * unitNetCost).toFixed(this.decimalPlaces)

                            await this.tabulator.updateData([{product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal, total_gross: totalGross}])
                        }
                    }
                    this.calculateSummary();
                }
            },
            async populateMatrixItems(selectedProduct, productName, quantity, paramDiscountText) {
                window.scrollTo(0,0);
                this.spinning = true;
                this.spinMessage = 'Loading matrix items from ' + productName;
                // let unit_supplier_ordering_cost;
                // let site_product_cost;

                // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                //     // console.log(this.unitCost, isRel, isRec, this.productPriceChoice,eval('group.selectedObject.'+this.productPriceChoice))
                //     // if docType check alternate_sup of this product
                //     var site_id = secureStorage.getItem("defaultSiteId");
                //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProduct.id + '&site_id=' + site_id);

                //     if(site_product != null){
                //         var siteProductCost = eval('site_product.'+this.productPriceChoice)
                //         site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                //     }

                //     if(this.supplier.key != null && selectedProduct.id != null && this.productPriceChoice == 'ordering_cost'){
                //         var supp_id = Number(this.supplier.key)
                //         var alternate_supplier = await HTTPRequest.getRequest(this.endPoint + 'supplier_products/get_alternate_supplier?product_id=' + selectedProduct.id + '&supplier_id=' + supp_id)
                //         if(alternate_supplier != null && alternate_supplier.ordering_cost > 0){
                //             // this.unitCost = alternate_supplier.ordering_cost
                //             // this.unitNetCost = alternate_supplier.ordering_cost
                //             unit_supplier_ordering_cost = Number(alternate_supplier.ordering_cost).toFixed(this.decimalPlaces)
                //         }
                //         // if alternate_sup exist use this ordering_cost if productPriceChoice is Ordering Cost
                //     }
                // }

                var params = '/products/get_matrix_items?matrix_parent_id='+selectedProduct.id+'&matrix_item=1';
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                if (selectedProducts.length > 0){
                    for (let i = 0; i < selectedProducts.length; i++) {
                        var productName = selectedProducts[i].name
                        // unitcost equals to retail price note
                        var unitCost = eval('selectedProducts[i].'+`${this.productPriceChoice}`)
                        var discountText = []
                        var unitNetCost = eval('selectedProducts[i].'+`${this.productPriceChoice}`)

                        // for alternate supplier costing
                        if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts[i].matrix_parent_id + '&site_id=' + this.requestingSite.key);
                                    
                            if(site_product != null){
                                let siteProductCost = eval('site_product.'+this.productPriceChoice)
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                                if(Number(this.supplier.key) != Number(selectedProducts[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts[i].matrix_parent_id+ '&supplier_id=' + this.supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)

                        if(this.costUpdated){
                            unitCost = this.unitCost
                            unitNetCost = this.unitCost
                        }

                        // if(site_product_cost && site_product_cost > 0){
                        //     unitCost = site_product_cost
                        //     unitNetCost = site_product_cost
                        // }

                        // if(unit_supplier_ordering_cost && unit_supplier_ordering_cost > 0){
                        //     unitCost = unit_supplier_ordering_cost
                        //     unitNetCost = unit_supplier_ordering_cost
                        // }
                        var notifMessage = []
                        if (paramDiscountText.length > 0) {
                            // eslint-disable-next-line
                            var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                            var discountText = paramDiscountText.join();
                            discountText = discountText.split(',');

                            discountText.forEach(function(row) {
                                if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                            });

                            if (notifMessage.length == 0) {
                                var lessDiscount = /^L[0-9]+$/;
                                var numberRegex = /^[0-9]+$/;
                                // eslint-disable-next-line
                                var percentDiscount = /^[0-9]+\%$/;

                                var unitNetCost = unitCost
                                var quantity = quantity
                                var discountTotal = 0;
                                var decimalPlaces = this.decimalPlaces

                                discountText.forEach(function(row) {
                                    var discount;
                                    var discountAmount;
                                    if (lessDiscount.test(row)) {
                                        discount = row.slice(1)
                                        discountAmount = (unitNetCost) - (discount)
                                        unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    } else if (numberRegex.test(row)) {
                                        discount = row;
                                        discount = (discount / quantity)
                                        discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                        unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discountAmount = (unitNetCost) * (discount / 100)
                                        unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    }
                                    if (lessDiscount.test(row)) {
                                        discountTotal = discountTotal + (discount * quantity);
                                    } else{
                                        discountTotal = discountTotal + (discountAmount * quantity);
                                    }
                                });
                                if (unitNetCost < 0) unitNetCost = 0
                                unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                                var subTotal = (this.quantity * this.unitNetCost).toFixed(this.decimalPlaces)
                                discountTotal = discountTotal
                            } else {
                                paramDiscountText.pop();
                                this.notifMessage = notifMessage
                                this.documentActionNotification('Document line discount', 'error')
                            }
                        }else {
                            var subTotal = (this.quantity * unitCost).toFixed(this.decimalPlaces)
                        }
                        // this.unitCost gets whats in price
                        this.addRegularProduct(selectedProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", 1);
                    }

                    this.calculateSummary();
                    this.$refs.autocomplete.clear();
                    this.clearProduct();
                }
                this.spinning = false;
                this.costUpdated = false;
                this.spinMessage = 'Loading...';
            },

            // function to clear current document line upon clicking "OK" on modal
            clearDocumentLine(){
              this.popUpModal.isVisible = false
              this.spinning = true;
              this.spinMessage = 'Clearing document lines'
              const data = this.tabulator.getRows()
              setTimeout(()=>{
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                  })  
              this.spinning = false;  
              this.spinMessage = 'Loading...'
              this.calculateSummary()
              this.populateBySupplier(this.supplier)
              },500)  
            },

            checkDocumentLine(){
              // validate if document line is currently filled
                if(this.tabulator.getRows().length > 0){
                 this.popUpModal.isVisible = true 
                 this.popUpModal.initializeProcess = this.clearDocumentLine
                 this.popUpModal.message = "Do you want to overwrite existing item(s)?"
                 this.popUpModal.text = "Click 'OK' to overwrite , 'Cancel' to retain current list and add item(s) below"
                 this.popUpModal.toClear = true
                }
               if(this.tabulator.getRows().length === 0){
                this.popUpModal.isVisible = true 
                this.popUpModal.initializeProcess = ()=>{this.populateBySupplier(this.supplier) } 
                this.popUpModal.message = "Auto Populate By Supplier"
                this.popUpModal.text = "Are you sure you want to populate the products from this supplier?"
               }

            },
           
            async populateBySupplier(supplier){
               this.popUpModal.isVisible = false
               this.showAddingProgress.isVisible = true
                // window.scrollTo(0,0);
                // this.spinning = true;
                // this.spinMessage = 'Loading products from ' + supplier.label;
                var params = '/products/?per_page=200&supplier_id='+supplier.key+'&all=1';
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    params += '&is_non_trade=' + !this.isDocumentTrade;
                }
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                this.showAddingProgress.productCount = selectedProducts.data.length
                if (selectedProducts.data.length > 0){
                  for (let i = 0; i < selectedProducts.data.length; i++) {
                        this.showAddingProgress.productAdded = (i + 1)
                        var productName = selectedProducts.data[i].name
                        var quantity = 1.0
                        var unitCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        var discountText = []
                        var unitNetCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        // unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        // var discountTotal = 0

                        // // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1927
                        // // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1871#note_82568
                        // //In PO Document, if the selected supplier is the main supplier:
                        // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                        //     // Check first if the current site have site price/cost, if none, use the product (main).
                        //     // Check first if the current site have site price/cost, if none, use the product (main).
                        //     // If the selected supplier is not main supplier or not alternate supplier:
                        //     var site_id = secureStorage.getItem("defaultSiteId");
                        //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts.data[i].id + '&site_id=' + site_id);

                        //     if(site_product != null){
                        //         var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                        //         var siteUnitNetCost = eval('site_product.'+this.productPriceChoice)
                        //         if(siteUnitCost > 0 || siteUnitNetCost > 0){
                        //             unitCost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                        //             unitNetCost = Number(siteUnitNetCost).toFixed(this.decimalPlaces)
                        //         }
                        //     }
                        //     // If the selected supplier is alternate supplier (with record in product_suppliers), get the ordering cost in the product_suppliers table
                        //     if(this.productPriceChoice == 'ordering_cost' && selectedProducts.data[i].supplier_product_ordering_cost != null){
                        //         if(selectedProducts.data[i].supplier_product_ordering_cost > 0){
                        //             unitCost = Number(selectedProducts.data[i].supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                        //             unitNetCost = Number(selectedProducts.data[i].supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                        //         }
                        //     }
                        // }
                        
                        // for alternate supplier costing
                        if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts.data[i].id + '&site_id=' + this.requestingSite.key);
                                    
                            if(site_product != null){
                                let siteProductCost = eval('site_product.'+this.productPriceChoice)
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(supplier != null && supplier != undefined && supplier != ""){
                                if(Number(supplier.key) != Number(selectedProducts.data[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts.data[i].id+ '&supplier_id=' + supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(selectedProducts.data.length == (i+1))
                            var triggerCompute = 0
                        else
                            var triggerCompute = 1
                        this.addRegularProduct(selectedProducts.data[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", triggerCompute);
                    }
                }
                this.spinning = false;
                this.spinMessage = 'Loading...';
                this.showAddingProgress.isVisible = false
                this.showAddingProgress.productAdded = 0
                this.showAddingProgress.productCount = 0

               setTimeout(()=>{ 
                // Prompt how many product/s are successfully populated.
                 this.popUpModal.isVisible = true 
                 this.popUpModal.isAutoPopulate = true 
                 this.popUpModal.initializeProcess = () => {
                  this.popUpModal.isVisible = false
                  this.popUpModal.isAutoPopulate = false
                }
                 this.popUpModal.message = `Auto-populate Successful`
                 this.popUpModal.text = `${selectedProducts.data.length} Item(s) added to list`
                // alert(`${selectedProducts.data.length} Product(s) has been added to list.`)
                }
                ,1000)

            },
            reasonLookup(){
                var response = '';
                var request = new XMLHttpRequest();
                request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons', false);
                request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                request.setRequestHeader('Request-Source', 'BXI-Web');
                request.send(null);
                if (request.status === 200) {
                    response = request.responseText;
                }
                var json_response = JSON.parse(response)
                return {values:json_response}
            },
            reasonFormatter(cell){
                var label = 'No Reason'
                if (cell._cell.row.data.reason_id != undefined){
                    var response = '';
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source', 'BXI-Web');
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == cell._cell.row.data.reason_id.toString()).label;
                            } catch (error) {}
                        }
                    }

                }
                return label;
            },
            unitLookup(cell){
                var response = '';
                var request = new XMLHttpRequest();
                request.open('GET', this.endPoint + 'products/'+cell._cell.row.data.product_id+'/get_product_unit_compositions', false);
                request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                request.setRequestHeader('Request-Source', 'BXI-Web');
                request.send(null);
                if (request.status === 200) {
                    response = request.responseText;
                }
                var json_response = JSON.parse(response)
                json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                return {values:json_response}
            },
            phpFormatter(cell){
                var field = (cell._cell.column.field).replace('_php','');
                var value = eval('cell._cell.row.data.'+field);
                var value_php
                if (this.isCurrencyToPhp){
                    if (this.supplierCurrencyId>0 && Number(this.supplierCurrencyRate) > 0 && (this.documentStatus == 'Posted' || this.documentStatus == 'Voided')){
                        value_php = Number(value * this.supplierCurrencyRate) || 0;
                    }else if (this.supplierDetails.currency_rate!=undefined && this.supplierDetails.currency_rate !=null && this.supplierDetails.currency_rate != 0 && this.supplierDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.supplierCurrencyRate) || Number(value * this.supplierDetails.currency_rate) || 0;
                    }else if (this.documentDetails.currency_rate !=undefined && this.documentDetails.currency_rate !=null && this.documentDetails.currency_rate != 0 && this.documentDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.documentDetails.currency_rate) || 0;
                    }else if (this.hasDefaultCurrency && this.defaultCurrencyRate!=0){
                        value_php = Number(value * this.defaultCurrencyRate) || 0;
                    }else {
                        value_php = Number(value * 1);
                    }
                }else{
                    value_php = Number(value / this.currencyRate) || 0;
                }
                value_php =  Math.round(value_php * 100) / 100
                var values = {}
                values[cell._cell.column.field] = value_php
                cell.getRow().update(values)
                return value_php;
            },
            unitFormatter(cell){
                var response = '';
                var label = 'No Product Unit'
                var unit_label = cell.getRow().getData().unit_label
                if (unit_label!=undefined){
                    label = unit_label
                }else{
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/'+cell._cell.row.data.product_id+'/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source', 'BXI-Web');
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    if (json_response[0]!=undefined){
                        if (json_response[0].key != undefined) {
                            json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                            try {
                                label = json_response.find(element => element.value == cell._cell.row.data.unit_id.toString() && element.key == cell._cell.row.data.product_id.toString()).label;
                            } catch (error) {}
                        }
                    }
                }
                cell.getRow().update({"unit_label":label})
                return label;
            },
            // Document Header
            async fetchSites() {
                this.fetching = true
                if (this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'OTHTRA'){
                    this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                } else {
                    this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                }
                this.fetching = false
            },
            async fetchForThisSites() {
                this.fetching = true
                this.forThisSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                this.forThisSites.unshift({id: 0, code: 'All', name: 'All'})
                this.forThisSites.unshift({id: -1, code: 'Master', name: 'Master'})
                this.fetching = false
            },
            async fetchDistributionSites(value) {
                this.distributionSite = {key: '', label: value}
                this.originSublocation = []
                this.destinationSublocation = []
                this.sublocations = []
                if (value == undefined) value = ''
                this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?name='+value, null)
                await this.tabulator.clearData();

                if (this.distributionSite.key > 0) {
                    this.isProductSearchDisabled = false
                    this.isDestinationSublocationDisabled = false
                } else {
                    this.isProductSearchDisabled = true
                    this.isDestinationSublocationDisabled = true
                }
            },
            async fetchPcountSublocations(){
                this.fetching = true
                this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                this.fetching = false
            },
            async fetchSublocations(){
                if (this.distributionSite.key) {
                    this.fetching = true
                    this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.distributionSite.key, null)
                    this.fetching = false
                }
            },
            async fetchCustomers(value){
                this.customer = {key: '', label: value}
                if (value == undefined) value = ''
                this.customers = await HTTPRequest.getRequest(this.endPoint + 'customers/get_valid_customers?name='+value, null)
            },
            async selectCustomer (customer, option) {
                customer = customer.replace('customers','')
                this.customer = {key: customer, label: option.data.attrs.text}
                if (customer){
                    var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+customer, null);
                    this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                    this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                    this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                    this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                    this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                    this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                    this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                }

                if (this.currentDocumentTypeCode == 'ORISOX'){
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }
            },
            async fetchSalesmen(value){
                this.salesman = {key: '', label: value}
                if (value == undefined) value = ''
                this.salesmen = await HTTPRequest.getRequest(this.endPoint + 'salesmen/get_valid_salesmen?name='+value, null)
            },
            async selectSalesman (salesman, option) {
                salesman = salesman.replace('salesman','')
                this.salesman = {key: salesman, label: option.data.attrs.text}
            },
            async selectDistributionSite (distributionSite, option) {
                distributionSite = distributionSite.replace('sites1','')
                Object.assign(this, {
                    originSublocation: [],
                    destinationSublocation: [],
                })
                this.distributionSite = {key: distributionSite, label: option.data.attrs.text}

                await this.tabulator.clearData();

                if (this.currentDocumentTypeCode == 'ORISOX'){
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                } else {
                    if (this.distributionSite.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }

                if (this.distributionSite.key > 0) {
                    this.isDestinationSublocationDisabled = false
                } else {
                    this.isDestinationSublocationDisabled = true
                }
            },
            async selectOriginSublocation (originSublocation) {
                var arr = {
                    key:originSublocation.key.replace('sublocations1',''),
                    label:originSublocation.label
                }
                originSublocation = arr
                Object.assign(this, {
                    originSublocation,
                    sublocations: [],
                    fetching: false,
                })

                //RELOAD Document Lines to retrieve actual quantity of sublocation on RELDDE
                window.scrollTo(0,0);
                this.spinning = true;
                var sales_order_id = this.$route.params.sales_order_id
                var document_lines = []
                var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation='+originSublocation.key, null)
                document_lines.forEach( row => {
                    row.quantity = 0
                });
                if(document_lines) await this.tabulator.clearData();
                if(document_lines) await this.tabulator.addData(document_lines, true);
                this.tabulator.addFilter("line_no", ">", 0);
                if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                this.spinning = false;
            },
            selectDestinationSublocation (destinationSublocation) {
                var arr = {
                    key:destinationSublocation.key.replace('sublocations2',''),
                    label:destinationSublocation.label
                }
                destinationSublocation = arr
                Object.assign(this, {
                    destinationSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            selectSupplyingSite (supplyingSite) {
                 var arr = {
                    key:supplyingSite.key.replace('sites',''),
                    label:supplyingSite.label
                }
                supplyingSite = arr
                Object.assign(this, {
                    supplyingSite,
                    sites: [],
                    fetching: false,
                })
            },
            selectRequestingSite (requestingSite) {
                var arr = {
                    key:requestingSite.key.replace('selectRequestingSite',''),
                    label:requestingSite.label
                }
                requestingSite = arr
                Object.assign(this, {
                    requestingSite,
                    sites: [],
                    fetching: false,
                })
            },
            selectRevenue (revenue) {
                this.revenue = revenue.replace('selectRevenue','')
                this.fetching=false
            },
            async fetchSuppliers(value) {
                this.supplier = {key: '', label: value}
                if (value == undefined) value = ''
                this.suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?name='+value, null)
                this.supplierDetails = {}
                if (this.supplier.key !=undefined && this.supplier.key!=''){
                    this.forceFetchCurrency = true
                    this.showConversionRate = false
                    this.showConversionCurrencyRate()
                }
            },
            async fetchDefaultCurrency() {
                var default_currency = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_default_currency', null)
                if(default_currency["error"] == undefined){
                    try{
                        if(this.currency.key==undefined){
                            this.currency = {key: default_currency.id, label: default_currency.currency}
                        }
                    }catch(e){
                        this.currency = {key: default_currency.id, label: default_currency.currency}
                    }
                    this.hasDefaultCurrency = default_currency.has_default_currency
                    this.defaultCurrencyDetails = default_currency
                    this.defaultCurrencyRate = default_currency.currency_rate
                    this.isRunDefaultCurrency = true
                }else{
                    this.notifMessage = default_currency["error"].split(",");
                }
            },

            // Start
            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

            changeDate () {
                    this.isEditing = true
                if( ['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode) ) {
                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time, 'days');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time + this.suppDetails.days_to_cancel, 'days');
                }
            },

            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
            // End

            async selectSupplier (supplier, option) {
                supplier = supplier.replace('selectSupplier','')

                // Start
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

                if( ['OROTRQ', 'OROCSQ', 'ORITRQ', 'ORICSQ', 'RECTRX', 'RELTRX', 'OTHPUR', 'ORIPOX', 'RECDEL', 'RELRSR', 'ORITRQ', 'OROTRQ', 'RECTRX', 'RELTRX'].includes(this.currentDocumentTypeCode) ) {
                    this.suppDetails = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + supplier, null)

                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time, 'days').utc().startOf('day');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time + this.suppDetails.days_to_cancel, 'days').utc().startOf('day');

                    //1935 - Populate supplier header and support discount
                    if(this.suppDetails.support_discount_text!=null && this.suppDetails.support_discount_text.length > 0 )
                        this.supportDiscount = this.suppDetails.support_discount_text.toString().split(",")
                    else
                        this.supportDiscount = []
                    if(this.suppDetails.discount_text!=null && this.suppDetails.discount_text.length > 0 )
                        this.headerDiscount = this.suppDetails.discount_text.toString().split(",")
                    else
                        this.headerDiscount = []
                }

                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                // End

                this.forceFetchCurrency = true
                let check_supplier = this.suppliers.findIndex(x=> x.id == supplier)
                let currency_id =null
                if (check_supplier>=0){
                    let supplier_details = this.suppliers[check_supplier]
                    this.supplierDetails = supplier_details
                    if (supplier_details.currency_id>0){
                        this.supplierCurrencyRate = supplier_details.currency_rate
                        this.supplierCurrencyId = supplier_details.currency_id
                        currency_id = supplier_details.currency_id
                        if(this.currencies.length <= 0 || this.hasDefaultCurrency){
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                        }
                        let currency_details = this.currencies.find(c => parseInt(c.id) == parseInt(this.suppliers[check_supplier].currency_id))
                        if (currency_details!=undefined){
                            let currency = {
                                key:this.suppliers[check_supplier].currency_id,
                                label:currency_details.code,
                            }
                            this.currencyRate = currency_details.conversion || 0
                            Object.assign(this, {
                                currency,
                                fetching: false,
                                currencyDetails:currency_details,
                            })
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                            await this.showConversionCurrencyRate()
                        }
                        this.calculateSummary();    
                    }else{
                        this.supplierCurrencyRate = 0
                        this.supplierCurrencyId = -1
                        this.supplierDetails = {}
                        await this.fetchCurrencies()
                    }
                }else{
                    this.supplierCurrencyRate = 0
                    this.supplierCurrencyId = -1
                    this.supplierDetails = {}
                    await this.fetchCurrencies()
                }
                Object.assign(this, {
                    suppliers: [],
                })
                this.supplier = {key: supplier, label: option.data.attrs.text,currency_id:currency_id}
                this.$refs.supplierAutoCompleteInput.blur()
                this.$refs.autocomplete.clear()
            },

            showSupplierModal(){
                if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                    let _data = this.tabulator.getData();
                    if(_data.length > 0){
                        this.showChangeSupplierModal = true
                    }
                }
            },

            //Add Product / Search Product
            changeProductFormMode(val) {
                this.productFormMode = val
                if (val == "Add") {
                    this.tabulator.clearFilter();
                    this.productSearchInput = ''
                }
            },
            changeSearchFilter(searchFilter){
                this.productSearchInput = ''
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.placeholder = "Search by " + search_text.join(' ')
                }else{
                    this.placeholder = "Search product by " + search_text.join(' ')
                }
                // if (searchFilter == 'code') {
                //     searchFilter = 'product_id'
                // }
                if (searchFilter == 'document_id') {
                    searchFilter = 'id'
                }
                this.searchFilter = searchFilter
            },

            changesearchFilterAddedProduct(searchFilter){
                this.addedProductSearchInput = ''
                if(this.addedProductSearchInput == ''){
                    this.searchAddedProducts()
                }
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.addedProductPlaceholder = "Search by " + search_text.join(' ')
                }else{
                    this.addedProductPlaceholder = "Search added product by " + search_text.join(' ')
                }
                if (searchFilter == 'code') {
                    searchFilter = 'product_id'
                }
                if (searchFilter == 'name') {
                    searchFilter = 'product_name'
                }
                this.searchFilterAddedProduct = searchFilter
            },

            productEndpoint (input) {
                var params = '/products?&type=document&'
                if (this.currentDocumentTypeCfode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM'){
                    params = '/products?&type=ASMDSMDOC&'
                }
                if (this.currentDocumentTypeCode == 'ORISOX'){
                    params = '/products?site_id='+this.distributionSite.key+'&type=ORISOXDOC&'
                }

                // if (this.supplier.key > 0) params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                if (this.filterBySupp && this.supplier.key > 0){
                    params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                }
                else if (this.filterBySupp && this.supplier.key == undefined) {
                    if (this.document_config.document_type_settings.incomingOrder.requireSupplierInPo){
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Filter product by supplier is enabled.",
                            style: getNotificationStyle('error')
                        });
                    }
                    params = '/products?type=document&supplier_id=0&'
                }
                else {
                    params = '/products?type=document&'
                }

                if (this.currentDocumentTypeCode == 'OTHPWS') {
                    if (this.filteredBySupplier == false) {
                        params = '/products?type=document&'
                    } else {
                        params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                    }
                }
                if (this.currentDocumentTypeCode == 'RECCSR' && component_x.openCSR != undefined && !(component_x.openCSR)){
                    var document_id = this.$route.params.sales_order_id
                    params = `/products?type=RECCSRDOC&origin_document_id=${component_x.documentNumber > 0 ?  component_x.documentNumber : this.$route.params.sales_order_id }&`
                }
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    params += 'is_non_trade=' + !this.isDocumentTrade + '&' + 'documenttype=ORIPOX&';
                }
                //2114
                if(['OTHPUR', 'OTHASM', 'OTHDSM'].includes(this.currentDocumentTypeCode)) {
                    params += 'documenttype=' + this.currentDocumentTypeCode + '&';
                } 
                // console.log(this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical', this.currentDocumentTypeCode);
                return this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical';
            },
            formattedDisplay (result) {
                if (this.searchFilter == 'name'){
                    let namePrefix = result[this.document_config.document_type_settings.editorBehavior.prefixSearch]
                    let resultPrefix = (namePrefix) ? `[ ${namePrefix} ] ` : '';
                    return resultPrefix + eval('result.'+this.searchFilter);
                } else{
                    return eval('result.'+this.searchFilter) + ' ['+result.name+']';
                }
            },
            async getProduct (group) {

                 // On initial loading of document the value of on-hand quantity/available quantity in the UI is (*).
                if(this.isRefreshInventory == false && (this.documentStatus == 'Saved' || this.documentStatus == null)) {
                    this.onHandQuantity = '*'
                } else {
                    var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+secureStorage.getItem("defaultSiteId"), null)
                    if (lastinv.onhand_quantity != undefined)
                        this.onHandQuantity = lastinv.onhand_quantity
                    else
                        this.onHandQuantity = 0
                }

                this.notifMessage = []
                if (this.currentDocumentTypeCode == 'OTHASM' && group.selectedObject.product_type == "R"){
                    this.actual_yield = group.selectedObject.yield_quantity || 0;
                    this.tolerance_quantity = group.selectedObject.tolerance_quantity || 0;
                    this.showActualYield = true;
                }

                if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.supplyingSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="ORISOX"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.distributionSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="OTHTRA"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.supplyingSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                    }
                }
                var unitCost = eval('group.selectedObject.'+this.productPriceChoice)
                var unitNetCost = eval('group.selectedObject.'+this.productPriceChoice)

                var site_id = secureStorage.getItem("defaultSiteId");
                var isRel = this.currentDocumentTypeCode.includes("REL");
                var isRec = this.currentDocumentTypeCode.includes("REC");
                if (isRel || isRec) {
                    let currency_params = ""
                    if (this.supplier.currency_id!=null && this.currencyRate!=null){
                        currency_params = '&currency_id='+this.supplier.currency_id+'&currency_rate='+this.currencyRate
                    }
                    // var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+group.selectedObject.id+'&site_id='+site_id+' ' +currency_params, null)
                    // if (inventory_cost.cost){
                    //     this.unitCost = inventory_cost.cost
                    //     this.unitNetCost= inventory_cost.cost
                    // } else {
                        this.unitCost = unitCost
                        this.unitNetCost= unitNetCost
                    //}
                }else {
                    this.unitCost = unitCost
                    this.unitNetCost= unitNetCost

                    // for alternate supplier costing
                    if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                        let site_product_cost;
                        let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + group.selectedObject.id + '&site_id=' + this.requestingSite.key);
                                
                        if(site_product != null){
                            let siteProductCost = eval('site_product.'+this.productPriceChoice)
                            site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                        }

                        if(site_product_cost && site_product_cost > 0){
                            this.unitCost = site_product_cost
                            this.unitNetCost = site_product_cost
                        }

                        if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                            if(Number(this.supplier.key) != Number(group.selectedObject.supplier_id)){
                                // if not main supplier get cost based on supplier products table
                                let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ group.selectedObject.id+ '&supplier_id=' + this.supplier.key);
                                if(findSupplierProduct != null){
                                    if(findSupplierProduct.data.length > 0){
                                        let supplierProduct = findSupplierProduct.data[0]
                                        this.unitCost = supplierProduct.ordering_cost
                                        this.unitNetCost = supplierProduct.ordering_cost
                                    }
                                }
                            }
                        }
                    }
                }

                                
                // // TODO: https://tools.iripple.com/barter-11/bxi-backend/-/issues/1927
                // // ------ [Internal] - Incorrect ordering cost of product when using alternate supplier
                // // Check if docType is Purchase Order or Purchase Request
                // // what if matrix item matrix item product dont have alternate supplier
                // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                //     // console.log(this.unitCost, isRel, isRec, this.productPriceChoice,eval('group.selectedObject.'+this.productPriceChoice))
                //     // if docType check alternate_sup of this product
                //     let product_id
                //     if(group.selectedObject.matrix_parent_id == null){
                //         product_id = group.selectedObject.id
                //     }else{
                //         product_id = group.selectedObject.matrix_parent_id
                //     }

                //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + product_id + '&site_id=' + site_id);
                //     if(site_product != null){
                //         var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                //         var siteUnitNetCost = eval('site_product.'+this.productPriceChoice)
                //         if(siteUnitCost != null && siteUnitNetCost != null && siteUnitCost > 0 && siteUnitNetCost > 0){
                //             this.unitCost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                //             this.unitNetCost = Number(siteUnitNetCost).toFixed(this.decimalPlaces)
                //         }
                //     }

                //     if(this.supplier.key != null && group.selectedObject.id != null && this.productPriceChoice == 'ordering_cost'){
                //         var supp_id = Number(this.supplier.key)
                //         var alternate_supplier = await HTTPRequest.getRequest(this.endPoint + 'supplier_products/get_alternate_supplier?product_id=' + product_id + '&supplier_id=' + supp_id)
                //         if(alternate_supplier != null && alternate_supplier.ordering_cost > 0){
                //             this.unitCost = alternate_supplier.ordering_cost
                //             this.unitNetCost = alternate_supplier.ordering_cost
                //         }
                //         // if alternate_sup exist use this ordering_cost if productPriceChoice is Ordering Cost
                //     }
                // }
                // // ------ END [Internal] - Incorrect ordering cost of product when using alternate supplier

                this.selectedParentProduct = group.selectedObject
                this.selectedProduct = group.selectedObject
                if (group.selectedObject.product_type == "R") {
                    this.productName = group.selectedObject.name + ' : ' + group.selectedObject.finished_product_name
                } else {
                    this.productName = group.selectedObject.name
                }

                this.inputProduct = group.selectedObject.name
                this.quantity = 1
                this.productComposition = group.selectedObject.product_unit_content
                this.unitCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                this.unitNetCost = Number(this.unitNetCost).toFixed(this.decimalPlaces)
                this.isDocumentLineFormDisabled = false
                this.isProductNameDisabled = this.isProductNameEditConfigDisabled
                this.discountText = []
                this.subTotal = (this.quantity * this.unitCost).toFixed(this.decimalPlaces)

                if (this.currentDocumentTypeCode=="ORISOX" && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPromotionComputation) {
                    var request_body = {
                        document_date: this.documentDate.format(),
                        site_id: this.distributionSite.key,
                        unit_cost: this.unitCost,
                        product_id: group.selectedObject.id,
                        customer_id: this.customer.key
                    }
                    var promotion = await HTTPRequest.postRequest(this.endPoint + 'promotions/is_applicable', null, request_body)

                    if (promotion.applied_promo_reward_code != null) {
                        //this.unitCost = promotion.new_unit_cost
                        this.unitNetCost = promotion.new_unit_cost.toFixed(this.decimalPlaces)
                        this.promoName = promotion.applied_promo_name
                        this.rewardCode = promotion.applied_promo_reward_code
                        this.rewardDiscountAmount = promotion.discounted_amount
                        this.discountText.push(promotion.discounted_amount)
                        this.subTotal = (this.subTotal - promotion.discounted_amount).toFixed(this.decimalPlaces)
                    }
                }
                // price work sheet
                if (this.currentDocumentTypeCode=="OTHPWS"){
                    this.oldOrdering = group.selectedObject.ordering_cost
                    this.oldLanded = group.selectedObject.landed_cost
                    this.oldRetailPrice = group.selectedObject.retail_price
                }
            },
            clearProduct (){
                this.selectedParentProduct = ''
                this.selectedProduct = ''
                this.productName = '';
                this.inputProduct = ''
                this.quantity = 0
                this.productComposition = ''
                this.unitCost = 0
                this.discountTotal = 0
                this.discountText = []
                this.unitNetCost = 0
                this.subTotal =  0
                this.isDocumentLineFormDisabled = true
                this.isProductNameDisabled = true
                this.rewardCode = null
                this.rewardDiscountAmount = 0
                this.showActualYield = false;
                this.actual_yield = 0;
                this.tolerance_quantity = 0;
                this.oldOrdering = ''
                this.newOrdering = ''
                this.oldLanded = ''
                this.newLanded = ''
                this.oldRetailPrice = ''
                this.newRetailPrice = ''
                this.oldLeastPrice = ''
                this.oldWholesalePrice = ''
                this.oldSpecialPrice = ''
                this.oldOriginal = ''
                this.markUp = ''
            },
                calculatePwsCosts(field) {
                  if (field == 'markUp') {
                    let landedCost = this.newLanded;
                    let markUpPercent = this.markUp;
                    let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);
                    this.newRetailPrice = newRetailPrice > 0 ? newRetailPrice.toFixed(this.decimalPlaces) : 0;
                  }

                  if (field == 'newLanded') {
                    let landedCost = this.newLanded;
                    let retailPrice = this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }

                  if (field == 'newPrice') {
                    let landedCost = this.newLanded;
                    let retailPrice = this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }
                },
                calculateSelectedProduct () {
                    var notifMessage = []
                    if (this.discountText.length > 0) {
                        // eslint-disable-next-line
                        var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                        var discountText = this.discountText.join();
                        discountText = discountText.split(',');

                        discountText.forEach(function(row) {
                            if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                        });

                        if (notifMessage.length == 0) {
                            var lessDiscount = /^L[0-9]+$/;
                            var numberRegex = /^[0-9]+$/;
                            // eslint-disable-next-line
                            var percentDiscount = /^[0-9]+\%$/;

                            var unitNetCost = this.unitCost
                            var quantity = this.quantity
                            var discountTotal = 0;
                            var decimalPlaces = this.decimalPlaces

                            discountText.forEach(function(row) {
                                var discount;
                                var discountAmount;
                                if (lessDiscount.test(row)) {
                                    discount = row.slice(1)
                                    discountAmount = (unitNetCost) - (discount)
                                    unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                } else if (numberRegex.test(row)) {
                                    discount = row;
                                    discount = (discount / quantity)
                                    discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                    unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                } else if (percentDiscount.test(row)) {
                                    discount = row.slice(0,-1)
                                    discountAmount = (unitNetCost) * (discount / 100)
                                    unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                }
                                if (lessDiscount.test(row)) {
                                    discountTotal = discountTotal + (discount * quantity);
                                } else{
                                    discountTotal = discountTotal + (discountAmount * quantity);
                                }
                            });
                            if (unitNetCost < 0) unitNetCost = 0
                            this.unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                            this.subTotal = (this.quantity * this.unitNetCost).toFixed(this.decimalPlaces)
                            this.discountTotal = discountTotal
                        } else {
                            this.discountText.pop();
                            this.notifMessage = notifMessage
                            this.documentActionNotification('Document line discount', 'error')
                        }
                    }else {
                        this.unitNetCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                        this.subTotal = (this.quantity * this.unitCost).toFixed(this.decimalPlaces)
                    }
                },
                //Document Line Form
                documentLineErrorNotif(type) {
                    this.$notification[type]({
                        message: 'Document Line Notification',
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                },
                async fetchProductCompositions() {
                    this.fetching = true
                    this.productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+this.selectedParentProduct.id+'/get_product_unit_compositions', null)
                    this.fetching = false
                },
                async selectProductComposition(productComposition) {
                    var arr = {
                        key:productComposition.key.replace('productCompositions',''),
                        label:productComposition.label
                    }
                    productComposition = arr
                    var unitId = this.productCompositions.find(x => x.key == productComposition.key).unit_id
                    Object.assign(this, {
                        productComposition,
                        productCompositions: [],
                        fetching: false,
                    })
                    this.productComposition.unit_id = unitId
                    var product = await HTTPRequest.getRequest(this.endPoint + '/products/'+ this.productComposition.key);

                    if (product){
                         this.notifMessage = []
                        if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                            var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.id+'&site_id='+this.supplyingSite.key, null)
                            if (inventory.error) {
                                this.notifMessage.push(inventory.error)
                                this.documentActionNotification('Add document line', 'error')
                                return
                            } else{
                               this.onHandQuantity = inventory.quantity
                            }
                        }


                        var unitCost = eval('product.'+this.productPriceChoice)
                        var unitNetCost = eval('product.'+this.productPriceChoice) //VAT EXCLUDE PRICE

                        var site_id = secureStorage.getItem("defaultSiteId");
                        var isRel = this.currentDocumentTypeCode.includes("REL");
                        var isRec = this.currentDocumentTypeCode.includes("REC");
                        if (isRel || isRec) {
                            var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+product.id+'&site_id='+site_id, null)
                            if (inventory_cost.cost && Number(inventory_cost.cost) != 0){
                                this.unitCost = inventory_cost.cost
                                this.unitNetCost= inventory_cost.cost
                            } else {
                                this.unitCost = unitCost
                                this.unitNetCost= unitNetCost
                            }
                        }else {
                            this.unitCost = unitCost
                            this.unitNetCost= unitNetCost
                        }

                        this.selectedProduct = product
                        this.productName = product.name
                        this.inputProduct = product.name
                        this.quantity = 1
                        this.unitCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                        this.discountText = [] //Not Hardcoded
                        this.unitNetCost = Number(this.unitNetCost).toFixed(this.decimalPlaces)
                        this.subTotal =  (this.quantity * this.unitCost).toFixed(this.decimalPlaces)
                    }
                },

                //isDirtyData
                preventNav(event) {
                    if (!this.isDirty) return
                    event.preventDefault()
                    event.returnValue = ""
                },
                filterExistingProducts(e){
                    if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                        this.filterExistingProductData = e.data
                        return e.data
                    }else{
                        var data = this.tabulator.getData();
                        var product_ids = data.map(({product_id}) => product_id)
                        return e.data.filter(item => !product_ids.includes(item.id))
                    }
                },

                //Document Lines
                validateAddLine(quantity, productName, unitCost, selectedProduct){
                    this.notifMessage = [];
                    var data = this.tabulator.getData();
                    if (this.document_config.document_type_settings.editorBehavior.radio != 'P'){
                        var product = data.find(element => element.product_id == selectedProduct.id)
                        if (product != undefined) this.notifMessage.push("Matrix Item Exists");
                    }
                    this.notifMessage.push(ValidateField.positiveNumber('Quantity', quantity));
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 100));
                    this.notifMessage.push(ValidateField.positiveNumber('Cost', unitCost));
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                validateAddPwsLine(productName, newOrdering, newLanded, newRetailPrice, markUp){
                    this.notifMessage = [];
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 100));
                    if (newOrdering) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Ordering', newOrdering));
                    }
                    if (newLanded) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Landed', newLanded));
                    }
                    if (newRetailPrice){
                        this.notifMessage.push(ValidateField.positiveNumber('New Retail Price', newRetailPrice));
                    }
                    if (markUp) {
                        this.notifMessage.push(ValidateField.positiveNumber('Mark Up %', markUp));
                    }
                    if ((newOrdering == "" || newOrdering == null) && (newLanded == "" || newLanded == null) && (newRetailPrice == "" || newRetailPrice == null)) {
                        this.notifMessage.push("Atleast one price/cost field is required.")
                    }
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                async refreshInventory() {
                    // this.isRefreshInventory = true
                    var items = this.tabulator.getData();
                    let refreshProducts = [];

                        for (const product of items) {
                            var site_id = secureStorage.getItem("defaultSiteId")
                            var refreshInventory = 0
                            var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.product_id+'&site_id='+site_id, null)

                            if (lastinv.onhand_quantity != undefined)
                                refreshInventory = lastinv.onhand_quantity
                                var data = {
                                    "line_no": product.line_no,
                                    "stock_no": product.stock_no,
                                    "product_name": product.product_name,
                                    "supplier_stock_no": product.supplier_stock_no,
                                    "design": product.design,
                                    "size": product.size,
                                    "product_id": product.product_id,
                                    "ref_code": product.ref_code,
                                    "barcode": product.barcode,
                                    "unit_id": product.unit_id,
                                    "ordered_quantity": product.ordered_quantity,
                                    "actual_quantity": product.actual_quantity,
                                    "quantity": product.quantity,
                                    "reason_id": product.reason_id,
                                    "actual_yield": product.actual_yield,
                                    "delivery_quantity": product.delivery_quantity,
                                    "goods_issue_quantity": product.goods_issue_quantity,
                                    "frozen_quantity": product.frozen_quantity,
                                    "content_quantity": product.content_quantity,
                                    "price": product.price,
                                    "price_php": product.price_php,
                                    "price_pi": product.price_pi,
                                    "cost": product.cost,
                                    "cost_php": product.cost_php,
                                    "total_gross": product.total_gross,
                                    "total_gross_php": product.total_gross_php,
                                    "subtotal": product.subtotal,
                                    "subtotal_php": product.subtotal_php,
                                    "discount": product.discount,
                                    "discount_text": product.discount_text,
                                    "old_landed_cost": product.old_landed_cost,
                                    "landed_cost": product.landed_cost,
                                    "old_retail_price": product.old_retail_price,
                                    "retail_price": product.retail_price,
                                    "markup_percent": product.markup_percent,
                                    "old_original_cost": product.old_original_cost,
                                    "original_cost": product.original_cost,
                                    "old_ordering_cost": product.old_ordering_cost,
                                    "ordering_cost": product.ordering_cost,
                                    "old_wholesale_price": product.old_wholesale_price,
                                    "wholesale_price": product.wholesale_price,
                                    "old_least_price": product.old_least_price,
                                    "least_price": product.least_price,
                                    "old_special_price": product.old_special_price,
                                    "special_price": product.special_price,
                                    "on_hand_quantity": refreshInventory,
                                    "invoice_amount": product.invoice_amount,
                                    "invoice_discount": product.invoice_discount,
                                    "unit_price_vat": product.unit_price_vat,
                                    "net_price_vat": product.net_price_vat,
                                    "subtotal_vat": product.subtotal_vat,
                                    "unit_price_no_vat": product.unit_price_no_vat,
                                    "price_without_vat": product.price_without_vat,
                                    "subtotal_without_vat": product.subtotal_without_vat,
                                    "effective_discount": product.effective_discount,
                                    "incoming_quantity": product.incoming_quantity,
                                    "code_and_document_no": product.code_and_document_no,
                                    "id": product.id,
                                    "reference_1": product.reference_1,
                                    "document_date": product.document_date,
                                    "total_quantity": product.total_quantity,
                                    "status": product.status,
                                    "order_status": product.order_status,
                                    "created_by": product.created_by,
                                    "updated_by": product.updated_by,
                                    "remarks": product.remarks,
                                    "salesman_name": product.salesman_name,
                                    "line_extras": product.line_extras,
                                    "sublocation_allocation": product.sublocation_allocation,
                                    "product_type": product.product_type,
                                    "document_line_serials_text": product.document_line_serials_text,
                                    // "size": product.size_name,
                                    "color": product.color
                                    };
                            // var data = {
                            //     "line_no": product.line_no,
                            //     "parent_line_no": product.parent_line_no,
                            //     "product_type": product.product_type,
                            //     "product_id": product.product_id,
                            //     "barcode": product.barcode,
                            //     "actual_quantity": product.actual_quantity,
                            //     "on_hand_quantity": refreshInventory,
                            //     "unit_id": product.unit_id,
                            //     "content_quantity": product.content_quantity,
                            //     "product_name": product.product_name,
                            //     "tax_type": product.tax_type,
                            //     "quantity": product.quantity,
                            //     "price": product.price,
                            //     "subtotal": product.subtotal,
                            //     "subtotal_without_vat": product.subtotal_without_vat,
                            //     "price_without_vat": product.price_without_vat,
                            //     "discount": product.discount,
                            //     "discount_text": product.discount_text,
                            //     "stock_no": product.stock_no,
                            //     "cost": product.cost,
                            //     "remarks": product.remarks,
                            //     "retail_price": product.retail_price,
                            //     "tax_rate": product.tax_rate,
                            //     "tax_amount": product.tax_amount,
                            //     "reward_code": product.reward_code,
                            //     "reward_discount_amount": product.reward_discount_amount,
                            //     "actual_yield": product.actual_yield,
                            //     "extras":product.extras
                            // };
                            refreshProducts.push(data)
                        }
                    await this.tabulator.clearData();
                    await this.tabulator.addData(refreshProducts);
                },
                addProduct() {
                    this.notifMessage = []
                    var data = this.tabulator.getData();

                    if (this.inputProduct) {
                        if (!(data.length == this.maximumDocumentLineNumber)) {
                            if (this.currentDocumentTypeCode == 'OTHPWS'){
                                this.addPwsProduct(this.selectedProduct, this.newOrdering, this.newLanded, this.newRetailPrice, this.markUp);
                            } else {
                                if (this.selectedProduct.product_type == "M") {
                                    this.populateMatrixItems(this.selectedProduct, this.productName, this.quantity, this.discountText)
                                } else {
                                    this.addRegularProduct(this.selectedProduct, this.productName, this.quantity, this.actual_yield, this.unitCost, this.subTotal, this.unitNetCost, this.discountTotal, this.discountText, this.onHandQuantity, this.rewardCode, this.rewardDiscountAmount, 0);
                                    if(this.currentDocumentTypeCode == 'RECCSR'){
                                        this.limitCsrProduct(this.tabulator.getData().at(-1));
                                    }
                                }
                            }
                        } else {
                            this.documentActionNotification('Add Product', 'error')
                        }
                    }
                    this.showActualYield = false;
                    this.actual_yield = 0;
                    this.tolerance_quantity = 0;
                    this.addProductConfirmationVisible = false;
                },
                async limitCsrProduct(selectedProduct){
                    // change good issued quantity here
                    var returnable_product = component_x.returnable_qtys.data.find(line => line.product_id == selectedProduct.product_id)
                    var updatedProduct = {product_id: selectedProduct.product_id}
                    updatedProduct.goods_issue_quantity = returnable_product == undefined ? 0 : (returnable_product.returnable_qty)
                    updatedProduct.delivery_quantity = updatedProduct.goods_issue_quantity
                    updatedProduct.discount_text = (returnable_product == undefined) ? '' : returnable_product.discount_text
                    this.tabulator.updateData([updatedProduct])
                    await this.recalculateLine(updatedProduct.product_id)
                    this.calculateSummary();
                },

                async addPwsProduct(selectedProduct, newOrdering, newLanded, newRetailPrice, markUp){
                    if(!this.validateAddPwsLine(selectedProduct, newOrdering, newLanded, newRetailPrice, markUp)) {
                        let _products = []
                        if(selectedProduct.product_type == 'M'){
                            var prodMatrix = await HTTPRequest.getRequest(this.endPoint + 'products/get_matrix_items?document_form=true&matrix_parent_id='+selectedProduct.id, null )
                            if(prodMatrix != null){
                                _products = prodMatrix
                            }
                        }
                        _products.push(selectedProduct)

                        let newProducts = [];
                        _products.forEach((product) => {
                            var oldLeastPrice = (Number(product.least_price) > 0) ? product.least_price : product.retail_price
                            var oldWholesalePrice = (Number(product.wholesale_price) > 0) ? product.wholesale_price : product.retail_price
                            var oldSpecialPrice = (Number(product.special_price) > 0) ? product.special_price : product.retail_price
                            var oldOriginal = (Number(product.original_cost)>0) ? product.original_cost : product.ordering_cost

                           var data = {
                                "parent_line_no": 0,
                                "product_id": product.id,
                                "barcode": product.barcode,
                                // "original_cost": oldOriginal,
                                "original_cost": "",
                                "ordering_cost": newOrdering,
                                "landed_cost": newLanded,
                                "retail_price": newRetailPrice,
                                // "wholesale_price": oldWholesalePrice,
                                // "least_price": oldLeastPrice,
                                // "special_price": oldSpecialPrice,
                                "wholesale_price": "",
                                "least_price": "",
                                "special_price": "",
                                "markup_percent": markUp,
                                "old_original_cost": oldOriginal,
                                "old_ordering_cost": product.ordering_cost,
                                "old_landed_cost": product.landed_cost,
                                "old_retail_price": product.retail_price,
                                "old_wholesale_price": oldWholesalePrice,
                                "old_least_price": oldLeastPrice,
                                "old_special_price": oldSpecialPrice,
                                "unit_id": product.unit_id,
                                "product_name": product.name,
                                "stock_no": product.stock_no,
                                "ref_code": product.reference_code,
                                "size": product.size,
                                "color": product.color

                            };
                            newProducts.push(data)
                        })
                            this.tabulator.addData(newProducts);
                            this.recountLineNo();
                            this.calculateSummary();
                            this.$refs.autocomplete.clear();
                            this.clearProduct();

                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }

                },
                async addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate){
                     if(!this.validateAddLine(quantity, productName, unitCost, selectedProduct)) {
                        var subtotal = Number(subTotal).toFixed(this.decimalPlaces)
                        var subtotal_without_vat = (Number(subTotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                        var price_without_vat = (Number(unitNetCost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                        var tax_amount = Number(subTotal).toFixed(this.decimalPlaces) * (1+Number(this.taxRate))
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            var check_existing_data = await this.tabulator.searchData("product_id","=",selectedProduct.id);
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                quantity=parseInt(quantity)+parseInt(check_existing_data[0].quantity)
                            }
                        }
                        
                        var data = {
                            "parent_line_no": 0,
                            "product_type": selectedProduct.product_type,
                            "product_id": selectedProduct.id,
                            "barcode": selectedProduct.barcode,
                            "actual_quantity": 0, // :TODO: if physical count document must have actual quantity value
                            "on_hand_quantity": on_hand_quantity,
                            "unit_id": selectedProduct.unit_id,
                            "content_quantity": selectedProduct.content_quantity,
                            "product_name": productName,
                            "tax_type": selectedProduct.tax_type,
                            "quantity": quantity,
                            "price": Number(unitCost),
                            "subtotal": subtotal,
                            "subtotal_without_vat": subtotal_without_vat,
                            "price_without_vat": price_without_vat,
                            "discount": discountTotal,
                            "discount_text": discountText.join(),
                            "stock_no": selectedProduct.stock_no,
                            "cost": Number(unitNetCost).toFixed(this.decimalPlaces),
                            "remarks": "",
                            "retail_price": selectedProduct.retail_price,
                            "tax_rate": this.taxRate,
                            "tax_amount": subtotal - subtotal_without_vat,
                            // "tax_amount": tax_amount,
                            "reward_code": rewardCode,
                            "reward_discount_amount": rewardDiscountAmount,
                            "actual_yield": actualYield,
                            "extras":selectedProduct.extras,
                            "ref_code": selectedProduct.reference_code,
                            "matrix_parent_id": selectedProduct.matrix_parent_id,
                            "size": selectedProduct.size,
                            "color": selectedProduct.color
                        };
                        if(this.currentDocumentTypeCode == 'RELDDE'){
                            data["ordered_quantity"] = quantity
                            data["delivery_quantity"] = quantity
                        }
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                await this.tabulator.updateData([data]);
                            }else{
                                await this.tabulator.addRow(data);
                            }
                        }else{
                            await this.tabulator.addRow(data);
                        }

                        this.isEditing = true;
                        this.recountLineNo();

                        if(autoPopulate == 0){
                            this.calculateSummary();
                            if(selectedProduct.product_type == 'S'){
                                await this.showSerialization([{...this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1).getData(), quantity}])
                            }
                            if(selectedProduct.is_require_lotcode && /^RE(C|L)/.test(this.currentDocumentTypeCode)){
                                await this.tabulator.updateData([{product_id: selectedProduct.id, is_require_lotcode: selectedProduct.is_require_lotcode}])
                                this.rowSelectionChanged([this.tabulator.getData().at(-1)], [this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1)])
                                this.showLotCodeExpiry([this.tabulator.getData().at(-1)])
                            }
                            this.$refs.autocomplete.clear();
                            this.clearProduct();
                        }
                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }
                },

                //START OF Document Line TABLE
                mass_delete_line() {
                    var ids = this.selectedDocumentLines.map(({line_no}) => line_no)
                    ids.forEach(
                       line_no => this.delete_line(line_no)
                    );
                    this.calculateSummary();
                },
                async delete_line(line_no) {
                    var data = this.tabulator.getData();
                    var product_id = data.find(item => item.line_no == line_no).product_id
                    await this.tabulator.deleteRow(product_id);
                    this.recountLineNo();
                },
                recountLineNo(){
                    var data = this.tabulator.getData();
                    var lineCounter = 1
                    data.forEach( row => {
                        if (row.line_no == undefined){
                            row.line_no = lineCounter
                            lineCounter = lineCounter + 1
                        } else if (row.line_no != undefined && row.line_no > 0) {
                            if (row.parent_line_no === -1){
                                if (data.find(x => x.parent_line_no === row.line_no)) {
                                    data.find(x => x.parent_line_no === row.line_no).parent_line_no = lineCounter
                                }
                                row.line_no = lineCounter
                            }else{
                                row.line_no = lineCounter
                            }
                            lineCounter = lineCounter + 1
                        }
                    });
                    var negativeLineCounter = -1
                    data.forEach(function(row) {
                        if (row.line_no != undefined && row.line_no < 0) {
                            row.line_no = negativeLineCounter
                            negativeLineCounter = negativeLineCounter - 1
                        }
                    });
                    this.tabulator.replaceData(data)
                },
                //END OF VUE ANT TABLE`

                async initializeFooterCalculation() {
                    var tQuantity = 0;
                    var data = this.tabulator.getData();
                    data.forEach(function(element) {
                        //Total Quantity
                        if (element.line_no > 0){
                            if(element.quantity) tQuantity = Number(tQuantity) + Number(element.quantity)
                        }
                    })
                    component_x.totalQuantity = tQuantity
                },
                calculateSummary(){
                    //Calculate Overall Discount
                    //this.calculateOverallDiscount();

                    var summaryResults = this.tabulator.getCalcResults();

                    //Calculates Quantity
                    console.log(summaryResults)
                    component_x.totalQuantity = summaryResults.bottom.quantity
                    component_x.grossAmount = summaryResults.bottom.total_gross
                    component_x.itemDiscount = summaryResults.bottom.discount

                    this.calculateOverallDiscount();

                    //Calcualates discount_amount
                    var netAmount = (Number(summaryResults.bottom.total_gross) - Number(summaryResults.bottom.discount) - Number(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = Number(netAmount).toFixed(this.decimalPlaces)

                    //Calculate Gross Amount Without Tax
                    component_x.grossAmountwithoutTax = Number(summaryResults.bottom.total_gross) / (1+Number(this.taxRate))

                    //Calculate Net Amount Without Tax
                    component_x.netAmountWithoutTax = summaryResults.bottom.subtotal_without_vat

                    //Update grossAmount UI Display Data when Vat Exempt is Toggled on PO / RR
                    component_x.grossAmountDisplay = component_x.vatExclusiveCheckbox ? (Number(component_x.grossAmountwithoutTax)).toFixed(component_x.decimalPlaces) : Number(component_x.grossAmount).toFixed(component_x.decimalPlaces)
                    component_x.netAmountDisplay = component_x.vatExclusiveCheckbox ? Number(component_x.netAmountWithoutTax).toFixed(component_x.decimalPlaces) : Number(component_x.netAmount).toFixed(component_x.decimalPlaces)

                    //Calculate Vat Amount
                    component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)

                    //Set Total With Vat
                    component_x.totalWithVat = component_x.grossAmount.toFixed(this.decimalPlaces)

                    //format Net Amount w/o Vat
                    component_x.netAmountWithoutTax = component_x.netAmountWithoutTax.toFixed(this.decimalPlaces)
                },

            //SUMARRY
            calculateOverallDiscount(){
                var notifMessage = [];
                // eslint-disable-next-line
                var discountRegex = /(^[0-9]+$|^[0-9]+\%$)/;
                
                if(this.headerDiscount.length > 0 && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount){
                    this.headerDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        var percentDiscount = /^[0-9]+\%$/;

                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount)
                        var overallDiscount = 0;

                        component_x.headerDiscount.forEach(function(row) {
                            var discount;
                            if (numberRegex.test(row)) {
                                discount = row;
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discount = (beforeDiscount) * (discount / 100)
                            }
                            overallDiscount = overallDiscount + Number(discount)
                        });

                        if (overallDiscount <= 0) overallDiscount = 0

                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            component_x.overallDiscount = overallDiscount.toFixed(this.decimalPlaces)
                            component_x.overallDiscountWithoutSupportDiscount = Number(overallDiscount)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }

                if(this.supportDiscount.length > 0 && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount){
                    this.supportDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        var percentDiscount = /^[0-9]+\%$/;

                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount) - ((Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0)
                        var overallDiscount = (Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0;

                        component_x.supportDiscount.forEach(function(row) {
                            var discount;
                            if (numberRegex.test(row)) {
                                discount = row;
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discount = (beforeDiscount) * (discount / 100)
                            }
                            overallDiscount = overallDiscount + Number(discount)
                        });

                        if (overallDiscount <= 0) overallDiscount = 0

                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            component_x.overallDiscount = overallDiscount.toFixed(this.decimalPlaces)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }
            },
            onHeaderDiscountChange() {
                var netAmount;
                if (component_x.headerDiscount.length != 0){
                    this.calculateOverallDiscount();

                    //Calcualates Net Amount
                    netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount

                } else {
                    component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                    this.calculateOverallDiscount();

                    //Calcualates Net Amount
                    netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount
                }
            },
            onSupportDiscountChange () {

                if(['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode)) {

                    var netAmount;
                    if (component_x.supportDiscount.length != 0){
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount

                    } else {
                        component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount
                    }

                } else {
                    this.isSupportDiscountValid = false
                    var notifMessage = []
                    // eslint-disable-next-line
                    var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;

                    this.supportDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {
                        this.isSupportDiscountValid = true
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }
            },
            toggleVatExclusive(e) {
                this.vatExclusiveCheckbox = e.target.checked
                this.calculateSummary();
                if (this.vatExclusiveCheckbox) {
                    if (this.unitCost) this.unitCost = (Number(this.unitCost) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.unitNetCost) this.unitNetCost = (Number(this.unitNetCost) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.subTotal) this.subTotal = (Number(this.subTotal) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    this.grossAmountDisplay = Number(this.grossAmountwithoutTax).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = Number(this.netAmountWithoutTax).toFixed(this.decimalPlaces)
                } else {
                    if (this.unitCost) this.unitCost = (Number(this.unitCost) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.unitNetCost) this.unitNetCost = (Number(this.unitNetCost) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.subTotal) this.subTotal = (Number(this.subTotal) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    this.grossAmountDisplay = Number(this.grossAmount).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = Number(this.netAmount).toFixed(this.decimalPlaces)
                }
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
            },
            async fetchPaymentTerms() {
                this.fetching = true
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + 'payment_terms/get_valid_payment_terms', null)
                this.fetching = false
            },
            selectPaymentTerm (paymentTerm) {
                var arr = {
                    key:paymentTerm.key.replace('paymentTerms',''),
                    label:paymentTerm.label
                }
                paymentTerm = arr
                Object.assign(this, {
                    paymentTerm,
                    paymentTerms: [],
                    fetching: false,
                })
            },
            async fetchShippingMethods() {
                this.fetching = true
                this.shippingMethods = await HTTPRequest.getRequest(this.endPoint + 'shipping_methods/get_valid_shipping_methods', null)
                this.fetching = false
            },
            selectShippingMethod (shippingMethod) {
              this.isEditing = true
                var arr = {
                    key:shippingMethod.key.replace('shippingMethods',''),
                    label:shippingMethod.label
                }
                shippingMethod = arr
                Object.assign(this, {
                    shippingMethod,
                    shippingMethods: [],
                    fetching: false,
                })
            },
            async fetchPurposes() {
                this.fetching = true
                this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+this.currentDocumentTypeId, null)
                this.fetching = false
            },
            selectPurpose (purpose) {
              this.isEditing = true
                var arr = {
                    key:purpose.key.replace('purposes',''),
                    label:purpose.label
                }
                purpose = arr
                Object.assign(this, {
                    purpose,
                    purposes: [],
                    fetching: false,
                })
            },
            closeChargeDrawer() {
            },
            showDrawer(action) {

                if (action == 'charges') {
                    this.chargeDrawerVisible = true;
                } else if (action == 'history') {
                    this.historyDrawerVisible = true;
                }
                // Validation for PURCHASE TO PAYMENT documents -> SUPPLIER is required
                   else if (action == 'massAdd') {

                    if( this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.supplier.key === undefined  ) {
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Please select supplier.",
                            style: getNotificationStyle('error')
                        });
                    } else {
                        this.massAddDrawerVisible = true;
                        this.massAddDrawerKey++
                    }

                } else if (action == 'references') {
                    this.referenceDrawerVisible = true;
                } else if (action == 'extras') {
                    this.extrasDrawerVisible = true;
                } else if (action == 'document_image') {
                    this.documentImageDrawerVisible = true;
                }else if (action == "massAddWithAllocation"){
                    this.massAddWithAllocationDrawerVisible = true;
                }else if (action == "view_allocation"){
                    this.viewSiteAllocation()
                }
                this.massAddProductErrors = [];
                this.massAddProductErrorsDL = [];
                this.dlDUplicateSkus = 0;
                this.dlSkusNotFound =  0;
            },
            closeDrawer(action) {
                if (action == 'charges'){
                    this.clearChargeFormDrawer();
                    this.selectChargeType();
                    this.chargeDrawerVisible = false;
                } else if (action == 'history'){
                    this.historyDrawerVisible = false;
                } else if (action == 'payments'){
                    this.paymentDrawerVisible = false;
                } else if (action == 'booking'){
                    this.bookingDrawerVisible = false;
                } else if (action == 'massAdd'){
                    this.massAddDrawerVisible = false;
                } else if (action == 'references'){
                    this.referenceDrawerVisible = false;
                } else if (action == 'extras'){
                    this.extrasDrawerVisible = false;
                } else if (action == 'document_image'){
                    this.documentImageDrawerVisible = false;
                } else if (action == 'serialization'){
                  this.tabulator.updateData([{product_id: this.selectedSerialProduct.product_id, quantity: this.currentDrawerSerialsInstance.length, document_line_serials: this.currentDrawerSerialsInstance }])
                  this.calculateSummary();
                  this.serializationVisible = false;
                } else if (action == 'document_payments'){
                    this.documentPaymentsDrawerVisible = false;
                } else if (action == 'sublocationAllocation'){
                    this.sublocationAllocationVisible = false;
                    this.drawerCurrentSublocationAllocation = []
                    this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    this.drawerSublocationQuantity = ''
                    this.sublocationAllocationErrors = [];
                } else if (action == 'siteAllocation'){
                    this.siteAllocationVisible = false;
                    this.drawerCurrentSiteAllocation = []
                    this.drawerSite = {key: 0, label: "Please select a site"}
                    this.drawerSiteQuantity = ''
                    this.siteAllocationErrors = [];
                    this.isEditAllocation=false
                    this.isEditAllocationIndex=0
                    this.siteAllocationRemainingQuantity = null
                } else if (action == "ecomForm"){
                    this.documentEcomDrawerVisible = false
                } else if(action == "initialDeposit"){
                    this.initialDepositDrawerVisible = false
                }else if (action == "massAddWithAllocation"){
                    this.massAddWithAllocationDrawerVisible = false
                }else if (action == "view_allocation"){
                    this.viewAllocation = false
                }else if (action == "lotCodeExpiry"){
                    this.inputExpiryAt = undefined
                    this.inputLotCode = ''
                    this.lotCodeExpiryVisible = false
                }
            },
            ecomCloseDrawer(){
                this.closeDrawer("ecomForm")
            },
            selectChargeType () {
                this.isChargeWeightDisabled = (this.chargeType == 'W') ?  false : true
                this.isChargeRateDisabled = (this.chargeType == 'W') ? false : true
                this.isChargeAmountDisabled = (this.chargeType == 'W') ? true : false
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            mass_delete_charge() {
                const newData = [...this.chargeData]
                var ids = this.chargeSelectedRowKeys
                var afterDelete = _.remove(newData, function(n) {
                    return !ids.includes(n.line_no);
                });
                this.chargeData = afterDelete
                this.chargeSelectedRowKeys = []
            },
            validateCharge(){
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.required('Description', this.chargeDescription));
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage.push(ValidateField.decimalFormat('Amount', this.chargeAmount));
                this.notifMessage.push(ValidateField.lessThanZero('Weight', this.chargeWeight, 'Weight is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Rate', this.chargeRate, 'Rate is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Amount', this.chargeAmount, 'Amount is Required'));
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },
            clearChargeFormDrawer() {
                this.chargeDescription = null
                this.chargeType = 'R'
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            addCharge: async function() {
                if(!this.validateCharge()) {
                    var charges = this.chargeData.map(a => a.line_no);
                    if (charges.length == 0) charges = [0]
                    this.chargeData.push({
                        line_no: Math.max(...charges) + 1,
                        name: this.chargeDescription,
                        remark: this.chargeType,
                        weight: this.chargeWeight,
                        rate: this.chargeRate,
                        amount: this.chargeAmount
                    })
                    this.clearChargeFormDrawer();
                    this.closeDrawer('charges');
                    this.documentActionNotification('add charge', 'success')
                } else {
                    this.documentActionNotification('add charge', 'error')
                }
            },
            calculateChargeAmount () {
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage = this._.compact(this.notifMessage);
                if (this.notifMessage.length == 0) {
                    this.chargeAmount = Number(this.chargeWeight * this.chargeRate * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                }
            },

            // Footer Document Actions
            documentActionNotification(action, type) {
                if (type == 'success') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action success',
                        style: getNotificationStyle(type)
                    });
                } else if (type == 'error') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action failed',
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                }
            },
            validateForm(){
                this.notifMessage = [];
                var data = this.tabulator.getData()
                //For Interbranch Documents
                if (['ORITRQ','OROTRQ','RECTRX','RELTRX','ORICSQ','OROCSQ','RECCSX','RELCSX'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key));
                    this.notifMessage.push(ValidateField.required('Requesting Site', this.requestingSite.key));
                    this.notifMessage.push(ValidateField.identicalField('Supplying Site', 'Requesting Site', this.supplyingSite.key, this.requestingSite.key));
                }
                //For Purchase Documents
                if (['OTHPUR','ORIPOX','RECDEL','RELRSR'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplier', this.supplier.key));
                }

                //For Local Documents
                if(['RECADJ','RELADJ'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Purpose', this.purpose.key));
                    this.notifMessage.push(ValidateField.required('Party', this.party));
                }

                //For Transfer Allocation
                if(['OTHTRA'].includes(this.currentDocumentTypeCode) && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key));
                    data.forEach( line => {
                        if (line.site_allocation == undefined || line.site_allocation == []){
                            this.notifMessage.push(`Product ${line.product_name} has no site allocation`);
                        }
                    })
                }
                //For Distribution Documents
                if(['RECSLI','RELSLO'].includes(this.currentDocumentTypeCode)){
                    if (this.originSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }
                    if (this.destinationSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Destination', this.destinationSublocation.key));
                    }
                    if (this.destinationSublocation.key != undefined && this.originSublocation.key != undefined){
                        this.notifMessage.push(ValidateField.identicalField('Sublocation Origin', 'Sublocation Destination', this.originSublocation.key, this.destinationSublocation.key));
                    }

                }

                //For Orisox Documents
                if(['ORISOX'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));
                    if (this.isOrderSourceMode){
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }else{
                        this.notifMessage.push(ValidateField.required('Sublocation Destination', this.destinationSublocation.key));
                    }

                    var invalid = data.find(row => row.quantity == 0)
                    if (invalid != undefined){
                        this.notifMessage.push("Zero quantity is not allowed in the document line");
                    }
                }

                //For RelDde Documents
                if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));

                    if (this.isOrderSourceMode){
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }else{
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }

                    //when goods issue
                    if (this.documentNumber > 0) {
                        var invalid = data.find(row => (row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0))
                        if (invalid != undefined){
                            this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                        }
                    } else {
                        //when open delivery
                        console.log(data)
                        var any = data.find(row => (row.quantity > 0 && Number(row.ordered_quantity) > 0))
                        if (any == undefined){
                            this.notifMessage.push("Atleast one line of delivery quantity should be filled");
                        }
                    }
                }
                if(['RECCSR'].includes(this.currentDocumentTypeCode)){
                    //Validate each line
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));
                    this.notifMessage.push(ValidateField.required('Site', this.distributionSite.key));
                    if(!component_x.openCSR){
                        data.forEach(row => {
                            this.notifMessage.push(ValidateField.isGreaterThan(`${row.product_name}`, parseInt(row.quantity),  parseInt(row.goods_issue_quantity)+1, `${row.product_name} quantity is more than the goods issued quantity.`))
                        });
                    }
                }

                this.notifMessage.push(ValidateField.required('Document Date', this.documentDate));
                this.notifMessage.push(ValidateField.required('Target Date', this.targetDate));
                this.notifMessage.push(ValidateField.required('Cancellation Date', this.cancellationDate));
                if (this.supportDiscount) this.notifMessage.push(ValidateField.validateBoolean('Support Discount', this.isSupportDiscountValid));
                this.notifMessage.push(ValidateField.charMinAndMax("Remark",this.remark,0,255));
                this.notifMessage.push(ValidateField.charMinAndMax("Reference",this.reference,0,50));

                if(this.isHeaderOnly != true && this.processingCsvUpload != true && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.isEmpty('Document Line', data));
                }
                // Validate Release and Receive Documents
                if(/^RE(C|L)/.test(this.currentDocumentTypeCode)){
                    //Validate serial numbers matching the quantity
                    let serial_products = []
                    serial_products = data.filter(row => row.product_type === 'S')
                    if(serial_products.length > 0 && this.documentNumber > 0) {
                        serial_products.forEach(row => {
                            this.notifMessage.push(ValidateField.matchData('Quantity', row.quantity, row.document_line_serials.length, `Insufficient Serial Number provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    } 
                    let require_lotcode_products = []
                    require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                    
                    if(require_lotcode_products.length > 0 && this.documentNumber > 0) {
                        require_lotcode_products.forEach(row => {
                            this.notifMessage.push(ValidateField.positiveNumber('Document Line Locations', row.document_line_locations.length, `Product in line no ${row.line_no} requires lot code and expiry`));

                             var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                            
                            this.notifMessage.push(ValidateField.matchData('Quantity', row.quantity, lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    }
                }
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },

            async save(){
                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    var data = this.tabulator.getData();
                    var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    if (notEqual != undefined){
                        this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                        onOk: () => {
                            this.continueWithPriceDiscrepancy = true
                            this.save()
                        },
                        onCancel() {}
                        });
                    }else {
                        this.continueWithPriceDiscrepancy = true
                        this.save()
                    }
                } else {
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.spinning = true;
                    if(!this.validateForm()) {
                        this.calculateSummary();

                        //To get document type and trans code
                        var document_type_code = '';
                        var document_trans_code = '';
                        var document_party_type = '';
                        var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                        if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                            document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                            document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                            document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                        }

                        var party_id = -1
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX')){
                            party_id = this.requestingSite.key
                        }
                        else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                            party_id = this.supplyingSite.key
                        }

                        var site_id = secureStorage.getItem("defaultSiteId");
                        if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                            site_id = this.distributionSite.key
                        }
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                            site_id = this.supplyingSite.key
                        }

                        if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX')){
                            if(document_party_type == "Supplier"){
                                // Save the supplier info in party_id
                                party_id = this.supplier.key
                            
                                // Save the supplier info in party_name
                                this.party =  this.supplier.label
                            }
                           
                           site_id = this.requestingSite.key
                        }
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            site_id = this.forThisSite.key
                        }

                        var origin_document_id = -1
                        if (this.originDocumentNumber > 0) {
                            origin_document_id = this.originDocumentNumber
                        }

                        var order_status = 'U'
                        if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'REC' && document_type_code == 'CSR')){
                            origin_document_id = this.$route.params.sales_order_id
                            order_status = 'O'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                            origin_document_id = this.$route.params.delivery_document_id
                            order_status = 'G'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                            origin_document_id = this.$route.params.receiving_report_id
                        } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                            origin_document_id = this.$route.params.transfer_allocation_id || -1
                        }else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                            origin_document_id = this.$route.params.sales_order_id
                            if(this.documentExtras!= null){
                                this.documentExtras['revenue'] = this.revenue
                            }else{
                                this.documentExtras = {revenue:this.revenue}
                            }
                        }

                        var data = this.tabulator.getData();
                        if (this.document_config) {
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true) {
                                data.forEach(row => {row.goods_issue_quantity = row.delivery_quantity;});
                            }
                        }

                        var line_type = 'document_lines'
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            line_type = 'pricecost_lines'
                        }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                            line_type = 'countset_lines'
                        }

                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                payment_term_id : this.paymentTerm.key,
                                document_no: 0, //TEST ONLY,
                                [line_type]: data,
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross: this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                supplier_currency_rate:this.supplierCurrencyRate,
                                supplier_currency_id:this.supplierCurrencyId,
                            }
                        }

                        documentPayload.document.currency_rate = this.currencyRate!=undefined && this.currencyRate!=0 ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ?this.defaultCurrencyRate : this.currencyRate
                        try {
                            if(this.documentDetails.address_id!=undefined){
                                documentPayload.document.address_id = this.documentDetails.address_id
                            } 
                        } catch (error) {}

                        // Process references
                        var documentReferences = this.document_config.document_type_settings.references;
                        for(var i=0; i < documentReferences.length; i++){
                            var reference = documentReferences[i]
                            if(_.isUndefined(reference.input)){
                                //console.log("skip")
                            }else{
                                documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                            }
                        }

                        //console.log("===============");
                        //console.log(documentPayload);
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents', null, documentPayload)
                        if (post_request == undefined) {
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.documentNumber = post_request.id
                                    this.openDocument(post_request.id)
                                    this.documentActionNotification('save', 'success')
                                    this.create_action_history('CREATED')
                                }
                        } else {
                            if (post_request["error"] == undefined) {
                                if((['ORISOX','RELDDE','OTHSIN'].includes(this.currentDocumentTypeCode)) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true) && (post_request.id > 0)){
                                    this.documentNumber = post_request.id
                                    this.post();
                                } else {
                                    //this.$router.replace('/documents')
                                    if (this.processingCsvUpload == true) {
                                        let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                        if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                            url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                        }

                                        var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                        this.$router.replace(this.backLink)
                                        } else {
                                            this.documentActionNotification('CSV Upload', 'error');
                                        }
                                    } else if (this.processingXlsxUpload == true){
                                        let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                        var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else {
                                            this.documentActionNotification('XLSX Upload', 'error');
                                        }
                                    } else {
                                        this.documentNumber = post_request.id
                                        this.openDocument(post_request.id)
                                        this.documentActionNotification('save', 'success')
                                        this.create_action_history('CREATED')
                                    }
                                }
                            } else {
                                this.notifMessage = post_request["error"].split(",")
                                this.documentActionNotification('save', 'error')
                            }
                        }
                    } else {
                        this.documentActionNotification('save', 'error')
                    }
                    this.spinning = false;
                }
            },
            async update() {
                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    var data = this.tabulator.getData();
                    var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    if (notEqual != undefined){
                        this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                        onOk: () => {
                            this.continueWithPriceDiscrepancy = true
                            this.update()
                        },
                        onCancel() {}
                        });
                    }else {
                        this.continueWithPriceDiscrepancy = true
                        this.update()
                    }
                } else {
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.spinning = true;
                    if(!this.validateForm()) {
                        if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"){
                        }else{
                            this.calculateSummary();
                        }

                        //To get document type and trans code
                        var document_type_code = '';
                        var document_trans_code = '';
                        var document_party_type = '';
                        var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                        if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                            document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                            document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                            document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                        }

                        var party_id = -1
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX')){
                            party_id = this.requestingSite.key
                        }
                        else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                            party_id = this.supplyingSite.key
                        }

                        var site_id = secureStorage.getItem("defaultSiteId");
                        if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                            site_id = this.distributionSite.key
                        }
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') ||  (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                            site_id = this.supplyingSite.key
                        }

                        if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX')){
                           
                            if(document_party_type == "Supplier"){
                                // Save the supplier info in party_id
                                party_id = this.supplier.key
                            
                                // Save the supplier info in party_name
                                this.party =  this.supplier.label
                            }
                            site_id = this.requestingSite.key
                        }
                        
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS') || (document_trans_code == 'ORO' && document_type_code == 'RSO')){
                            site_id = this.forThisSite.key
                        }

                        var origin_document_id = -1
                        if (this.originDocumentNumber > 0) {
                            origin_document_id =  this.originDocumentNumber
                        }
                        var order_status = 'U'
                        if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR')){
                            origin_document_id = this.$route.params.sales_order_id
                            order_status = 'O'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                            origin_document_id = this.$route.params.delivery_document_id
                            order_status = 'G'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                            origin_document_id = this.$route.params.receiving_report_id
                        } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                            origin_document_id = this.$route.params.transfer_allocation_id
                        } else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                            origin_document_id = this.$route.params.sales_order_id
                            if(this.documentExtras!= null){
                                this.documentExtras['revenue'] = this.revenue
                            }else{
                                this.documentExtras = {revenue:this.revenue}
                            }
                        }

                        var line_type = 'document_lines'
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            line_type = 'pricecost_lines'
                        }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                            line_type = 'countset_lines'
                        }
                        this.updateValueOfSupplierCurrency();

                        var data = this.tabulator.getData();
                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                payment_term_id : this.paymentTerm.key,
                                [line_type]: data,
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross: this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                supplier_currency_rate:this.supplierCurrencyRate,
                                supplier_currency_id:this.supplierCurrencyId,
                            }
                        }

                        // if(parseInt(this.currency.key)>0){
                        //   documentPayload.document.currency_rate = this.currencyRate
                        // }
                        // Change setting of currency_rate process
                        // Update by Maron Justo
                        documentPayload.document.currency_rate = (this.currencyRate!=undefined && this.currencyRate!=0) ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ? this.defaultCurrencyRate : this.currencyRate

                        // Process references
                        var documentReferences = this.document_config.document_type_settings.references;
                        for(var i=0; i < documentReferences.length; i++){
                            var reference = documentReferences[i]
                            if(_.isUndefined(reference.input)){
                                //console.log("skip")
                            }else{
                                documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                            }
                        }

                        //console.log("===============");
                        //console.log(documentPayload);

                        var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber, null, documentPayload)
                        if(put_request == undefined){
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.$emit('refreshPage', event)
                                    this.documentActionNotification('update', 'success')
                                    this.create_action_history('UPDATED')
                                }
                        } else {
                            if(put_request["error"] == undefined){
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            duration: 0,
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.openDocument(this.documentNumber)
                                    this.documentActionNotification('update', 'success')
                                    this.create_action_history('UPDATED')
                                }
                            } else {
                                this.notifMessage = put_request["error"].split(",");
                                this.documentActionNotification('update', 'error')
                            }
                        }
                    } else {
                        this.documentActionNotification('update', 'error')
                    }
                    this.spinning = false;
                }
            },
            async payLater(){
                 window.scrollTo(0,0);
                    this.spinning = true;
                    this.notifMessage = [];
                    var data = this.tabulator.getData();

                    if(["ORISOX"].includes(this.currentDocumentTypeCode)){
                        if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                            this.autoPostDD = true;
                        }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                            this.autoPostDDAndSI = true;
                        }
                    } 
                    //For RelDde Documents
                    if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                            //when goods issue
                            if (this.documentNumber > 0) {
                                var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                if (invalid != undefined){
                                    this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    return;
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }

                    if (this.isEditing && !this.isChangeAction) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        return;
                    } else {
                        if (component_x.documentNumber > 0) {
                            var params = (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)
                            if (post_request['success']){
                                this.openDocument(this.documentNumber)
                                this.documentActionNotification('post', 'success')
                                if (this.documentDetails.order_source=="shopee" && this.documentDetails.order_source=="shopify" && this.documentDetails.order_source=="lazada" && (this.autoPostDD || this.autoPostDDAndSI)){
                                    var message = (this.autoPostDD) ? "Auto posting of DD failed" : (this.autoPostDDAndSI) ? "Auto posting of DD, creation & posting of SI failed" : ""
                                    if (message !=""){
                                        this.$notification['warning']({
                                            message: message,
                                            description: "the setting is only applicable for manually created SO's."
                                        });
                                    }
                                } 
                            } else if (post_request['error']){
                                this.notifMessage = post_request['error'].split(',');
                                this.documentActionNotification('post', 'error')
                            }
                        }
                    }

                    this.spinning = false;
                    this.paymentDrawerVisible = false;
            },
            async post(){
                //Check Lot codes
                if (this.currentDocumentTypeCode.includes("REC")) {
                    this.notifMessage = [];
                    var data = this.tabulator.getData()
                    let require_lotcode_products = []
                    require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                    if(require_lotcode_products.length > 0 && this.documentNumber > 0) {
                        require_lotcode_products.forEach(row => {
                            var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                            var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                            this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    }
                    this.notifMessage = this._.compact(this.notifMessage);
                    if (this.notifMessage.length > 0) {
                        this.spinning = false;
                        this.documentActionNotification('post', 'error');
                        return;
                    }
                }

                if (['ORISOX','RELDDE','OTHSIN'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPaymentOnPosting || false == true) && this.forPaymentIsProcessed == false) {
                    this.forPaymentIsPosting = true;
                    this.showPaymentMethods();
                }else if (['ORIPOX'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableRecordingOfInitialDeposit || false == true) && this.forPaymentIsProcessed == false) {
                    this.forPaymentIsPosting = true;
                    this.showInitialDepositMethods();
                } else if(['RECDEL'].includes(this.currentDocumentTypeCode) && this.continueAutoCreatePoExceedRr == false) {
                    this.notifMessage = [];
                    var data = this.tabulator.getData()
                    let require_lotcode_products = []
                    require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                    if(require_lotcode_products.length > 0 && this.documentNumber > 0) {
                        require_lotcode_products.forEach(row => {
                            var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                             var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                            this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    }
                    this.notifMessage = this._.compact(this.notifMessage);
                    if (this.notifMessage.length > 0) {
                        this.spinning = false;
                        this.documentActionNotification('post', 'error');
                        return;
                    }

                    if (this.document_config.document_type_settings.receivingDocumentWithOrder.autoCreatePurchaseOrderExceedingQuantity == true && this.notifMessage.length == 0){
                        var result = await HTTPRequest.getRequest(this.endPoint + 'documents/check_has_exceeding_receiving_report/?document_id='+component_x.documentNumber, null)
                        if (result.exceeding == true){
                            this.$confirm({
                                title: 'Proceed?',
                                content: h => <div>This action will auto create PO documents from exceeding RR quantity</div>,
                                onOk: () => {
                                    this.continueAutoCreatePoExceedRr = true
                                    this.post()
                                },
                                onCancel() {}
                            });
                        } else {
                            this.continueAutoCreatePoExceedRr = true
                            this.post()
                        }
                    } else {
                            this.continueAutoCreatePoExceedRr = true
                            this.post()
                    }
                }else if(this.currentDocumentTypeCode=='OTHCNS' && this.continuePostCountSetDocument == false){
                    this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>Set not included products to zero (0) inventory ? </div>,
                        okText: 'Yes',
                        cancelText: 'No',
                        onOk: () => {
                            component_x.continuePostCountSetDocument = true
                            component_x.isSetOtherItemInventoryToZero = true
                            component_x.post()
                        },
                        onCancel() {
                            component_x.continuePostCountSetDocument = true
                            component_x.isSetOtherItemInventoryToZero = false
                            component_x.post()
                        }
                    });
                }else {
                    window.scrollTo(0,0);
                    this.spinning = true;
                    this.notifMessage = [];
                    var data = this.tabulator.getData();
                    if(["ORISOX"].includes(this.currentDocumentTypeCode)){
                        if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                            this.autoPostDD = true;
                        }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                            this.autoPostDDAndSI = true;
                        }
                    } 
                    //For RelDde Documents
                    if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                            //when goods issue
                            if (this.documentNumber > 0) {
                                var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                if (invalid != undefined){
                                    this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    return;
                                }
                            }
                        }
                    }
                    if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                        if (this.documentNumber > 0) {
                            var invalidDoc = data.find(row => row.requested_quantity == 0 && row.quantity == 0)
                            if (invalidDoc != undefined){
                                this.notifMessage.push("Zero quantity is not allowed in the document line");
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                return;
                            }
                            var checkQty = data.find(row => row.requested_quantity < row.quantity)
                            if (checkQty != undefined){
                                this.notifMessage.push("quantity must less than or equal to requested quantity");
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                return;
                            }
                            var checkNotAvailableQty = data.find(row => row.quantity > row.on_hand_quantity)
                            if (checkNotAvailableQty != undefined){
                                this.notifMessage.push("containing item that cannot be fulfilled because of lack of inventory.");
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                return;
                            }
                        }
                    }
                    if (data.length > 0) {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }

                    if (this.isEditing && !this.isChangeAction) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        if(this.currentDocumentTypeCode=='OTHCNS'){
                            this.continuePostCountSetDocument = false
                        }
                        this.spinning = false;
                        return;
                    } else {
                        if (component_x.documentNumber > 0) {
                            var params = (this.isSetOtherItemInventoryToZero) ? "&set_other_item_inventory_to_zero=true" : ""
                            params += (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)

                            var linecost_recompute_request = []
                            // 1935 - Line Cost (When posting Document with header discount)
                            if(this.headerDiscount.length > 0)
                            linecost_recompute_request = await HTTPRequest.postRequest(this.endPoint + 'documents/recompute_line_cost_with_discount/?document_id='+component_x.documentNumber+'&overallDiscountWithoutSupportDiscount='+component_x.overallDiscountWithoutSupportDiscount+'&grossAmount='+component_x.grossAmountDisplay, null)
                            // 1935 - Line Cost (When posting Document with header discount)

                            if ( (post_request['success'] && linecost_recompute_request['success'] && this.headerDiscount.length > 0) || (post_request['success'] && this.headerDiscount.length == 0) ){
                                this.openDocument(component_x.documentNumber);
                                this.documentActionNotification('post', 'success')
                            } else if (post_request['error']) {
                                if(this.currentDocumentTypeCode=='OTHCNS'){
                                    this.continuePostCountSetDocument = false
                                }
                                this.notifMessage = post_request['error'].split(',');
                                this.documentActionNotification('post', 'error')
                            }
                        }
                    }
                    this.spinning = false;
                    // this.paymentDrawerVisible = false;
                }
            },
            async voided() {
                window.scrollTo(0,0);
                this.spinning = true;
                var status = -1;
                var err_msg = [];
                await axios({
                    method: 'delete',
                    url: this.endPoint + 'documents/' + this.documentNumber,
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                })
                .then(function () {
                    status = 1;
                })
                .catch(function (e) {
                    err_msg = JSON.parse(e.request.response).error
                    status = 0;
                });
                if (status) {
                    this.openDocument(this.documentNumber)
                    this.documentActionNotification('void', 'success')
                    this.create_action_history('VOIDED')
                }  else {
                    this.notifMessage = err_msg
                    this.documentActionNotification('void', 'error')
                }
                this.spinning = false;
            },
            async confirm() {
                var data = this.tabulator.getData();
                if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                    if (this.documentNumber > 0) {
                        var invalidQty = data.find(row => row.quantity == 0)
                        if (invalidQty != undefined){
                            this.notifMessage.push("Zero quantity is not allowed in the document line");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkQty = data.find(row => row.requested_quantity < row.quantity)
                        if (checkQty != undefined){
                            this.notifMessage.push("quantity must less than or equal to requested quantity");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkNotAvailableQty = data.find(row => row.quantity > row.on_hand_quantity)
                        if (checkNotAvailableQty != undefined){
                            this.continueAutoCreateTr = true
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm?auto_create_tr='+this.continueAutoCreateTr, null, null)
                }else{
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm', null, null)
                }
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber)
                    this.documentActionNotification('confirm', 'success')
                    this.create_action_history('CONFIRMED')
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber)
                        this.documentActionNotification('confirm', 'success')
                        this.create_action_history('CONFIRMED')
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('confirm', 'error')
                    }
                }
            },
            deliver(){

            },

            downloadTemplate(type){
                if(type != "1") { return; }

                let urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic";

                if (this.currentDocumentTypeCode == "OTHPWS") {
                    // Import Mass Upload Products for PWS
                    // Selection between Barcode and Stock No field must be visible
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=pws_product&type=basic&save_via=${this.saveMassUploadProductVia}`;
                }

                axios({
                    url:  urlDownload,
                    method: 'POST',
                    responseType: 'blob', // important
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'product_import_template.csv');
                    document.body.appendChild(link);
                    link.click();
                    component_x.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the template for document upload.",
                        style: getNotificationStyle('success')
                    });
                });
            },

            showPaymentMethods(){
                this.paymentDrawerVisible = true
            },
            showInitialDepositMethods(){
                this.initialDepositDrawerVisible = true
            },
            async showBooking(){
                // https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order

                var activeBooking = await HTTPRequest.getRequest(this.endPoint + "document_bookings/get_active_booking?document_id="+ this.documentNumber, null);

                var siteId = secureStorage.getItem("defaultSiteId").toString();
                var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+ siteId, null);

                this.siteAddress = siteDetails.address;

                if(_.isEmpty(this.siteAddress) || _.isEmpty(this.customerAddress)){
                    this.$notification['error']({
                      message: 'Address Missing',
                      description: "Please make sure site and customer address are both configured.",
                      style: getNotificationStyle('error')
                    });
                    return;
                }

                this.bookingDrawerVisible = true
                this.siteContactNumber = siteDetails.telephone;
                this.siteContactPerson = siteDetails.contact_person;
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookingDetails = {}
                var response = {}
                if(activeBooking.length > 0){
                    this.bookingId = activeBooking[0].id
                    bookingDetails = activeBooking[0].booking_details
                    response = activeBooking[0].booking_details.order
                    this.activeBooking = true
                }  else {
                    var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                    bookingDetails = recomputeRequest
                    response = recomputeRequest.order
                }
                // var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)

                this.bookingDetails = bookingDetails;
                var response = response;
                this.recompute = false;
                this.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                this.markers = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                this.originalGeoLocation = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                // this.$notification['success']({
                //   message: 'Completed Recomputation',
                //   description: "Please see updated booking fee."
                // });

                    // await axios({
                    //     method: 'post',
                    //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                    //     data: this.orderParemeters,
                    //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                    // })
                    // .then(function (response) {
                    //     component_x.bookingDetails = response.data;
                    //     var response = response.data.order;

                    //     component_x.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                    //     component_x.markers = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]

                    //     component_x.originalGeoLocation = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]
                    //     // component_x.paymentMethods = response.data
                    // })
                    // .catch(async function (error) {
                    // })
            },
            async recomputeBooking(){
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                this.bookingDetails = recomputeRequest;
                this.recompute = false;
                this.$notification['success']({
                  message: 'Completed Recomputation',
                  description: "Please see updated booking fee.",
                  style: getNotificationStyle('success')
                });

                // await axios({
                //     method: 'post',
                //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                //     data: this.orderParemeters,
                //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                // })
                // .then(function (response) {
                //     component_x.bookingDetails = response.data;
                //     component_x.recompute = false;
                //     // componennt_x.originalGeoLocation = component_x.markers
                // })
                // .catch(async function (error) {
                // })

                this.recomputeModal = false
            },
            async proceedBooking(){
                if(this.recompute == true){
                    this.recomputeModal = true
                }else{
                    this.bookingProper()
                }
            },
            async cancelBooking(){
                var cancelRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/cancel_booking?booking_id=' + this.bookingId , null, this.orderParemeters)
                this.$notification['success']({
                  message: 'Success',
                  description: "Your booking is successfully cancelled.",
                  style: getNotificationStyle('success')
                });
                this.activeBooking = false
            },
            async bookingProper(){
                this.recomputeModal = false
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/book?document_id=' + this.documentNumber , null, this.orderParemeters)

                if(bookRequest.error == undefined){
                    this.bookingDetails = bookRequest;
                    this.recompute = false;
                    this.$notification['success']({
                      message: 'Waiting for driver..',
                      description: "We will notify you once booking has been accepted.",
                      style: getNotificationStyle('success')
                    });
                    this.activeBooking = true
                } else {
                    this.$notification['error']({
                      message: 'Failed to book.',
                      description: bookRequest.error,
                      style: getNotificationStyle('error')
                    });
                }


                // await axios({
                //     method: 'post',
                //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/create-order",
                //     data: this.orderParemeters,
                //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                // })
                // .then(function (response) {
                //     component_x.bookingDetails = response.data;
                //     component_x.$notification['success']({
                //       message: 'Waiting for driver...',
                //       description: "We will notify you once booking has been accepted."
                //     });
                // })
                // .catch(async function (error) {
                // })
            },
            async pay(documentNumber){
                this.spinning = true;
                var curr_document = await HTTPRequest.getRequest(this.endPoint + "documents/"+ documentNumber, null);

                if(this.paymentMode == "paymaya"){
                    var request_body = {
                        type: "paymaya",
                        document: curr_document
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                    if(post_request["error"] == undefined){
                        if (this.forPaymentIsPosting == true) {
                            this.forPaymentIsProcessed = true;
                            this.post();
                        }else{
                        this.openDocument(documentNumber);
                        this.documentActionNotification('pay', 'success')
                    }
                    }
                } else if(this.paymentMode == "dragonpay") {
                    this.paymentErrors = []
                    if (this.paymentMethod == null) {
                        this.paymentErrors.push("Please select a payment method")
                    }else{
                        var request_body = {
                            type: "dragonpay",
                            document: curr_document,
                            procId: this.paymentMethod
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.post();
                            }else{
                                this.openDocument(documentNumber)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                } else {
                    this.paymentErrors = []
                    if (this.bankTransferReference == "") {
                        this.paymentErrors.push("Please input a reference number")
                    }else{
                        var request_body = {
                            type: "bank",
                            document: curr_document,
                            reference: this.bankTransferReference
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)
                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.post();
                            }else{
                                this.openDocument(documentNumber)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                }
                this.spinning = false;
            },
            async unconfirm() {
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/unconfirm', null, null)
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber)
                    this.documentActionNotification('unconfirm', 'success')
                    this.create_action_history('UNCONFIRMED')
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber)
                        this.documentActionNotification('unconfirm', 'success')
                        this.create_action_history('UNCONFIRMED')
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('unconfirm', 'error')
                    }
                }
            },
            async create_action_history(action) {
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    document_id: this.documentNumber,
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
            },
            async freeze(){
                window.scrollTo(0,0);
                this.spinning = true;
                this.notifMessage = [];
                var data = this.tabulator.getData();

                if (data.length > 0) {
                    this.isEditing = !(component_x.origData === JSON.stringify(data))
                }

                if (this.isEditing && !this.isChangeAction) {
                    this.notifMessage.push("You have unsaved changes, please save before freezing inventory")
                    this.documentActionNotification('freeze', 'error');
                    this.spinning = false;
                    return;
                } else {
                    if (component_x.documentNumber > 0) {
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/freeze/?document_id='+component_x.documentNumber, null)
                        post_request
                        if (post_request['success']){
                            this.openDocument(component_x.documentNumber)
                            this.documentActionNotification('freeze', 'success')
                        } else if (post_request['error']){
                            this.notifMessage = post_request['error'].split(',');
                            this.documentActionNotification('freeze', 'error')
                        }
                    }
                }
                this.spinning = false;
            },
            autocompleteFilterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
                );
            },
            async toggleDocumentTrade(){
                this.isDocumentTrade = !this.isDocumentTrade
                await this.tabulator.clearData();
                this.calculateSummary();
            },
            refreshDocument() {
              this.openDocument(this.documentNumber);
            },
            async print(isDefaultPrint, customFont){
                let headerCustomPosition = 0
                let xCustomPosition = 0
                if(customFont == 'dotMatrix') {
                    headerCustomPosition = -10
                    xCustomPosition = 10
                }
                this.printDefault = isDefaultPrint;
                this.spinning = true;

                // alert("Font Size: " + this.printFontSizeIncrease)
                var fontSizeIncreaser = this.printFontSizeIncrease || 0
                var valueHeaderPos = this.printValueHeaderPos
                var valueFooterPos = this.printValueFooterPos

                var friendlyOriginDocumentNo = component_x.friendlyOriginDocumentNo || ''
                var currentDocumentTypeCode = this.currentDocumentTypeCode || ''
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                const currentSiteId = secureStorage.getItem("defaultSiteId") || '';
                let requestingSiteName = this.requestingSite.label;
                let requestingSiteId = this.requestingSite.key;

                var userCode = secureStorage.getItem("userCode") || '';
                var createdBy = this.createdBy || '';
                var postedBy = this.postedBy || '';


                var siteName = this.distributionSite.label || ''
                var customerName = this.customer.label || ''
                var customerAddress = this.customerAddress.trim() || ''

                var supplier = this.supplier.label || ''
                var supplyingBranch = this.supplyingSite.label || ''
                var requestingBranch = this.requestingSite.label || ''
                var sublocationSite = this.distributionSite.label || ''
                var originSublocation =  this.originSublocation.label || ''
                var destinationSublocation = this.destinationSublocation.label || ''
                var party = this.party || ''

                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''

                var reference = this.reference || ''
                var referenceLabel = this.referenceLabel || 'Reference'
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''

                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''

                var doc = new jsPDF();
                let currencyKey = component_x.currency.key;
                let currencyLabel = component_x.currency.label;
                let currencyRate = (component_x.documentDetails.currency_rate!=0 && component_x.documentDetails.currency_rate!=null && component_x.documentDetails.currency_rate!=undefined && component_x.documentDetails.currency_rate!='0.0') ? component_x.documentDetails.currency_rate : '1';
                var header_position = 130 + headerCustomPosition
                var value_position = 170
                var line_position = 195
                var total_plus_width = 0
                var minus_height = 0
                var initial_deposit = 0
                var balance = 0
                var orientation = "portrait"
                var papersize = "a4"
                var x_position = 0
                var showDiscountAmountValue = 0
                var showTotalVatValue = 0

                if (currencyKey>0 && component_x.showConversionRate){
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    var subtotal_php = this.tabulator.getColumn("subtotal_php")
                    await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var cost_php = this.tabulator.getColumn("price_php")
                    await cost_php.updateDefinition({downloadTitle: "Cost", download:true})
                }
                // // for all type document code Purchase to payment
                // commented by EJ
                // if(currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'RELRSR'){
                //     if (this.document_config.document_type_settings.printSettings!= undefined){
                //         if(this.document_config.document_type_settings.printSettings.enableLandscapePrinting != undefined && this.document_config.document_type_settings.printSettings.enableLandscapePrinting == true){
                //             orientation = "landscape"
                //             header_position = 220
                //             value_position = 260
                //             line_position = 280
                //             minus_height = 85
                //             total_plus_width = 70
                //         }
                //         if(this.document_config.document_type_settings.printSettings.showRefCode!=undefined &&this.document_config.document_type_settings.printSettings.showRefCode == true ){
                //             var ref_code = this.tabulator.getColumn("ref_code")
                //             await ref_code.updateDefinition({download: true, visible: true})
                //         }
                //     }
                // }
                // //end  for all type document code Purchase to payment

                if(currentDocumentTypeCode == 'OTHPWS'){
                    papersize = "a4"
                    orientation = "landscape"
                    header_position = 220 + headerCustomPosition
                    value_position = 300
                    line_position = 280
                    minus_height = 85
                    total_plus_width = 70
                    var old_landed_cost = this.tabulator.getColumn("old_landed_cost")
                    await old_landed_cost.updateDefinition({download:true})
                    var old_original_cost = this.tabulator.getColumn("old_original_cost")
                    await old_original_cost.updateDefinition({download:true})
                    var original_cost = this.tabulator.getColumn("original_cost")
                    await original_cost.updateDefinition({download:true})
                    var old_ordering_cost = this.tabulator.getColumn("old_ordering_cost")
                    await old_ordering_cost.updateDefinition({downloadTitle: "Old ORD", download:true})
                    var ordering_cost = this.tabulator.getColumn("ordering_cost")
                    await ordering_cost.updateDefinition({downloadTitle: "New ORD", download:true})
                    var old_wholesale_price = this.tabulator.getColumn("old_wholesale_price")
                    await old_wholesale_price.updateDefinition({downloadTitle: "Old WHS Price", download:true})
                    var wholesale_price = this.tabulator.getColumn("wholesale_price")
                    await wholesale_price.updateDefinition({downloadTitle: "New WHS Price", download:true})
                    var old_least_price = this.tabulator.getColumn("old_least_price")
                    await old_least_price.updateDefinition({downloadTitle: "Old LS Price", download:true})
                    var least_price = this.tabulator.getColumn("least_price")
                    await least_price.updateDefinition({downloadTitle: "New LS Price", download:true})
                    var old_special_price = this.tabulator.getColumn("old_special_price")
                    await old_special_price.updateDefinition({downloadTitle: "Old SP Price", download:true})
                    var special_price = this.tabulator.getColumn("special_price")
                    await special_price.updateDefinition({downloadTitle: "New SP Price", download:true})
                    var markup_percent = this.tabulator.getColumn("markup_percent")
                    await markup_percent.updateDefinition({downloadTitle: "Markup %", download:true, accessorParams:{}, 
                        accessor:function(value, data, accessorParams){
                            return Number(value).toFixed(2);
                        }})
                    var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                    await document_line_serials_text.updateDefinition({download:false})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    // var stock_no = this.tabulator.getColumn("stock_no")
                    // await stock_no.updateDefinition({width: 5})

                }
                if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                }
                if (this.document_config.document_type_settings.printSettings!= undefined){
                    if(this.document_config.document_type_settings.printSettings.showRefCode!=undefined && this.document_config.document_type_settings.printSettings.showRefCode == true){
                        var ref_code = this.tabulator.getColumn("ref_code")
                        ref_code.updateDefinition({download: true})
                    }
                    
                    if(this.document_config.document_type_settings.printSettings.showStockNoInProductList!=undefined && this.document_config.document_type_settings.printSettings.showStockNoInProductList==true){
                        var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                        supplier_stock_no.updateDefinition({download:true})
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                            this.tabulator.showColumn("supplier_stock_no")
                        }
                    }
                    if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                        var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                        supplier_stock_no.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                        var design = this.tabulator.getColumn("design")
                        design.updateDefinition({download:true})
                        var size = this.tabulator.getColumn("size")
                        size.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                        this.showDocumentPayment("initialDeposit")
                        initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                    }
                    if(this.document_config.document_type_settings.printSettings.enableLandscapePrinting != undefined && this.document_config.document_type_settings.printSettings.enableLandscapePrinting == true){
                        orientation = "landscape"
                        header_position = 220 + headerCustomPosition
                        value_position = 260
                        line_position = 280
                        minus_height = 85
                        if (!this.document_config.document_type_settings.printSettings.showStockNoInProductList){
                            total_plus_width = 58
                        }else {
                            total_plus_width = 66
                        }
                    }

                    if(!this.document_config.document_type_settings.printSettings.showSerialNoInProductList){
                        total_plus_width = 78
                    }

                    if(this.document_config.document_type_settings.printSettings.showTotalVat != undefined && this.document_config.document_type_settings.printSettings.showTotalVat == true){
                        var showTotalVat = this.document_config.document_type_settings.printSettings.showTotalVat
                        showTotalVatValue = this.documentDetails.tax_amount
                    }
                    if(this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat != undefined && this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat == true){
                        var showNetAmountWithoutVat = this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat
                    }
                    if(this.document_config.document_type_settings.printSettings.showTotalPrice != undefined && this.document_config.document_type_settings.printSettings.showTotalPrice == true){
                        var showTotalPrice = this.document_config.document_type_settings.printSettings.showTotalPrice
                    }
                    if(this.document_config.document_type_settings.printSettings.showDiscountAmount != undefined && this.document_config.document_type_settings.printSettings.showDiscountAmount == true){
                        var showDiscountAmount = this.document_config.document_type_settings.printSettings.showDiscountAmount
                        showDiscountAmountValue = Number((component_x.discountTotal * 100)/100) ||  Number(this.documentDetails.amount_header_discount)
                    }
                    if(this.document_config.document_type_settings.printSettings.showOtherCharges != undefined && this.document_config.document_type_settings.printSettings.showOtherCharges == true){
                        var showOtherCharges = this.document_config.document_type_settings.printSettings.showOtherCharges
                    }
                }

                let tempdata = this.tabulator.getData();
                var column_names = []
                if(currentDocumentTypeCode =='OTHCNS'){
                    var document_lines = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_count_set_pcount_lines?id="+component_x.documentNumber, null);
                    this.tabulator.replaceData(document_lines)
                    this.tabulator.toggleColumn("line_no")
                    this.tabulator.toggleColumn("product_name")
                    this.tabulator.toggleColumn("stock_no")
                    this.tabulator.toggleColumn("barcode")
                    this.tabulator.toggleColumn("unit_id")
                    this.tabulator.toggleColumn("quantity")
                    this.tabulator.getColumn('actual_quantity').updateDefinition({title:"Frozen Quantity"})
                    this.tabulator.toggleColumn("actual_quantity")
                    this.tabulator.toggleColumn("price")
                    this.tabulator.toggleColumn("cost")
                    this.tabulator.toggleColumn("subtotal")
                    this.tabulator.toggleColumn("on_hand_quantity")
                }else if ((currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK') && isDefaultPrint == false){
                    var lines = this.tabulator.getData();
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            lines[i].site_allocation.forEach(function(obj) {
                                if (currentDocumentTypeCode=='OTHPCK'){
                                    var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                    lines[i][`${obj.code}`] = qty
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    lines[i][`${obj.code}`] = qty
                                }
                                if (!column_names.includes(obj.code)) {
                                    column_names.push(obj.code);
                                }
                            });
                        }
                    }
                    this.tabulator.replaceData(lines)
                    for (var index = 0; index < column_names.length; index++) { this.tabulator.addColumn({title:column_names[index], field:column_names[index], download: true, visible:false, align: 'right'}) }
                    if (column_names.length > 5){
                        this.continueWithPrintPdf = false
                        this.$confirm({
                        title: "Allocation is more than 5 sites, print to pdf is not possible",
                        content: h => <div>Do you want to export this via excel?</div>,
                        onOk: () => {
                            this.downLoadExcelIfMoreThan5Site()
                        },
                        onCancel() {}
                        });
                    }
                }

                let siteData = {};
                let supplierData = {};
                if (this.continueWithPrintPdf){
                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                    requestingSiteId = this.documentDetails.site_id.key
                    requestingSiteName = this.documentDetails.site_id.label
                    siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}` , null, null);
                    supplierData = await HTTPRequest.getRequest(`${this.endPoint}suppliers/${this.supplier.key}` , null, null);
                        if(component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                            var imgLogo = new Image()
                            var arrImgLogos = []
                            var config = {
                                method: 'get',
                                url: `${this.endPoint}documents/get_product_image?stock_no=${this.tabulator.getData()[0].stock_no}`,
                                headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File"},
                                // headers: {'Authorization': 'Bearer ' + 'BX-pG09P8sgsNKczX9CtRaxNeH7S_kD6NCuxC3Twzo0'},
                            }
                            var imageResponse;
                            await axios(config)
                                .then(function (response) {
                                    imageResponse = response.data
                                })
                                .catch(function (error) {
                                    console.log(error)
                            });

                            if(imageResponse["error"] == undefined){
                                if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                    for(let  i = 0; i < imageResponse.images_url.length; i++){
                                        var img = new Image()
                                        img.src = imageResponse.images_url[i]
                                        arrImgLogos.push(img)
                                    }
                                }
                                else if (imageResponse.image != undefined && imageResponse.image != ""){
                                    imgLogo.src = "data:image/"+imageResponse.file_type+";base64,"+imageResponse.image
                                    var stock_no = this.tabulator.getData()[0].stock_no
                                }
                            }
                            console.log(arrImgLogos)
                        }
                    }
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var startY = 90

                    // console.log("instance: ",tabulatorInstance.getColumns());
                    tabulatorInstance.downloadToTab("pdf", "data"+isDefaultPrint+".pdf", {
                        orientation:orientation,
                        jsPDF:{
                            unit:"mm",
                            putOnlyUsedFonts:true,
                            // format: this.printPaperSize,
                            format:papersize
                        },
                        autoTable:function(doc){
                            // tabulatorInstance.getColumns({download: true});
                            //HEADER
                            doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
                            doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
                            doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
                            doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');
                            if(customFont == 'dotMatrix'){
                                doc.setFont("Epson1");
                            }
                            if (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'RECCSR') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(siteName, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Customer:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(customerName, 40, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                                if (customerAddress.length > 50){
                                    var cut = customerAddress.length /4;
                                    doc.text(customerAddress.slice(0, cut).trim(), 40, 65);
                                    doc.text(customerAddress.slice(cut, cut*2).trim(), 40, 70);
                                    doc.text(customerAddress.slice(cut*2, cut*3).trim(), 40, 75);
                                    doc.text(customerAddress.slice(cut*3, cut*4).trim(), 40, 80);
                                }else {
                                    doc.text(customerAddress, 40, 65);
                                }
                            }

                            if (currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'RECDEL' ||
                                currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.setFontStyle("bold");
                                const supplierAddress = supplierData.billing_address || '';
                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplier}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 90);
                                doc.text(15, 50, splitTitle);
                                doc.setFontStyle("normal");
                                }

                            if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' ) {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.setFontStyle("bold");
                                // doc.text(supplier, 40, 50);
                                const supplierName = supplierData.name || '';
                                const supplierAddress = supplierData.billing_address || '';
                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplierName}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 90);
                                doc.text(15, 50, splitTitle);
                                doc.setFontStyle("normal");
                            }

                            if (currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ' || currentDocumentTypeCode == 'RELTRX' || currentDocumentTypeCode == 'RECTRX' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ' || currentDocumentTypeCode == 'RELCSX' || currentDocumentTypeCode == 'RECCSX') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Supplying Branch:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(supplyingBranch, 50 + xCustomPosition, 50);
                                doc.setFontStyle("normal");

                                doc.text("Requesting Branch:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(requestingBranch, 50 + xCustomPosition, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);
                            }

                            if (currentDocumentTypeCode == 'RELSLO' || currentDocumentTypeCode == 'RECSLI') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(sublocationSite, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Origin:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(originSublocation, 40, 60);
                                doc.setFontStyle("normal");

                                doc.text("Destination:", 15, 70);
                                doc.setFontStyle("bold");
                                doc.text(destinationSublocation, 40, 70);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                            }

                            if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Party:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(party, 40, 50);
                                doc.setFontStyle("normal");
                            }

                            doc.setFontSize(10 + fontSizeIncreaser);
                            doc.text(currentDocumentTypeFriendlyCode+" Date:", header_position, 50);
                            doc.text(documentDate, value_position, 50);
                            doc.text(((currentDocumentTypeFriendlyCode === 'PWS') ? "Effectivity Date:" : "Target Date:"), header_position, 55);
                            doc.text(targetDate, value_position, 55);
                            if(currentDocumentTypeFriendlyCode != 'PWS') {
                                x_position = 60
                                doc.text("Cancellation  Date:", header_position, x_position);
                                doc.text(cancellationDate, value_position, x_position);
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.text(reference, value_position, x_position + 5);
                                doc.text("Currency:", header_position, x_position + 10);
                                doc.text(currencyLabel, value_position, x_position + 10);
                                doc.text("Currency Rate:", header_position, x_position + 15);
                                doc.text(currencyRate, value_position, x_position + 15);
                            } else {
                                x_position = 55
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.text(reference, value_position, x_position + 5);
                                x_position = 45
                                startY = 80
                            }

                            doc.text("Status:", header_position, x_position + 20);
                            doc.text(documentStatus, value_position, x_position + 20);
                            doc.text("Purpose:", 15,  x_position + 20);
                            doc.text(purpose, 40,  x_position + 20);
                            doc.text("Remark:", 15, x_position + 25);
                            doc.text(remark, 40, x_position + 25);
                            if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RECDEL'){
                                if (component_x.document_config.document_type_settings.printSettings!= undefined){
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                        doc.text("Price Inclusion:", 15, 90);
                                        doc.text(priceInclusion, 40, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                        doc.text("Comment 1:", 15, 95);
                                        doc.text(comment1, 40, 95);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                        doc.text("Comment 2:", 15, 100);
                                        doc.text(comment2, 40, 100);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                        doc.text("Initial Deposit:", header_position, 90);
                                        doc.text(initial_deposit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                        balance = (calculation.bottom.subtotal).toFixed(2) - initial_deposit.toFixed(2)
                                        doc.text("Balance:", header_position, 95);
                                        doc.text(balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 95);
                                    }
                                }
                                startY = 105
                                doc.text("Total:", header_position, 100);
                                doc.text(calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 100);
                            }

                            let stockNoWidth = 30;

                            if (currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RELDEL') {
                                stockNoWidth = 20;
                            }

                            doc.line(15, startY, line_position, startY);
                            return {
                                didParseCell: function (table) {
                                    if (table.section === 'head' && (table.column.index == 8 || table.column.index == 9 || table.column.index == 10 || table.column.index == 11 || table.column.index == 12)) {
                                        table.cell.styles.halign = 'right';
                                    }
                                    if(table.column === 'body'){
                                        console.log(table.column)
                                    }
                                    if((currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') && !component_x.accessRights.includes('Z')){
                                        if (table.section === 'body' && (table.column.index == 7 || table.column.index == 8 || table.column.index == 9 || table.column.index == 10 || table.column.index == 11 || table.column.index == 12)) {
                                            table.cell.text = '******';
                                        }
                                    }
                                },
                                didDrawPage: function (data) {
                                    //Main Header
                                    var logobarter = document.getElementById('logobarter');
                                    doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
                                    doc.setFontStyle("bold");
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR') {
                                    doc.text(requestingSiteName, 40, 25);
                                    } else {
                                    doc.text(currentSiteName, 40, 25);
                                    }


                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                                    doc.setFontSize(9 + fontSizeIncreaser);
                                    const companyName = siteData.company_name || '';
                                    const companyAddress = siteData.address || '';
                                    const tin = siteData.tin || '';
                                    let splitTitle = doc.splitTextToSize(`Company Name: ${companyName}\nAddress: ${companyAddress}\nTIN #: ${tin}`, 75);
                                    doc.text(40, 30, splitTitle);
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    }

                                    doc.setFontStyle("normal");
                                    doc.text(documentType, header_position, 25);
                                    doc.text("# "+String(documentNumber), header_position, 35);
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                    doc.text(String(friendlyOriginDocumentNo), header_position, 40);
                                    doc.line(15, 265-minus_height, line_position, 265-minus_height);

                                    doc.text("Printed By:", 15, 270-minus_height);
                                    doc.text(userCode, 35 + xCustomPosition, 270-minus_height);

                                    doc.text("Created By:", 70, 270-minus_height);
                                    doc.text(createdBy, 90 + xCustomPosition, 270-minus_height);

                                    doc.text("Posted By:", 125, 270-minus_height);
                                    doc.text(postedBy, 145 + xCustomPosition, 270-minus_height);

                                    doc.text("Print Date:", 15, 275-minus_height);
                                    doc.text(printDate, 35 + xCustomPosition, 275-minus_height)
                                    doc.text("Post Date:", 15, 280-minus_height);
                                    doc.text(postDate, 35 + xCustomPosition, 280-minus_height)

                                },
                                startY: startY,
                                margin: {top: 50, bottom: 58},
                                bodyStyles: {
                                    fontSize: 7 + fontSizeIncreaser
                                },
                                headStyles: {
                                    fontSize: 8 + fontSizeIncreaser,
                                    halign: 'center',
                                    valign: 'middle'
                                },
                                styles: {
                                 overflow: 'linebreak',
                                 font: (customFont == 'dotMatrix') ? 'Epson1' : null
                                },
                                // columnStyles: { text: { cellWidth: 'auto' } },
                                theme: 'plain',
                                columnStyles: {
                                    0: {
                                        halign: 'center',
                                        cellWidth: 'auto'
                                    },
                                    1: {
                                        cellWidth: (component_x.document_config.document_type_settings.printSettings.showStockNoInProductList == true) ? stockNoWidth : 'auto'
                                    },
                                    2: {
                                        cellWidth: 'auto'
                                    },
                                    3: {
                                        cellWidth: 25
                                    },
                                    4: {
                                        cellWidth: 15
                                    },
                                    5: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  component_x.document_config.document_type_settings.printSettings.showRefCode == true && component_x.document_config.document_type_settings.printSettings.showStockNoInProductList != true)? 'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  component_x.document_config.document_type_settings.printSettings.showRefCode == true && component_x.document_config.document_type_settings.printSettings.showStockNoInProductList != true) ? 20 : 15
                                    },

                                    6: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  component_x.document_config.document_type_settings.printSettings.showRefCode == true && component_x.document_config.document_type_settings.printSettings.showStockNoInProductList == true) ?  'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  component_x.document_config.document_type_settings.printSettings.showRefCode == true && component_x.document_config.document_type_settings.printSettings.showStockNoInProductList == true) ? 25 : 20
                                    },
                                    7: {
                                        halign: 'right',
                                        cellWidth: 15
                                    },
                                    8: {
                                        halign: 'right',
                                        cellWidth: 15
                                    },
                                    9: {
                                        halign: 'right',
                                        cellWidth: 15
                                    },
                                    10: {
                                        halign: 'right',
                                    },
                                    11: {
                                        halign: 'right',
                                    },
                                    12: {
                                        halign: 'right',
                                    },
                                    13: {
                                        halign: 'right',
                                    },
                                }
                            };
                        },
                        documentProcessing:function(doc){
                            let showRefCodeAdjustXpos = 13;
                            if(component_x.document_config.document_type_settings.printSettings.showRefCode!=undefined && component_x.document_config.document_type_settings.printSettings.showRefCode==true){
                                showRefCodeAdjustXpos += 2;
                            }
                            let quantityTotalWidth = 145 + showRefCodeAdjustXpos;
                            let priceTotalWidth = 163 + showRefCodeAdjustXpos;
                            let subTotalWidth = 178 + showRefCodeAdjustXpos;
                            if (currentDocumentTypeCode == 'RELRSR') {
                                priceTotalWidth = 161;
                                subTotalWidth = 181;
                            } else if (currentDocumentTypeCode == 'ORIPOX') {
                                if(component_x.document_config.document_type_settings.printSettings.showRefCode!=undefined && component_x.document_config.document_type_settings.printSettings.showRefCode==true){
                                    quantityTotalWidth = 165;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 205;
                                } else {
                                    quantityTotalWidth = 155;
                                    priceTotalWidth = 175;
                                    subTotalWidth = 195;
                                }
                            }else if (currentDocumentTypeCode == 'RECDEL'){
                                if(component_x.document_config.document_type_settings.printSettings.showRefCode!=undefined && component_x.document_config.document_type_settings.printSettings.showRefCode==true){
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 206;
                                } else {
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 190;
                                    subTotalWidth = 207;
                                }
                            }

                            doc.setFontSize(7 + fontSizeIncreaser);
                            const pageCount = doc.internal.getNumberOfPages();
                            const finalY = doc.lastAutoTable['finalY'];
                            for(var i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                doc.text('Page ' + String(i) + ' of ' + String(pageCount),value_position,280 - minus_height);
                            }

                            doc.setFontStyle("bold");
                            var formatMyNumber = function (number, decimal) {
                                var splitNum;
                                number = Math.abs(number);
                                number = number.toFixed(decimal);
                                splitNum = number.split('.');
                                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return splitNum.join(".");
                            }
                            // Issue: 1474
                            // Update PO Print-out to include subtotal and total cost
                            doc.line(15, finalY, line_position, finalY, 'F');
                            if (currentDocumentTypeCode == 'ORIPOX'){
                                if(component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                                    if(imageResponse["error"] == undefined){
                                        if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                            let x = 20
                                            arrImgLogos.forEach(el => {
                                                doc.addImage(el,'JPEG', x,finalY + 3,15,15)
                                                x += 15
                                            })
                                        }
                                        else if (imageResponse.image != undefined && imageResponse.image != ""){
                                            doc.addImage(imgLogo, imageResponse.file_type, 30, 63, 14, 14);
                                        }
                                    }
                                    // doc.text("stock no:"+stock_no, 26, 59);
                                    // doc.setFontStyle("normal");
                                    // doc.setFontSize(5);
                                }
                            }

                            if(currentDocumentTypeCode != 'OTHPWS'){
                                var positionTQ = 255
                                var positionTC = 259
                                var positionS = 263
                                var postionDA = 0
                                var positionNWOV = 0
                                var positionTP = 0
                                var positionTV = 0
                                if (showDiscountAmount){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA = positionS+4
                                    positionNWOV+=4
                                    positionTP+=4
                                    positionTV+=4
                                }
                                if (showTotalVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV = positionS+positionTV+4
                                    positionNWOV+= 4
                                    positionTP+=4
                                }
                                if(showNetAmountWithoutVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV = positionS+positionNWOV+4
                                    positionTP+=4
                                }
                                if(showTotalPrice){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV-=4
                                    positionTP = positionS+positionTP+4
                                }
                                if(currencyKey>0 && component_x.showConversionRate){
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text(doc.splitTextToSize((calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text(doc.splitTextToSize((calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionTQ-minus_height, 'right')
                                    doc.text("Total Cost:", 15, positionTC-minus_height)
                                    doc.text((calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionTC-minus_height, 'right')
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text((calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 50, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }else{
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text(doc.splitTextToSize((calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text(doc.splitTextToSize((calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text(formatMyNumber(calculation.bottom.quantity, 0), 60, positionTQ-minus_height, 'right')
                                    doc.text("Total Cost:", 15, positionTC-minus_height)
                                    doc.text(formatMyNumber(calculation.bottom.price, 2), 60, positionTC-minus_height, 'right')
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(formatMyNumber(calculation.bottom.subtotal, 2), 60, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 60, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }
                            }
                            doc.setFontStyle("normal");
                            doc.setFontSize(6 + fontSizeIncreaser);
                            doc.text("Noted By:", 75, 252-minus_height)
                            doc.text("____________________________________", 95, 252-minus_height)
                            doc.text("Verified By:", 75, 256-minus_height)
                            doc.text("____________________________________", 95, 256-minus_height)
                            doc.text("Approved By:", 75, 260-minus_height)
                            doc.text("____________________________________", 95, 260-minus_height)
                        }
                    });
                    if(currentDocumentTypeCode =='OTHCNS'){
                        this.tabulator.replaceData(tempdata)
                        var line_no = this.tabulator.getColumn("line_no")
                        line_no.updateDefinition({visible:false})
                        var product_name = this.tabulator.getColumn("product_name")
                        product_name.updateDefinition({visible:false})
                        var stock_no = this.tabulator.getColumn("stock_no")
                        stock_no.updateDefinition({visible:false})
                        var ref_code = this.tabulator.getColumn("ref_code")
                        ref_code.updateDefinition({visible:false})
                        var barcode = this.tabulator.getColumn("barcode")
                        barcode.updateDefinition({visible:false})
                        var unit_id = this.tabulator.getColumn("unit_id")
                        unit_id.updateDefinition({visible:false})
                        var quantity = this.tabulator.getColumn("quantity")
                        quantity.updateDefinition({visible:false})
                        var actual_quantity = this.tabulator.getColumn("actual_quantity")
                        actual_quantity.updateDefinition({visible:false})
                        var _price = this.tabulator.getColumn("price")
                        _price.updateDefinition({visible:false})
                        var cost = this.tabulator.getColumn("cost")
                        cost.updateDefinition({visible:false})
                        var _subtotal = this.tabulator.getColumn("subtotal")
                        _subtotal.updateDefinition({visible:false})
                        var on_hand_quantity = this.tabulator.getColumn("on_hand_quantity")
                        on_hand_quantity.updateDefinition({visible:false})
                    }else if (currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                        for (var index = 0; index < column_names.length; index++) {
                            var customField = this.tabulator.getColumn(column_names[index])
                            customField.updateDefinition({visible:false,download:false})
                        }
                    }
                }
                this.spinning = false;
            },
            addProductCancel() {
                this.addProductConfirmationVisible = false;
            },
            handleAddProductVisibleChange(addProductConfirmationVisible){
                if (!addProductConfirmationVisible) {
                    this.addProductConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'ORISOX') {
                    if (Number(this.quantity) <= Number(this.onHandQuantity)) {
                        this.addProduct();
                    } else {
                        this.addProductConfirmationVisible = true;
                    }
                }else{
                    this.addProduct();
                }
            },
            unitAccessor(value, data){
                var response = '';
                var label = 'No Product Unit'
                var unit_label = data.unit_label
                if (unit_label!=undefined){
                    label = unit_label
                }else{
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/'+data.product_id+'/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                     request.setRequestHeader('Request-Source', 'BXI-Web');
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == data.unit_id.toString()).label;
                            } catch (error) {}
                        }
                    }
                }
                return label;
            },
            async openDocument(document_id){
                secureStorage.setItem("temp_document_id", document_id);
                secureStorage.setItem('documentTypeCode',this.currentDocumentTypeCode)
                secureStorage.setItem('DataOptions',this.$options.data())
                if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                    Object.assign(this.$data, this.$options.data());
                }else{
                    this.tabulator.clearData();
                    Object.assign(this.$data.options, secureStorage.getItem('DataOptions').options)
                }
                this.documentNumber = secureStorage.getItem('temp_document_id');
                this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                this.initializeDocument();
                if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                    this.backLink = "/products_v2?type=OTHPWS"
                } else {
                    this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
                }
            },
            async openOriginDocument(document_id){
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules' , null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === this.originDocumentTypeId)
                    if (origin_document_type) {
                        var origin_trans_code = origin_document_type.trans_code
                        var origin_type_code = origin_document_type.type_code
                        var origin_document_type = documentTypes.find(x => x.trans_code === origin_trans_code && x.type_code === origin_type_code)
                        if(origin_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: origin_trans_code+origin_type_code+" origin document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", document_id);
                        secureStorage.setItem("documentTypeId", origin_document_type.id);
                        secureStorage.setItem("documentTypeName", origin_document_type.name);
                        secureStorage.setItem("documentTypeCode", origin_document_type.trans_code+origin_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", origin_document_type.friendly_code);
                        Object.assign(this.$data, this.$options.data());
                        this.documentNumber = secureStorage.getItem('temp_document_id');

                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                        this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                        this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                        this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                    }
                }
                this.initializeDocument();
            },
            async processChildDocument(isASN){
                var originDocumentNumber = this.documentNumber
                var originDocumentTypeId = this.currentDocumentTypeId
                var originDocumentTypeName = this.currentDocumentTypeName
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules', null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === this.currentDocumentTypeId)
                    if (origin_document_type) {
                        if (isASN) {
                            var child_trans_code = origin_document_type.child_trans_code2
                            var child_type_code = origin_document_type.child_type_code2
                        } else {
                            var child_trans_code = origin_document_type.child_trans_code
                            var child_type_code = origin_document_type.child_type_code
                        }

                        var child_document_type = documentTypes.find(x => x.trans_code === child_trans_code && x.type_code === child_type_code)
                        if(child_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: child_trans_code+child_type_code+" child document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", 0);
                        secureStorage.setItem("documentTypeId", child_document_type.id);
                        secureStorage.setItem("documentTypeName", child_document_type.name);
                        secureStorage.setItem("documentTypeCode", child_document_type.trans_code+child_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", child_document_type.friendly_code);
                        if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                            Object.assign(this.$data, this.$options.data());
                        }else{
                            this.tabulator.clearData();
                            Object.assign(this.$data.options, secureStorage.getItem('DataOptions').options)
                        }
                        this.documentNumber = secureStorage.getItem('temp_document_id');

                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                        this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                        this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                        this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                        this.originDocumentNumber = originDocumentNumber
                        this.originDocumentTypeId = originDocumentTypeId
                        this.originDocumentTypeName = originDocumentTypeName
                    }
                }
                await this.initializeDocument();
                await this.save();
            },
            async initializeDocument() {
                // window.checkAndAttachMapScript(this.initLocationSearch);
                window.addEventListener('scroll', this.handleScroll);
                component_x = this

                //Retrieve TaxRate from Global Settings
                var tax_rate_settings = await HTTPRequest.getRequest(this.endPoint + '/system_settings');
                var default_vat_rate = 12
                if (tax_rate_settings.data[0]) {
                    default_vat_rate = JSON.parse(tax_rate_settings.data[0].settings_json).default_vat_rate || 12
                }

                this.taxRate = Number(default_vat_rate) / 100

                //Retrieving and application of Document Access Rights
                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ this.currentDocumentTypeCode, null)
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

                if (accessRightsRequest.access_rights[system_module[0].id]) {
                    this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
                } else {
                    this.accessRights = [];
                }

                component_x.isSaveDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isUpdateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTableEditable = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupplyingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isRequestingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isHeaderDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.productFormMode = (!this.accessRights.includes('W')) ? "Search" : "Add";
                component_x.isReferenceDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPaymentTermDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isShippingMethodDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupportsDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPurposeDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDocumentDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTargetDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCancellationDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isOriginSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDestinationSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSalesmanDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerCreateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isForThisSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                this.isLotCodeExpiryDisabled = (this.currentDocumentTypeCode.substring(0,3) == "REC") ? false : true;

                //Get Tabulator Instance
                this.tabulator = this.$refs.tabulator.getInstance();

                //Document Configuration Application
                var document_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?id='+ component_x.currentDocumentTypeId, null)
                if(document_config) this.document_config = document_config
                this.maxLines = this.document_config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput
                this.autoCreateAlterSupp = this.document_config.document_type_settings.incomingOrder.disableAutocreationAlternateSupplierPosting
                this.filterBySupp = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.filterProductBySupplier

                //Mount selected Product Price/Cost depending on the configuration
                if (this.document_config && document_config.document_type_settings.priceOrCost) {
                    this.productPriceChoice = document_config.document_type_settings.priceOrCost
                    this.productPriceChoice = _.snakeCase(this.productPriceChoice);
                    var unit_cost_column = this.tabulator.getColumn("price")
                    await unit_cost_column.updateDefinition({title: _.capitalize(this.productPriceChoice.split('_').pop())})
                    var unit_cost_column_php = this.tabulator.getColumn("price_php")
                    await unit_cost_column_php.updateDefinition({title: _.capitalize(this.productPriceChoice.split('_').pop()) + ' (PHP)' })
                }

                //Disable Editing Depending on Config
                if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting) {
                    component_x.isProductNameEditConfigDisabled = !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting
                }

                // Enable Confirm and Unconfirm Document - Config
                if (component_x.document_config && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.confirmDocumentStatus) {
                    this.showconfirmUnconfirmButton = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.confirmDocumentStatus
                }

                //Set Maximum Document Line Limit - Config
                if (component_x.document_config && component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput){
                    this.maximumDocumentLineNumber = component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput
                }

                //Set Decimal Places Config
                if (component_x.document_config && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces){
                    if (component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces) {
                        this.decimalPlaces = 4
                    }
                }

                //Set Order Source
                var isSourceMode = null
                var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
                if (user_settings.data[0]) isSourceMode = user_settings.data[0].settings_json.isSourceMode

                if (component_x.document_config && component_x.document_config.document_type_settings.orderSource){
                    if (isSourceMode == null) isSourceMode = component_x.document_config.document_type_settings.orderSource.enableOrderSourceMode
                    this.isOrderSourceMode = isSourceMode
                    this.isOrderSourceDisabled = !this.isOrderSourceMode
                    if (this.isOrderSourceMode && component_x.document_config.document_type_settings.orderSource.orderSources) {
                        this.orderSources = component_x.document_config.document_type_settings.orderSource.orderSources
                    }
                }


                if(component_x.document_config){
                    var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                    if(enableAddCharges) {
                        component_x.showChargesTable = true
                    }
                    component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                }

                if (['RELTRX', 'RECTRX', 'RELADJ', 'RECADJ', 'RELDDE', 'RECDEL', 'RECCSR'].includes(this.currentDocumentTypeCode)) this.allowSublocationAllocation = true
                if (['OTHTRA', 'OTHPCK'].includes(this.currentDocumentTypeCode)) this.allowSiteAllocation = true
                //Setting columns on Document Form Table
                switch(this.currentDocumentTypeCode) {
                    case 'ORITRQ':

                        //1935 - Show Header / Supports Discount for ORITRQ
                        component_x.showHeaderDiscount = true
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        break;
                    case 'OROTRQ':

                        //1935 - Show Header / Supports Discount for OROTRQ
                        component_x.showHeaderDiscount = true
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines

                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECTRX':

                        //1935 - Show Header for RECTRX
                        component_x.showHeaderDiscount = true

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "color", value: true },
                          { name: "size", value: true }
                          ]
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isSupplyingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RELTRX':

                        //1935 - Show Header / Supports Discount for RELTRX
                        component_x.showHeaderDiscount = true

                        this.defaultColumnFields = [
                         ...this.defaultColumnFields,
                         { name: "color", value: true },
                         { name: "size", value: true }
                        ]
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.createChildDocButtonLabel = 'Create Transfer In'

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'ORICSQ':

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        break;
                    case 'OROCSQ':
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECCSX':
                       
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isSupplyingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RELCSX':
                      
                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.header = InterbranchDocuments.header
                    this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer In'

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;

                    case 'OTHPUR':

                        //1935 - Show Header / Supports Discount for OTHPUR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                    this.defaultColumnFields = this.defaultColumnFields.filter(({name}) => name !== "discount_text" )
                  
                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.header = PurchaseDocuments.header
                    this.renderColumnFields()

                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create PO'

                        break;
                    case 'ORIPOX':

                        // var subtotal = this.tabulator.getColumn("ref_code");
                        // await subtotal.updateDefinition({ download: true });

                        //1935 - Show Header / Supports Discount for ORIPOX
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                    this.defaultColumnFields = [
                      { name: "supplier_stock_no", value: false },
                      { name: "line_no", value: true },
                      { name: "stock_no", value: true },
                      { name: "barcode", value: true },
                      { name: "product_name", value: true },
                      { name: "unit_id", value: true },
                      { name: "quantity", value: true },
                      { name: "actual_quantity", value: true },
                      { name: "content_quantity", value: true },
                      { name: "price", value: true },
                      { name: "cost", value: true },
                      { name: "total_gross", value: true },
                      { name: "subtotal", value: true },
                      { name: "discount_text", value: true }
                    ]
                      
                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.header = PurchaseDocuments.headerOriPox
                    this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }

                        component_x.showVatExclusiveCheckbox = true
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        //console.log(component_x.documentNumber < 1)
                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["currency_id"]
                                component_x.currencyDetails = document["currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.supplierCurrencyId = document['supplier_currency_id']
                                component_x.supplierCurrencyRate =  document['supplier_currency_rate']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'ORIASN':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "total_gross", value: true },
                          { name: "actual_quantity", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOriPox
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }

                        component_x.showSupportDiscount = true
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }
                        break;
                    case 'RECDEL':

                        //1935 - Show Header / Supports Discount for RECDEL
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                        this.defaultColumnFields = [
                         ...this.defaultColumnFields,
                          { name: "ref_code", value: true },
                          { name:"reason_id", value:true},
                          { name: "actual_quantity", value: false },
                          { name: "total_gross", value: true },
                          { name: "invoice_amount", value: true },
                          { name: "invoice_discount", value: true },
                          { name: "color", value: false },
                          { name: "size", value: false }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        component_x.showVatExclusiveCheckbox = true

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["currency_id"]
                                component_x.currencyDetails = document["currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.supplierCurrencyId = document['supplier_currency_id']
                                component_x.supplierCurrencyRate =  document['supplier_currency_rate']
                            }

                            if(component_x.document_config){
                                var notSetRecdelQuantityZero = component_x.document_config.document_type_settings.receivingDocumentWithOrder.populateReceivingReportQuantityBasedOnPurchaseOrder || false
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)

                            if (!notSetRecdelQuantityZero) {
                                document_lines.forEach( row => {
                                    row.quantity = 0
                                });
                            }
                            if(document_lines) await this.tabulator.addData(document_lines, true);

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines

                            //Document Charges
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.originDocumentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            this.spinning = false;
                            this.initializeFooterCalculation();

                            this.isSupplierDisabled = true
                            this.showCreateChildDocButton = false;

                        }
                        break;

                    case 'OTHSBI':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: false },
                          { name: "price_pi", value: true},
                          { name: "total_gross", value: true },
                          { name: "invoice_amount", value: true },
                          { name: "invoice_discount", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOthSbi
                        this.renderColumnFields()


                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showDocumentBodyHeader = false
                        component_x.isPurposeDisabled = true
                        component_x.isSupportsDiscountDisabled = true
                        component_x.isSupplierDisabled =  true
                        component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true

                        if (component_x.documentNumber < 1) {

                            var receiving_report_id = this.$route.params.receiving_report_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+receiving_report_id, null);

                            component_x.receivingReport = receiving_report_id
                            component_x.supplier = document["supplier_id"]
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+receiving_report_id+'?field_name=document_id', null)
                            document_lines.forEach( row => {
                                row.goods_issue_quantity = row.quantity
                            });
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines

                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }
                        break;
                    case 'OTHPWS':
                        
                       this.defaultColumnFields = [
                         { name: "line_no", value: true },
                         { name: "product_name", value: true },
                         { name: "stock_no", value: true },
                         { name: "barcode", value: true },
                         { name: "old_landed_cost", value: true },
                         { name: "landed_cost", value: true },
                         { name: "old_retail_price", value: true },
                         { name: "retail_price", value: true },
                         { name: "markup_percent", value: true },
                         { name: "old_original_cost", value: true },
                         { name: "original_cost", value: true },
                         { name: "old_ordering_cost", value: true },
                         { name: "ordering_cost", value: true },
                         { name: "old_wholesale_price", value: true },
                         { name: "wholesale_price", value: true },
                         { name: "old_least_price", value: true },
                         { name: "least_price", value: true },
                         { name: "old_special_price", value: true },
                         { name: "special_price", value: true },
                         { name: "on_hand_quantity", value: true }
                       ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PriceWorkSheet.header
                        this.renderColumnFields()

                        component_x.showSummaryCalculation = false
                        component_x.showTotalQuantity = false
                        component_x.showPwsCosts = true
                        component_x.showCancellationDate = false
                        component_x.showQuantity = false
                        component_x.showUnitCost = false
                        component_x.showDiscount = false
                        component_x.showUnitNetCost = false
                        component_x.showSubtotal = false
                        component_x.showFilteredBySupplier = false

                        break;

                    case 'RELRSR':

                        //1935 - Show Header / Supports Discount for RELRSR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                        var subtotal = this.tabulator.getColumn("ref_code");
                        await subtotal.updateDefinition({ download: true });

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: false },
                          { name: "ref_code", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()


                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;

                    case 'RECADJ':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: false },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = LocalDocuments.headerAdjustments
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'RELADJ':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: false }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = LocalDocuments.headerAdjustments
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHUPC':
                    case 'OTHPCN':

                        //Default Sublocation Handling

                        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                        this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                        var default_sublocation_id = this.sites.find(element => element.id == secureStorage.getItem("defaultSiteId")).sublocation_id || 0
                        var default_sublocation_name = this.sublocations.find(element => element.id == default_sublocation_id).name || ""
                        this.siteSublocation = {key: default_sublocation_id, label: default_sublocation_name}

                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "product_name", value: true },
                          { name: "barcode", value: true },
                          { name: "unit_id", value: true },
                          { name: "quantity", value: true },
                          { name: "actual_quantity", value: true },
                          { name: "price", value: true },
                          { name: "cost", value: true },
                          { name: "subtotal", value: true },
                          { name: "on_hand_quantity", value: true },
                          { name: "remarks", value: true }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PCount.header
                        this.renderColumnFields()

                        this.showCreateChildDocButton = false
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHASM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHDSM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields, 
                          { name: "actual_quantity", value: true }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;

                    case 'RELSLO':
                          this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: true},
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;
                    case 'RECSLI':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: true},
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;

                    case 'ORISOX':
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.references){
                            this.referenceLabel = orisox_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }


                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }

                        this.showPayButton = true
                        this.showDeliverButton = true

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "on_hand_quantity", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                          { name: "salesman_name", value: true },
                          { name: "line_extras", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOriSox
                        this.renderColumnFields()

                        component_x.showHeaderDiscount = true

                        if (this.documentNumber > 0) {
                            this.isProductSearchDisabled = false
                        } else {
                            this.isProductSearchDisabled = true
                        }
                        this.isDestinationSublocationDisabled = true
                        this.searchFilter = "name"
                        this.showShippingMethod = true

                        //component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.sublocationDestinationLabel = 'Serving Sublocation'
                        break;

                    case 'RELDDE':
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var reldde_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=DDE&trans_code=REL', null)
                        //Set Order Source
                        var allowWIthoutSO = false;
                        if (reldde_doc_config && reldde_doc_config.document_type_settings.references){
                            this.referenceLabel = reldde_doc_config.document_type_settings.references[0].name || "Reference"
                            allowWIthoutSO = reldde_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                            this.tabulator.toggleColumn("actual_quantity")
                        }
                        if (!allowWIthoutSO && this.documentNumber==0){
                            this.showBookingButton = true
                            //this.showDocumentBodyHeader = false
                            this.productFormMode = "Search"
                            this.showShippingMethod = true
                        }

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "quantity", value: false },
                          { name: "ordered_quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "delivery_quantity", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRelDde
                        this.renderColumnFields()


                        //Disable fields
                        if (!allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = true
                            component_x.isCustomerDisabled = true
                            component_x.isCustomerCreateDisabled = true
                            component_x.isDestinationSublocationDisabled = true
                            component_x.isDistributionSiteDisabled = true
                            component_x.isDocumentDateDisabled = true
                            component_x.isTargetDateDisabled = true
                            component_x.isCancellationDateDisabled = true
                            component_x.isShippingMethodDisabled = true
                            component_x.isPurposeDisabled = true
                            component_x.sublocationDestinationLabel = 'SO Sublocation'
                            component_x.sublocationOriginLabel = 'Serving Sublocation'
                            component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                            component_x.showHeaderDiscount = true
                            component_x.isHeaderDiscountDisabled = true
                        }else if (allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = false
                        }

                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            if (sales_order_id > -1){
                                var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                                var document_charges = []
                                document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                                if(document_charges) component_x.chargeData = document_charges
                                component_x.documentDetails = document
                            }
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.salesOrder = sales_order_id
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            if (sales_order_id > -1){
                                var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            }
                            document_lines.forEach( row => {
                                row.quantity = 0
                            });
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                        } else {
                            component_x.isOriginSublocationDisabled = true
                            this.tabulator.toggleColumn("goods_issue_quantity")
                        }

                        break;

                    case 'OTHSIN':
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var othsin_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SIN&trans_code=OTH', null)
                        if (othsin_doc_config && othsin_doc_config.document_type_settings.references){
                            this.referenceLabel = othsin_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                        }

                        this.showDocumentBodyHeader = false
                        this.showShippingMethod = true

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "ordered_quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "goods_issue_quantity", value: true },
                          { name: "remarks", value: true },
                          { name: "ref_code", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOthSin
                        this.renderColumnFields()

                        component_x.isCustomerDisabled = true
                        component_x.isCustomerCreateDisabled = true
                        component_x.isOrderSourceDisabled = true
                        component_x.isDeliveryDocumentDisabled = true
                        component_x.isDocumentDateDisabled = true
                        component_x.isOriginSublocationDisabled = true
                        component_x.isDestinationSublocationDisabled = true
                        component_x.isDistributionSiteDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.isPurposeDisabled = true

                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.sublocationOriginLabel = 'Serving Sublocation'

                        if (component_x.documentNumber < 1) {

                            var delivery_document_id = this.$route.params.delivery_document_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+delivery_document_id, null);

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.originSublocation = document['origin_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.salesOrder = document['origin_document_id']['label']
                            component_x.deliveryDocument = delivery_document_id
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                            component_x.remark = document["remark"];
                            component_x.isHeaderOnly = document['is_header_only']

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                            if (orisox_document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+delivery_document_id+'?field_name=document_id', null)
                            document_lines.forEach( row => {
                                row.goods_issue_quantity = row.quantity
                            });
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }
                        break;
                    case 'RECCSR':
                      var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }

                        //this.showBookingButton = true
                        //this.showDocumentBodyHeader = false
                        //this.productFormMode = "Search"
                        //this.showShippingMethod = true

                          this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRecCsr
                        this.renderColumnFields()

                        //Disable fields
                        //component_x.isOrderSourceDisabled = true
                        //component_x.isCustomerDisabled = true
                        //component_x.isCustomerCreateDisabled = true
                        //component_x.isDestinationSublocationDisabled = true
                        //component_x.isDistributionSiteDisabled = true
                        //component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        //component_x.isPurposeDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                        //component_x.showHeaderDiscount = true
                        component_x.isHeaderDiscountDisabled = true
                        var document_id = this.$route.params.sales_order_id
                        var documentExists = false
                        var openCSR = false
                        if( component_x.documentNumber > 0 ){
                            document_id = component_x.documentNumber
                            documentExists = true
                        } else if( this.$route.params.sales_order_id == undefined && component_x.documentNumber == 0){
                            openCSR = true
                        }
                        if(!openCSR){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+document_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]

                            if(documentExists){
                                component_x.deliveryDocument = document['origin_document_id']['key']
                            }else {
                                component_x.deliveryDocument = document_id
                                component_x.documentDate = moment()
                                component_x.targetDate = moment()
                                component_x.cancellationDate = moment().add(1, 'months').calendar();
                            }
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }


                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var origin_doc_id = documentExists ? document['origin_document_id']['key'] : document_id
                            if(origin_doc_id == null || origin_doc_id == ''){
                                openCSR = true
                            }
                            if(!openCSR) var returnable_qtys = await HTTPRequest.getRequest(component_x.endPoint + '/documents/' + origin_doc_id + '/available_return_quantity', null)
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+document_id+'?field_name=document_id', null)
                            component_x.returnable_qtys = returnable_qtys
                            document_lines.forEach( row => {
                                // if creating CSR, then reset the quantities
                                if(!documentExists){
                                    row.quantity = 0
                                }
                                // check max qty per product that can be returned, actual quantity is available quantity
                                if(!openCSR){
                                    var returnable_line = returnable_qtys.data.find(line => line.product_id == row.product_id)
                                    row.goods_issue_quantity
                                    row.goods_issue_quantity = returnable_line == undefined ? 0 : (returnable_line.returnable_qty)
                                    row.delivery_quantity = row.goods_issue_quantity
                                }
                            });
                            if(documentExists) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse())
                            if( !openCSR && ((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                        }
                        component_x.openCSR = openCSR
                        this.spinning = false;
                        break;
                    case 'ORORSO':
                      var ororso_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=RSO&trans_code=ORO', null)
                        if (ororso_doc_config && ororso_doc_config.document_type_settings.editorBehavior){
                            this.revenueCreditingMode = ororso_doc_config.document_type_settings.editorBehavior.revenueCreditingMode
                        }
                        if (this.revenueCreditingMode == 'R'){
                            this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            this.revenue = 'R'
                            this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                            this.header.showRevenue = false
                        }else if(this.revenueCreditingMode == 'T'){
                            this.revenue = 'T'
                            this.header.showRevenue = false
                        }else if (this.revenueCreditingMode == 'M'){
                            this.header.showRevenue = true
                        }
                        this.showShippingMethod = true
                        this.RequestingLabel = "Target"

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "requested_quantity", value: true },
                          { name: "ordered_quantity", value: true},
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "actual_quantity", value: false },
                          { name: "quantity", value: false },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOroRso
                        this.renderColumnFields()

                        //Disable fields
                        component_x.showDocumentBodyHeader = false
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        //component_x.isPurposeDisabled = true
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"
                        component_x.showHeaderDiscount = true
                        component_x.isHeaderDiscountDisabled = true
                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.siteSublocation = document["sublocation_id"]
                            component_x.salesOrder = sales_order_id
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }
                            
                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                        }
                        break;
                    case 'OTHTRA':
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()
                        
                        component_x.isSupplyingSiteDisabled = false
                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (component_x.documentNumber < 1) {

                            var transfer_allocation_id = this.$route.params.transfer_allocation_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+transfer_allocation_id, null);

                            component_x.receivingReport = transfer_allocation_id
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            var document_lines = []
                            var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+transfer_allocation_id+'?field_name=document_id&document_type_code='+this.currentDocumentTypeCode, null)
                            document_lines.forEach( row => {
                                row.goods_issue_quantity = row.quantity
                            });
                            if(document_lines) {
                                await this.tabulator.addData(document_lines, true);
                               // if(this.currentDocumentTypeCode == 'OTHTRA' || this.currentDocumentTypeCode == 'OTHPCK') await this.tabulator1.addData(document_lines, true);
                            }
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }

                        break;

                    case 'OTHPCK':
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()

                        component_x.isSupplyingSiteDisabled = true
                        this.HideDeleteAndAddProductButton = true
                        if(component_x.originDocumentNumber < 1){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.originDocumentNumber, null);
                            if(document!=null){
                                if(document["code_and_document_no"]=="TRA#"+document["document_no"]){
                                    this.tabulator.getColumn('quantity').updateDefinition({editable:false})
                                }
                            }
                        }
                        break;

                    case 'OTHCNS':
                        this.spinning = true;
                        this.showDocumentBodyHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false
                        this.showTotalQuantity = false
                        this.defaultColumnFields = [
                          { name: "code_and_document_no", value: true },
                          { name: "id", value: true },
                          { name: "reference_1", value: true },
                          { name: "document_date", value: true },
                          { name: "total_quantity", value: true },
                          { name: "status", value: true },
                          { name: "order_status", value: true },
                          { name: "remarks", value: true },
                          { name: "updated_by", value: true },
                          { name: "created_by", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = CountSet.header
                        this.renderColumnFields()

                        if (component_x.documentNumber < 1){
                            var data = this.$route.params.pcount_data != undefined ? this.$route.params.pcount_data : []
                            data = JSON.parse(JSON.stringify(data));
                            await this.tabulator.addData(data, true);
                        }
                        this.searchFilter = "document_no"
                        this.placeholder = "Search by document no"
                        this.showCancellationDate = false
                        this.showTargetDate = false
                        this.spinning = false;
                        break;
                    default:
                }
                // Mount to Edit Record
                if (component_x.documentNumber > 0) {

                    //Action History
                    var documentHistory = await HTTPRequest.getRequest(component_x.endPoint + "document_action_histories/"+component_x.documentNumber+"?field_name=document_id", null);
                    if (documentHistory) this.historyData = documentHistory

                    var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.documentNumber, null);

                    // Start
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                        this.suppDetails = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + document["supplier_id"]["key"], null)
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                    // End

                    component_x.documentDetails = document
                    component_x.friendlyCodeAndDocumentNo = document['code_and_document_no']
                    if(component_x.currentDocumentTypeCode=="RECDEL" && document['origin_document_id']["label"] != undefined) {
                        component_x.friendlyOriginDocumentNo = 'Origin Document No: ' + document['origin_document_id']["label"]
                    }

                    component_x.documentId = document['id'];
                    component_x.documentNo = document['document_no']
                    component_x.postDate = document['posted_at']
                    component_x.documentStatus = document['status']
                    component_x.documentOrderStatus = document['order_status']
                    component_x.originDocumentNumber = document["origin_document_id"]["key"]
                    component_x.isHeaderOnly = document['is_header_only']
                    component_x.isDocumentTrade = document['is_trade']

                    component_x.requestingSite = document['target_site_id']
                    component_x.supplyingSite = document['source_site_id']
                    component_x.distributionSite = document['site_id']
                    component_x.siteSublocation = document['sublocation_id']
                    component_x.forThisSite = document['site_id']
                    component_x.originSublocation = document['origin_sublocation_id']
                    component_x.destinationSublocation = document['target_sublocation_id']
                    component_x.reference = document['reference']
                    component_x.remark = document['remark']
                    component_x.documentDate = moment(document["document_date"])
                    component_x.targetDate = moment(document["target_date"])
                    component_x.cancellationDate = moment(document["cancellation_date"])
                    component_x.paymentTerm = document["payment_term_id"]
                    component_x.supplier = document["supplier_id"]
                    component_x.supplierDetails = document["supplier_id"]
                    component_x.currency = document['currency_id']
                    component_x.imageFileUrl = document['image_url']

                    //Populate Footer and Calculation Data
                    component_x.grossAmount =  document['amount_gross']
                    component_x.grossAmountDisplay = document['amount_gross']
                    component_x.overallDiscount = document['amount_header_discount']
                    component_x.netAmount = document['amount_net']
                    component_x.netAmountDisplay = document['amount_net']
                    component_x.vatAmount = document['tax_amount']
                    component_x.totalWithVat = document['tax_exempt_amount']
                    component_x.itemDiscount = document['amount_line_discount']
                    component_x.taxRate = document['tax_rate']
                    component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                    component_x.netAmountWithoutTax = document['net_amount_without_tax']
                    component_x.drawerSublocationSiteId = document['site_id']["key"]
                    component_x.currencyRateLabel = document["currency_rate"] != "0.00" && document["currency_rate"]!=null ? document["currency_rate"] : document['supplier_currency_rate'] != "0.00" && document['supplier_currency_rate'] != "0.0" && document['supplier_currency_rate'] != null ? document['supplier_currency_rate'] : 1
                    component_x.currencyRate = document["currency_rate"]
                    component_x.currencyDetails = document["currency_id"]
                    component_x.supplierCurrencyRate = document['supplier_currency_rate']
                    component_x.supplierCurrencyId = document['supplier_currency_id']

                    component_x.createdBy = document['created_by']
                    component_x.postedBy = document['posted_by']

                    var docTypeSystemModules = await HTTPRequest.getRequest(component_x.endPoint+"system_modules?code="+component_x.currentDocumentTypeCode+"&status=A", null);
                    var configgedExtras = await HTTPRequest.getRequest(component_x.endPoint+"account_system_modules/"+ docTypeSystemModules[0]["id"] +"?field_name=system_module_id", null);
                    if(configgedExtras!=undefined && configgedExtras != [] && configgedExtras != {} && configgedExtras["meta"]!=undefined && configgedExtras["meta"].customized_fields != undefined ){
                        var metaHolder = JSON.parse(configgedExtras["meta"]).customized_fields
                        this.configuredExtras = metaHolder.map(a => a.code)
                    }
                    this.documentExtras = document['extras']
                    component_x.extras = this.documentExtras
                    //console.log("LOADING REFERENCES")
                    var documentReferences = component_x.document_config.document_type_settings.references
                    for(var i=0; i < documentReferences.length; i++){
                        var storedRef = document["reference_" + (i + 1).toString()]
                        if(_.isEmpty(storedRef)){
                            //console.log("skip")
                        } else {
                            documentReferences[i]["input"] = storedRef
                        }
                    }

                    if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                    if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount && document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                    // Changed position of these initializers to render the right currency_rate in the tabulator
                    // Updated by Maron Justo
                    if(document["supplier_id"].currency_id!=document["currency_id"].key){
                        await component_x.showConversionCurrencyRate();
                    }
                    if (component_x.currentDocumentTypeCode=="OTHPWS"){
                        window.scrollTo(0,0);
                        this.spinning = true;
                        var document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "pricecost_lines/"+component_x.documentNumber+"?field_name=document_id", null);
                        if(document_lines) await this.tabulator.addData(document_lines, true);
                        this.tabulator.addFilter("line_no", ">", 0);

                        if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        this.spinning = false;
                    }else if(component_x.currentDocumentTypeCode=="OTHCNS"){
                        window.scrollTo(0,0);
                        this.spinning = true;
                        var pcount_documents = [];
                        pcount_documents = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_pcount_document_details?id="+component_x.documentNumber, null);
                        if(pcount_documents) await this.tabulator.addData(pcount_documents, true);
                        if(pcount_documents) component_x.origData = JSON.stringify(pcount_documents.reverse()) //For isDirty Data on Document lines
                        this.spinning = false;
                    } else if(component_x.currentDocumentTypeCode=="RECCSR"){ // do nothing
                    } else {
                        window.scrollTo(0,0);
                        this.spinning = true;
                        var document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "document_lines/"+component_x.documentNumber+"?field_name=document_id", null);
                        if(document_lines) {
                            await this.tabulator.addData(document_lines, true);
                        }
                        this.tabulator.addFilter("line_no", ">", 0);

                        if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        this.spinning = false;
                    }

                    //Document Charges
                    if(component_x.document_config){
                        var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                        if(enableAddCharges) {
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.documentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges
                        }
                    }

                    if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                    if (document["purpose_id"]["key"] > 0) component_x.purpose = document["purpose_id"];

                    component_x.party = document["party_name"];
                    component_x.customer = document["customer_id"];
                    component_x.salesman = {key: document["salesman_id"], label: document["salesman_name"]};

                    if(component_x.salesman)
                    if (component_x.customer){
                        var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                        this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                        this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                        this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                        this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                        this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                        this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                        this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                    }

                    if(document["address"]){
                        this.customerAddress = document["address"]
                    }

                    // if Transfer Request
                    if (this.currentDocumentTypeCode == 'ORITRQ' || this.currentDocumentTypeCode == 'ORICSQ') {
                        if (document['source_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true
                    }

                    if (this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RELCSX') {
                        if (document['target_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true
                    }

                    // if Stock Request For Serving /Concession
                    if (this.currentDocumentTypeCode == 'OROTRQ' || this.currentDocumentTypeCode == 'OROCSQ') {
                        if (this.originDocumentNumber > 0) {
                            this.isRequestingSiteDisabled = true
                        }
                    }

                    // if Transfer In /Concession
                    if (this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'RECCSX') {
                        if (this.originDocumentNumber > 0) {
                            this.isSupplyingSiteDisabled = true
                        }
                    }

                    // if Receiving Report
                    if (this.currentDocumentTypeCode == 'RECDEL') {
                        if (this.originDocumentNumber > 0) {
                            this.isSupplierDisabled = true
                        }
                    }

                    // if Sales order Document
                    if (this.currentDocumentTypeCode == 'ORISOX') {
                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }
                        this.showPrint = true
                    }

                    // if Delivery Document
                    if (this.currentDocumentTypeCode == 'RELDDE') {
                        component_x.salesOrder = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    // if re-routed SO
                    if (this.currentDocumentTypeCode == 'ORORSO') {
                        component_x.salesOrder = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    // if Customer Return
                    if (this.currentDocumentTypeCode == 'RECCSR') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        this.showPrint = true
                    }
                    // if Sales Invoice
                    if (this.currentDocumentTypeCode == 'OTHSIN') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        var delivery_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        component_x.salesOrder = delivery_document['origin_document_id']['label'];

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var reldde_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+reldde_document['origin_document_id']['key'], null);
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    if (this.currentDocumentTypeCode == 'OTHSBI') {
                        component_x.receivingReport = document['origin_document_id']['label'];
                    }

                    // if Sales Invoice
                    if (this.originDocumentNumber > 0) {
                        var originDocument = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                        this.originDocumentTypeId = originDocument['document_type_id']
                    }

                    //Disabled Actions When Document is already Posted
                    var disable_status = ["Posted", "Voided", "Confirmed"]
                        component_x.isSaveDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isUpdateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplyingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRequestingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isHeaderDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplierDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTradeToggleDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.productFormMode = (disable_status.includes(component_x.documentStatus)) ? "Search" : "Add";
                        component_x.isReferenceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPaymentTermDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isShippingMethodDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupportsDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDocumentDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTargetDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCancellationDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isAddChargeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPurposeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPartyDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDistributionSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOriginSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDestinationSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSalesmanDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerCreateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOrderSourceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.showSupplierOptions = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isForThisSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSiteSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRevenueDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPostDisabled = (disable_status.includes(component_x.documentStatus) && component_x.documentStatus != "Confirmed") ? true : false;
                        this.showAdvancedInfo = true
                        if(component_x.currentDocumentTypeCode=="ORORSO") {
                            if( this.documentExtras!='' && this.documentExtras!=undefined){
                                this.revenue = this.documentExtras["revenue"] || ''
                            }
                            if(this.requestingSite.key == secureStorage.getItem("defaultSiteId").toString()){
                                this.isPostDisabled = false
                                this.isConfirmDisabled = false
                                this.isRevenueDisabled = true
                                if(this.distributionSite.key != this.requestingSite.key){
                                    this.isRequestingSiteDisabled = true
                                }
                                this.tabulator.toggleColumn("quantity")
                                this.tabulator.toggleColumn("on_hand_quantity")
                            }else{
                                this.isPostDisabled = true
                                this.isConfirmDisabled = true
                            }
                        }
                    // component_x.initializeFooterCalculation();
                    // await component_x.fetchCurrencies();
                    // await component_x.showConversionCurrencyRate();
                    if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                }

                //Check if with ongoing jobs
                var ongoingJob = await HTTPRequest.getRequest(component_x.endPoint+'import_jobs?profile_name='+this.currentDocumentTypeCode+'-%23-'+this.documentNumber, null)
                if(ongoingJob != undefined && ongoingJob.length > 0){
                    if(ongoingJob[0].formatted_status == 'Ongoing') {
                        this.documentStatus = 'Uploading'
                    }
                    else if(ongoingJob[0].formatted_status == 'With errors') {
                        this.documentStatus = 'Upload Error'
                        component_x.$notification['warning']({
                            message: 'Upload Error',
                            duration: 0,
                            description: "CSV file uploaded with errors ["+this.currentDocumentTypeCode+'-#-'+this.documentNumber+"] but you can ignore it and continue processing the document. Click 'View Jobs' button to review.",
                            style: getNotificationStyle('warning'),
                            btn: h => {
                                return h(
                                'base-button',
                                {
                                    props: {
                                    type: 'warning',
                                    class: 'btn-sm',
                                    },
                                    on: {
                                    click: () => component_x.$router.push("/jobs"),
                                    },
                                },
                                'View Jobs',
                                );
                            },
                        });
                    } else if(ongoingJob[0].formatted_status == 'Upload terminated') {
                        this.documentStatus = ongoingJob[0].formatted_status
                        component_x.$notification['warning']({
                            message: 'Upload terminated. Please reupload.',
                        });
                    }
                }

                //Setting Document Status Icon on Header
                switch(this.documentStatus) {
                    case 'Saved':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    case 'Uploading':
                        this.headerStatusIcon = 'fas fa-cloud-upload-alt text-blue'
                        break;
                    case 'Upload Error':
                        this.headerStatusIcon = 'fas fa-times text-red'
                        break;
                    case 'Posted':
                        this.headerStatusIcon = 'fas fa-check-circle text-green'
                        this.isPostDisabled = true
                        if (this.currentDocumentTypeCode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM') {
                            this.postedASMDSM = true
                        }
                        break;
                    case 'Voided':
                        this.headerStatusIcon = 'fas fa-times-circle text-red'
                        this.isPostDisabled = true
                        break;
                    case 'Confirmed':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    default:
                        this.headerStatusIcon = ''
                        this.isPostDisabled = false
                }
                
                //1935
                this.calculateOverallDiscount()
                if(!component_x.isRunDefaultCurrency){
                    await component_x.fetchDefaultCurrency()
                }
                component_x.forceFetchCurrency = true
                await component_x.fetchCurrencies()
                
                const docSortDrawerData = localStorage.getItem("documentTypeSort" + this.currentDocumentTypeCode);
                if(docSortDrawerData != undefined && docSortDrawerData != null && docSortDrawerData != "[]"){
                    let val = JSON.parse(docSortDrawerData)
                    await this.sortDocument(val);
                }
            },
            async copyDocument() {
                var duplicated_document = await HTTPRequest.postRequest(this.endPoint + '/documents/copy_document?document_id=' + this.documentNumber , null, null)
                this.openDocument(duplicated_document.id)
            },
            voidEcomOrder(){
                if (this.orderSource == 'shopee' || this.orderSource == 'lazada' || this.orderSource == 'shopify'){
                    this.documentEcomDrawerVisible = true
                    this.ecomAction = 'Void'
                } else {
                    this.voided()
                }
            },
            deleteRow(id){
                this.documentNumber = id
                this.voided()
            },
            postEcomOrder(){
                window.scrollTo(0,0);
                this.spinning = true;
                this.notifMessage = [];
                var data = this.tabulator.getData();
                //For RelDde Documents
                if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                    if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                        //when goods issue
                        if (this.documentNumber > 0) {
                            var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                            if (invalid != undefined){
                                this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                return;
                            }
                        }
                    }
                }
                if (data.length > 0) {
                    this.isEditing = !(component_x.origData === JSON.stringify(data))
                }

                if (this.isEditing && !this.isChangeAction) {
                    this.notifMessage.push("You have unsaved changes, please save before posting")
                    this.documentActionNotification('post', 'error');
                    this.spinning = false;
                    return;
                } else {
                    this.documentEcomDrawerVisible = true
                    this.ecomAction = 'Post'
                }
                this.spinning = false;
            },
            ecomPost(id){
                this.documentNumber = id
                this.post()
            },
            shopeePrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/shopee_integrations/get_airway_bill', null, {document_id:this.documentNumber})
                if (post_request["result"]["errors"].length <=0){
                    this.spinning = false;
                    window.open(post_request["result"]["airway_bills"][0]["airway_bill"], '_blank')
                }else {
                    this.$notification['error']({
                        message: post_request["result"]["errors"][0]["error_code"],
                        description: post_request["result"]["errors"][0]["error_description"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            lazadaPrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/lazada_integrations/print_waybill', null, {document_id:this.documentNumber})
                if (post_request["errors"] == undefined){
                    this.spinning = false;
                    let pdfWindow = window.open("");
                    pdfWindow.document.write(
                        "<iframe width='100%' height='100%' src='data:"+post_request["document"]["mime_type"]+";base64, " +
                        post_request["document"]["file"] + "'></iframe>"
                    )
                }else {
                    this.$notification['error']({
                        message: "Error",
                        description: post_request["errors"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            documentEndpoint (input) {
                var params = '/documents?type=OTHCNS&'
                return this.endPoint + params + this.searchFilter + '=' + input;
            },
            filterExistingDocuments(e){
                var data = this.tabulator.getData();
                var ids = data.map(({id}) => id)
                return e.data.filter(item => !ids.includes(item.id))
            },
            async getDocument (group) {
                this.notifMessage = []
                this.documentID = group.value
                this.selectedDocument = group.selectedObject
            },
            clearDocument (){
                this.selectedDocument = ''
                this.documentID = null
            },
            formattedDocumentDisplay (result) {
                if (this.searchFilter !='id'){
                    return eval('result.'+this.searchFilter) + ' ['+result.id+']';
                }else{
                    return eval('result.'+this.searchFilter)  + ' ['+result.document_no+']';
                }
            },
            handleAddDocumentVisibleChange(addPCountDocumentConfirmationVisible){
                if (!addPCountDocumentConfirmationVisible) {
                    this.addPCountDocumentConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'OTHCNS') {
                    this.addPCount();
                }
            },
            async addPCount() {
                this.notifMessage = []
                var data = this.tabulator.getData();
                if (this.documentID) {
                    if (!(data.length == this.maximumDocumentLineNumber)) {
                        await this.tabulator.addRow(this.selectedDocument);
                        this.clearDocument()
                    } else {
                        this.documentActionNotification('Add Document', 'error')
                    }
                }
                this.addPCountDocumentConfirmationVisible = false;
            },
            addPCountCancel() {
                this.addPCountDocumentConfirmationVisible = false;
            },
            mass_delete_document_line() {
                this.selectedDocumentLineRows.forEach(function(x){
                   x.delete();
                });
                this.selectedDocumentLines = []
            },
            async showConversionCurrencyRate(){
                if (parseInt(this.supplierDetails.currency_id)>0){
                    if (Number(this.currencyRate) > 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)) {
                        this.isCurrencyToPhp = false
                        this.showConversionCurrencyRateColumns()
                    } else if (Number(this.currencyRate) <= 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)){
                        this.isCurrencyToPhp = true
                        this.showConversionCurrencyRateColumns()
                    }else{
                        this.hideConversionColumns()
                    }
                }else if (this.hasDefaultCurrency){
                    if (parseInt(this.currency.key) == 0){
                        this.isCurrencyToPhp = true
                        this.showConversionCurrencyRateColumns()
                    }else{
                        this.hideConversionColumns()
                    }
                } else if(Number(this.currencyRate) > 0 && parseInt(this.currency.key) != 0 && !this.hasDefaultCurrency){
                    this.isCurrencyToPhp = false
                    this.showConversionCurrencyRateColumns()
                } else {
                    this.hideConversionColumns()
                }
            },
            async hideConversionColumns(){
                let subtotal,cost,price,gross;
                this.isCurrencyToPhp = false
                this.showConversionRate = false
                this.tabulator.hideColumn("subtotal_php")
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({download:false})
                this.tabulator.hideColumn("cost_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({download:false})
                this.tabulator.hideColumn("price_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({download:false})
                this.tabulator.hideColumn("total_gross_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({download:false})
            },
            async showConversionCurrencyRateColumns(){
                let subtotal,cost,price,gross,label;
                label=this.currencyDetails.code == undefined ? 'PHP' : this.currencyDetails.code
                this.showConversionRate = true
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({title: "Subtotal ("+label+")", download:true})
                this.tabulator.showColumn("subtotal_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({title: "Net Cost ("+label+")", download:true})
                this.tabulator.showColumn("cost_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({title: "Unit Cost ("+label+")", download:true})
                this.tabulator.showColumn("price_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({title: "Total Gross ("+label+")", download:true})
                this.tabulator.showColumn("total_gross_php")
            },
            supplierStockNumber(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber
                    var show_status1 = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showStockNoInProductList : false
                    if(show_status==true || show_status1==true){
                        var label = ''
                        var supplier_stock_no = cell.getRow().getData().supplier_stock_no
                        if (supplier_stock_no!=undefined){
                            label = supplier_stock_no
                        }else{
                            var extras = cell.getRow().getData().extras
                            try{
                                if(extras["supplier_stock_no"] == undefined){
                                    label = ""
                                }else {
                                    label = extras["supplier_stock_no"]
                                }
                            }catch(e){
                                label = ""
                            }
                            cell.getRow().update({"supplier_stock_no":label})
                        }
                        return label
                    }
                }
            },
            sizeFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var size = cell.getRow().getData().size
                        if (size==null){
                            label = ''
                            cell.getRow().update({"size":label})
                        }else{
                            label = size
                        }
                        return label
                    }
                }else{
                    label = ''
                    size = cell.getRow().getData().size
                    if (size==null){
                        label = ''
                        cell.getRow().update({"size":label})
                    }else{
                        label = size
                    }
                    return label
                }
            },
            colorFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showColorInProductList : false
                    if(show_status==true){
                        var label = ''
                        var color = cell.getRow().getData().color
                        if (color==null){
                            label = ''
                            cell.getRow().update({"color":label})
                        }else{
                            label = color
                        }
                        return label
                    }
                }else{
                    label = ''
                    color = cell.getRow().getData().color
                    if (color==null){
                        label = ''
                        cell.getRow().update({"color":label})
                    }else{
                        label = color
                    }
                    return label
                }
            },
            designFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var design = cell.getRow().getData().design
                        if (design==null){
                            label = ''
                            cell.getRow().update({"design":label})
                        }else{
                            label = design
                        }
                        return label
                    }
                }
            },
            payInitialDepositValidation(){
                this.initialDepositErrors = [];
                this.initialDepositErrors.push(ValidateField.required('Amount', this.initialDeposit.amount));
                this.initialDepositErrors.push(ValidateField.required('Reference', this.initialDeposit.reference));
                this.initialDepositErrors = this._.compact(this.initialDepositErrors);
                return this.initialDepositErrors.length;
            },
            async payInitialDeposit(documentNumber){
                if(!this.payInitialDepositValidation()){
                    var InitialDepositPayload = {
                        document_payment:{
                            amount:this.initialDeposit.amount,
                            reference:this.initialDeposit.reference,
                            payment_mode:"Initial Deposit",
                            status:"A",
                            payment_date: moment(new Date()),
                            document_id:documentNumber
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'document_payments', null, InitialDepositPayload)
                    if (post_request["error"] == undefined) {
                        this.forPaymentIsProcessed = true;
                        this.post();
                    } else {
                        this.notifMessage = post_request['error'].split(',');
                        this.documentActionNotification('Inital Deposit', 'error')
                    }
                }
            },
            async exportCSV(){
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var documentType = this.currentDocumentTypeName || ''
                    var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                    var userCode = secureStorage.getItem("userCode") || '';
                    var createdBy = this.createdBy || '';
                    var postedBy = this.postedBy || '';
                    var supplier = this.supplier.label || ''
                    var remark = this.remark || ''
                    var purpose = this.purpose.label || ''

                    var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                    var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                    var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                    var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                    var documentStatus = this.documentStatus || ''
                    var documentNumber = this.documentNo || ''

                    var reference = this.reference || ''
                    var currencyLabel = this.currency.label || '';
                    var currencyRate = this.documentDetails.currency_rate;

                    var printDate = moment().format('lll') || '';
                    var postDate = this.postDate || ''
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                    var initial_deposit = 0
                    var balance = 0
                    let currencyKey = component_x.currency.key;
                    var total_qty = 0
                    var total_cost = 0
                    var sub_total = 0
                    if (currencyKey>0 && this.showConversionRate){
                        var subtotal = this.tabulator.getColumn("subtotal")
                        await subtotal.updateDefinition({download:false})
                        var subtotal_php = this.tabulator.getColumn("subtotal_php")
                        await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                        var price = this.tabulator.getColumn("price")
                        await price.updateDefinition({download:false})
                        var cost_php = this.tabulator.getColumn("price_php")
                        await cost_php.updateDefinition({downloadTitle: "Cost", download:true})
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price_php).toString()
                        sub_total = (calculation.bottom.subtotal_php).toString()
                    }else {
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price).toString()
                        sub_total = (calculation.bottom.subtotal).toString()
                    }
                    if(this.document_config.document_type_settings.printSettings != undefined){
                        if(this.document_config.document_type_settings.printSettings.showStockNoInProductList!=undefined && this.document_config.document_type_settings.printSettings.showStockNoInProductList==true){
                            var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                            await supplier_stock_no.updateDefinition({download:true})
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                                this.tabulator.showColumn("supplier_stock_no")
                            }
                        }
                        if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                            var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                            await supplier_stock_no.updateDefinition({download:true})
                        }else{
                            var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                            await document_line_serials_text.updateDefinition({download:false})
                        }
                        if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                            var design = this.tabulator.getColumn("design")
                            await design.updateDefinition({download:true})
                            var size = this.tabulator.getColumn("size")
                            await size.updateDefinition({download:true})
                        }
                        if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                            await this.showDocumentPayment("initialDeposit")
                            initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                        }
                        if(component_x.document_config.document_type_settings.printSettings.showRefCode!=undefined && component_x.document_config.document_type_settings.printSettings.showRefCode==true){
                            var ref_code = this.tabulator.getColumn("ref_code")
                            await ref_code.updateDefinition({download: true})
                        }else{
                            var ref_code = this.tabulator.getColumn("ref_code")
                            await ref_code.updateDefinition({download: false})
                        }

                    }
                }
                var fileFormatter = function(columns, data, options, setFileContents){
                    var self = this,titles = [],fields = [],delimiter = options && options.delimiter ? options.delimiter : ",",
                        fileContents=[],output,main_header = [],second_main_header = [],supplier_header = [],target_date_header = [],
                        cancellation_date_header = [],reference_header = [],currency_header=[],currency_rate_header=[],status_header = [],purpose_header = [],remark_header = [],price_inclusion_and_initial_deposit_header = [],
                        comment1_and_balance = [],comment2_and_total = [],total_count = [],total_qty_row = [],total_cost_row = [],subtotal_row = [],
                        space_line = [],noted_by_row = [],verified_by_row = [],approved_by_row = [],printed_by_row = [],print_date_row = [],
                        post_date_row = [],created_by_row = [],posted_by_row = [];
                    //build column headers
                    function parseTitles() {
                        columns.forEach(function (column) {
                            titles.push(String(column.title).split('"').join('""'));
                            fields.push(column.field);
                        });
                        if(options.nested) {
                            titles.push(String(nestedParentTitle));
                        }
                    }
                    parseTitles();
                    function parseMainAndRemarkHeader(i){
                        if(i==0){
                            main_header.push(currentSiteName)
                            purpose_header.push("Purpose:")
                            remark_header.push("Remark:")
                            noted_by_row.push("Noted By:")
                            verified_by_row.push("Verified By:")
                            approved_by_row.push("Approved By:")
                        }else if(i==1){
                            purpose_header.push(purpose)
                            remark_header.push(remark)
                        }else if(i == titles.length-1){
                            main_header.push(documentType)
                        }else{
                            main_header.push("")
                            remark_header.push("")
                        }
                    }
                    function parseSecondMainHeader(i) {
                        if(i == titles.length-1){
                            second_main_header.push("# "+String(documentNumber))
                        }else{
                            second_main_header.push("")
                        }
                    }
                    function parseSupplierAndCustomDetailsHeader(i) {
                        if(i==0){
                            supplier_header.push("Supplier:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push("Price Inclusion:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push("Comment 1:")
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push("Comment 2:")
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == 1){
                            supplier_header.push(supplier)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push(priceInclusion)
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push(comment1)
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push(comment2)
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == titles.length-2){
                            supplier_header.push(currentDocumentTypeFriendlyCode+" Date:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push("Initial Deposit:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                comment1_and_balance.push("Balance:")
                            }else {
                                comment1_and_balance.push("")
                            }
                            comment2_and_total.push("Total:")
                        }else if(i == titles.length-1){
                            supplier_header.push(documentDate)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push(initial_deposit.toFixed(2))
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                balance = Number(calculation.bottom.subtotal) - Number(initial_deposit)
                                comment1_and_balance.push(balance)
                            }else{
                                comment1_and_balance.push("")
                            }
                            comment2_and_total.push(calculation.bottom.subtotal.toFixed(2))
                        }else{
                            supplier_header.push("")
                            price_inclusion_and_initial_deposit_header.push("")
                            comment1_and_balance.push("")
                            comment2_and_total.push("")
                        }
                    }
                    function parseOtherDetailsInHeader(i) {
                        if(i == titles.length-1){
                            target_date_header.push(targetDate)
                            cancellation_date_header.push(cancellationDate)
                            reference_header.push(reference)
                            currency_header.push(currencyLabel)
                            currency_rate_header.push(currencyRate)
                            status_header.push(documentStatus)
                        }else if(i == titles.length-2){
                            target_date_header.push("Target Date:")
                            cancellation_date_header.push("Cancellation Date:")
                            reference_header.push("Reference:")
                            currency_header.push("Currency:")
                            currency_rate_header.push("Currency Rate:")
                            status_header.push("Status:")
                        }else{
                            target_date_header.push("")
                            cancellation_date_header.push("")
                            reference_header.push("")
                            currency_header.push("")
                            currency_rate_header.push("")
                            status_header.push("")
                        }
                    }
                    function parseTotalCountRow(i) {
                        if(i==0){
                            total_qty_row.push("Total Quantity:")
                            total_cost_row.push("Total Cost:")
                            subtotal_row.push("Subtotal:")
                            printed_by_row.push("Printed By:")
                            created_by_row.push("Created By:")
                            posted_by_row.push("Posted By:")
                            print_date_row.push("Print Date:")
                            post_date_row.push("Post Date:")
                        }else if(i == 1){
                            total_qty_row.push(total_qty)
                            total_cost_row.push(total_cost)
                            subtotal_row.push(sub_total)
                            printed_by_row.push(userCode)
                            print_date_row.push('"'+String(printDate)+'"')
                            post_date_row.push('"'+String(postDate)+'"')
                            created_by_row.push(createdBy)
                            posted_by_row.push(postedBy)
                        }else{
                            total_qty_row.push("")
                            total_cost_row.push("")
                            subtotal_row.push("")
                            printed_by_row.push("")
                            print_date_row.push("")
                            post_date_row.push("")
                            created_by_row.push("")
                            posted_by_row.push("")
                        }
                    }
                    function parseMainHeader(){
                        for (var i = 0; i < titles.length; i++) {
                            parseMainAndRemarkHeader(i)
                            parseSecondMainHeader(i)
                            parseSupplierAndCustomDetailsHeader(i)
                            parseOtherDetailsInHeader(i)
                            parseTotalCountRow(i)
                            if(titles[i] == "Cost"){
                                total_count.push(total_cost)
                            }else if(titles[i] == "Quantity"){
                                total_count.push(total_qty)
                            }else if(titles[i] == "Subtotal"){
                                total_count.push(sub_total)
                            } else {
                                total_count.push("")
                            }
                            space_line.push("")
                        }
                    }

                    parseMainHeader()
                    fileContents.push(main_header);
                    fileContents.push(second_main_header);
                    fileContents.push(supplier_header);
                    fileContents.push(target_date_header);
                    fileContents.push(cancellation_date_header);
                    fileContents.push(reference_header);
                    fileContents.push(currency_header);
                    fileContents.push(currency_rate_header);
                    fileContents.push(status_header);
                    fileContents.push(purpose_header);
                    fileContents.push(remark_header);
                    fileContents.push(price_inclusion_and_initial_deposit_header);
                    fileContents.push(comment1_and_balance);
                    fileContents.push(comment2_and_total);
                    fileContents.push(space_line);
                    fileContents.push(titles);
                    function parseRows(data,parentValue="") {
                        //generate each row of the table
                        data.forEach(function (row) {
                            var rowData = [];

                            fields.forEach(function (field) {
                                var value = self.getFieldValue(field, row);

                                switch (value === "undefined" ? "undefined" : value) {
                                    case "undefined":
                                    case "null":
                                        value = "";
                                        break;

                                    default:
                                        value = value;
                                }

                                //escape quotation marks
                                rowData.push('"' + String(value).split('"').join('""') + '"');
                            });

                            if(options.nested) {
                                rowData.push('"' + String(parentValue).split('"').join('""') + '"');
                            }

                            fileContents.push(rowData.join(delimiter));

                            if(options.nested) {
                                if(row._children) {
                                    parseRows(row._children, self.getFieldValue(nestedParentField, row));
                                }
                            }
                        });
                    }
                    parseRows(data);
                    fileContents.push(total_count);
                    fileContents.push(space_line);
                    fileContents.push(total_qty_row);
                    fileContents.push(total_cost_row);
                    fileContents.push(subtotal_row);
                    fileContents.push(space_line);
                    fileContents.push(noted_by_row);
                    fileContents.push(verified_by_row);
                    fileContents.push(approved_by_row);
                    fileContents.push(printed_by_row);
                    fileContents.push(print_date_row);
                    fileContents.push(post_date_row);
                    fileContents.push(created_by_row);
                    fileContents.push(posted_by_row);
                    output = fileContents.join("\n");

                    if (options.bom) {
                        output = "\uFEFF" + output;
                    }

                    setFileContents(output, "text/csv");
                }
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download(fileFormatter, this.currentDocumentTypeFriendlyCodeWithId+".csv");
            },
            async onEnterScanner(){
                if(this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                    // this.document_config.document_type_settings.
                    if (this.filterExistingProductData.length > 0){
                    var group = {selectedObject:this.filterExistingProductData[0]}
                    await this.getProduct(group)
                        setTimeout(async function() {
                            await this.addProduct()
                            this.filterExistingProductData = []
                        }.bind(this), 250)
                    }else {
                        this.$notification['error']({
                            message: "barcode not found",
                            description: "Error",
                            style: getNotificationStyle('error')
                        });
                    }
                }
            },
            saveAllocationValidation(index){
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            async saveAllocation(index){
                if(!this.saveAllocationValidation(index)){
                    var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    if (((Number(total_site_quantity)+Number(this.drawerCurrentSiteAllocation[index].temp_quantity))-Number(this.drawerCurrentSiteAllocation[index].quantity)) > this.selectedSiteAllocationProduct.quantity){
                        this.drawerCurrentSiteAllocation[index].quantity = this.selectedSiteAllocationProduct.quantity
                        this.isEditAllocation=false
                        this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                    }else{
                        this.isEditAllocation=false
                        this.drawerCurrentSiteAllocation[index].quantity = this.drawerCurrentSiteAllocation[index].temp_quantity
                        total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    }
                    this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                }
            },
            editAllocation(index){
                this.isEditAllocation=true
                this.drawerCurrentSiteAllocation[index].temp_quantity = this.drawerCurrentSiteAllocation[index].quantity
                this.isEditAllocationIndex = index
            },
            beforeUploadWithAllocation(file) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.massAddWithAllocationProductErrors = []
                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var workbook = XLSX.read(text, {type: 'array'})
                    let sheetName = workbook.SheetNames[0]
                    let worksheet = workbook.Sheets[sheetName]
                    var lines = XLSX.utils.sheet_to_json(worksheet,{defval: '', blankrows: true })

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.')

                    for(var i = 0; i < lines.length; i++) {
                        let filteredObj = this.objectWithoutProperties(lines[i],['Line No','Stock No','Description','Barcode','Unit','Quantity','Cost','Subtotal','Serial No'])
                        let totalqtyAllocation = Object.keys(filteredObj).reduce((sum,key)=>sum+parseFloat(filteredObj[key]||0),0)
                        if (lines[i]["Quantity"] < totalqtyAllocation)
                            this.massAddWithAllocationProductErrors.push('Total allocated quantity:'+`${totalqtyAllocation}`+' > Maximum Quantity:'+`${lines[i]["Quantity"]}`+' for barcode number: '+`${lines[i]["Barcode"]}.`)

                        if(typeof lines[i]["Quantity"] === 'string')
                            qtylist.push(parseInt(lines[i]["Quantity"]))
                        else
                            qtylist.push(parseInt(lines[i]["Quantity"]) || 0)

                        skulist.push(lines[i]["Barcode"])
                    }
                    // Get duplicate sku's/barcode
                    const findDuplicates = (skulist) => {
                        let sorted_arr = skulist.slice().sort();
                        let results = [];
                        for (let i = 0; i < sorted_arr.length - 1; i++) {
                            if (sorted_arr[i + 1] == sorted_arr[i]) {
                                results.push(sorted_arr[i]);
                            }
                        }
                        return results;
                    }
                    // Result duplicate sku's/barcode -> download list
                    if(findDuplicates(skulist).length > 0) {
                        this.massAddWithAllocationProductErrors.push('With duplicate Barcodes');
                    }
                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else
                            return qty < 1
                    });
                    if(zQty.length > 0){
                        this.massAddWithAllocationProductErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }
                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // Result blank skus
                    if(bSku.length > 0)
                        this.massAddWithAllocationProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Proceed validating if barcodes are valid
                    if(this.massAddWithAllocationProductErrors.length < 1){
                        this.spinning = true;
                        if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp)
                            this.getSuppItems(skulist)
                        else
                            this.spinning = false;

                        this.fileWithAllocationList = [...this.fileWithAllocationList, file];
                    }
                    this.massAddWithAllocationProductErrors = this._.compact(this.massAddWithAllocationProductErrors);
                }
                reader.readAsArrayBuffer(file);
                this.spinning = false;
                return false;
            },
            objectWithoutProperties(obj, keys){
                var target = {};
                for (var i in obj) {
                    if (keys.indexOf(i) >= 0) continue;
                    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                    target[i] = obj[i];
                }
                return target;
            },
            importWithAllocationFile(){
                this.spinning = true;
                var bodyFormData = new FormData();
                bodyFormData.append('file', this.fileWithAllocationList[0])
                this.xlsxUploadFormData = bodyFormData
                this.documentStatus = 'Uploading';
                this.processingXlsxUpload = true
                if (this.documentNumber > 1) {
                    this.update();
                } else {
                    this.save();
                }
                this.closeDrawer('massAddWithAllocation');
                this.spinning = false;
                return false;
            },
            async viewSiteAllocation(){
                this.viewAllocation = true
                this.documentLines = this.tabulator.getData();
            },
            async exportWithAllocationDocument(){
                let formattedLines = []
                let lines = this.tabulator.getData()
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': lines[i].cost,
                        'Subtotal': lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                formatLine[' '+`${obj.code}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var dataWS = XLSX.utils.json_to_sheet(formattedLines)
                var wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.currentDocumentTypeFriendlyCodeWithId+".xlsx")
            },
            async downLoadExcelIfMoreThan5Site(){
                var wb = XLSX.utils.book_new()
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                var userCode = secureStorage.getItem("userCode") || '';
                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''
                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''
                var reference = this.reference || ''
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''
                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''
                let currencyKey = component_x.currency.key;
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                var calculation = tabulatorInstance.getCalcResults();
                let formattedLines = []
                var lines = this.tabulator.getData();
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': lines[i].cost,
                        'Subtotal': lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                formatLine[' '+`${obj.code}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var lineCount = parseInt(formattedLines.length)
                var dataWS = XLSX.utils.sheet_add_json(wb.Sheets.sheet1,formattedLines,{origin: "A12"})
                XLSX.utils.sheet_add_aoa(dataWS,[[currentSiteName,"","","","","","","",documentType]],{origin: "A1"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","# "+String(documentNumber)]],{origin: "A2"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","",currentDocumentTypeFriendlyCode+" Date:",documentDate]],{origin: "A3"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Target Date:",targetDate]],{origin: "A4"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Cancellation Date:",cancellationDate]],{origin: "A5"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Reference:",reference]],{origin: "A6"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A7"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Purpose",purpose,"","","","","","","Status:",documentStatus]],{origin: "A8"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Remark:",remark,"","","","","",""]],{origin: "A9"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Total:",calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")]],{origin: "A10"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A11"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Total Quantity:",(calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+17}`});
                if(currencyKey>0 && component_x.showConversionRate){
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",(calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",(calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }else{
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",(calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",(calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }
                XLSX.utils.sheet_add_aoa(dataWS,[["Noted By:","____________________________________","","",""]],{origin: "A"+`${lineCount+21}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Verified By:","____________________________________","","",""]],{origin: "A"+`${lineCount+22}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Approved By:","____________________________________","","",""]],{origin: "A"+`${lineCount+23}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","",""]],{origin: "A"+`${lineCount+24}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Printed By:",userCode,"","","",""]],{origin: "A"+`${lineCount+25}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Print Date:",printDate,"","","",""]],{origin: "A"+`${lineCount+26}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Post Date:",postDate,"","","",""]],{origin: "A"+`${lineCount+27}`});
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.currentDocumentTypeFriendlyCodeWithId+".xlsx")
            },
            async changeCostBySupplier(){
                this.spinning = true
                this.confirmLoadingonSuppModal = true
                let items = this.tabulator.getData();
                let newItems = []
                for(let i = 0; i < items.length; i++){
                    let item = items[i]
                    let product_id = item.product_id
                    let  supp_id = this.supplier.key
                    if(item.product_type == "I"){
                        product_id = item.matrix_parent_id
                    }

                    // should it change if wala sya na kita sa dating ordering cost from api or not?
                    var product = await HTTPRequest.getRequest(this.endPoint + 'products/' + product_id + '?supplier_id=' + supp_id)
                    if(product != null){
                        if(product.supplier_product_ordering_cost > 0 && this.productPriceChoice == 'ordering_cost'){
                            // this.unitCost = alternate_supplier.ordering_cost
                            // this.unitNetCost = alternate_supplier.ordering_cost
                            item.cost = Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                            item.price = Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                            item.subtotal = Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces) * item.quantity
                            item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.tax_amount = item.subtotal - item.subtotal_without_vat
                        }else{
                            var site_id = secureStorage.getItem("defaultSiteId");
                            let product_id
                            if(item.matrix_parent_id == null){
                                product_id = item.product_id
                            }else{
                                product_id = item.matrix_parent_id
                            }

                            let order_cost
                            var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + product_id + '&site_id=' + site_id);
                            if(site_product != null){
                                var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                                if(siteUnitCost != null && siteUnitCost > 0){
                                    order_cost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                                }else{
                                    var cost = eval('product.'+this.productPriceChoice)
                                    order_cost = Number(cost).toFixed(this.decimalPlaces)
                                }
                            }
                            // this.unitCost = alternate_supplier.ordering_cost
                            // this.unitNetCost = alternate_supplier.ordering_cost
                            item.cost = Number(order_cost).toFixed(this.decimalPlaces)
                            item.price = Number(order_cost).toFixed(this.decimalPlaces)
                            item.subtotal = Number(order_cost).toFixed(this.decimalPlaces) * item.quantity
                            item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.tax_amount = item.subtotal - item.subtotal_without_vat
                        }
                        newItems.push(item)
                    }
                }
                // console.log(newItems)
                await this.tabulator.updateData(newItems)
                this.confirmLoadingonSuppModal = false
                this.spinning = false
                this.showChangeSupplierModal = false
            },

            async handleSearchDrawerSites(value) {
                if (value == undefined) value = ''
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?name='+value, null)
            },

            async getSettings(){
                let AccountSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=accountSettings&status=A', null)
                if(AccountSettings.length > 0){
                    let as = JSON.parse(AccountSettings[0].value)
                    let printFontSize = as.printSettingsFontSizePTPM
                    if(printFontSize != null){
                        this.printFontSizeIncrease = printFontSize
                    }
                    let valueHeaderPos = as.printSettingsValueHeaderPos
                    if(valueHeaderPos != null){
                        this.printValueHeaderPos = valueHeaderPos
                    }
                    let valueFooterPos = as.printSettingsValueFooterPos
                    if(valueFooterPos != null){
                        this.printValueFooterPos = valueFooterPos
                    }
                    let printPaperSize = as.printSettingsPaperSizePTPM
                    if(printPaperSize != null){
                        this.printPaperSize = printPaperSize
                    }
                    // console.log(AccountSettings[0].value.userPasswordFormatStrict,AccountSettings[0].value[:userPasswordFormatStrict])
                    // if(AccountSettings[0].value.userPasswordFormatStrict!=null){
                    // }
                }
            },
            updateValueOfSupplierCurrency(){
                if (this.supplierCurrencyRate!=this.supplierDetails.currency_rate){
                    this.supplierCurrencyRate = this.supplierDetails.currency_rate
                }
                if (this.supplierCurrencyId!=this.supplierDetails.currency_id){
                    this.supplierCurrencyId = this.supplierDetails.currency_id
                }
                if (this.currencyDetails.key == this.supplierCurrencyId){
                    this.currencyRate = this.supplierCurrencyRate
                }
            },
          renderColumnFields() {
            this.filteredColumnFields.map(({ name, value }) => {
              if (value) {
                if (this.currentDocumentTypeCode === 'ORIPOX') {
                  if (name === "actual_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Received Quantity" })
                  if (name === "content_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Balance Quantity" })
                  if (name === "price") this.tabulator.getColumn(name).updateDefinition({ title: "Unit Cost" })
                }
                if (this.currentDocumentTypeCode === 'OTHUPC' || this.currentDocumentTypeCode === 'OTHPCN') {
                  if (name === "actual_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Frozen Quantity" })
                }
                this.tabulator.showColumn(name)
              } else {
                this.tabulator.hideColumn(name)
              }
            })
          }
        },
        watch: {
            paymentMode: async function() {
                if(this.paymentMode == "dragonpay" && this.paymentMethods.length == 0){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_dragonpay_processors', null)
                    component_x.paymentMethods = response
                }
            },
            viewAllocation: async function(){
                if (this.viewAllocation){
                    this.totalAllocatedQty = 0
                    var column_names = []
                    var check_error = false
                    try{
                        component_x.tabulator1 = this.$refs.tabulator1.getInstance();
                        check_error = false
                    }catch(e){
                        check_error = true
                    }
                    var lines = this.documentLines;
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            var ttl_quantity = 0
                            lines[i].site_allocation.forEach(function(obj) {
                                if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                    var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                    lines[i][`${obj.code}`] = qty
                                    ttl_quantity+= isNaN(parseInt(qty)) ? 0 : parseInt(qty)
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    lines[i][`${obj.code}`] = qty
                                    ttl_quantity+= isNaN(parseInt(qty)) ? 0 : parseInt(qty)
                                }
                                if (!column_names.includes(obj.code)) {
                                    column_names.push(obj.code);
                                }
                            });
                            lines[i]["total_allocated_quantity"] =  parseInt(ttl_quantity)
                            this.totalAllocatedQty += parseInt(ttl_quantity)
                        }
                    }
                    for (var index = 0; index < column_names.length; index++) {
                        try {
                            var customField = component_x.tabulator1.getColumn(column_names[index])
                            if (customField==undefined || customField==null || customField=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                                }else{
                                    component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                            }else{
                                component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                            }
                        }
                    }
                    if (column_names.length > 0){
                        try {
                            var total_allocated_quantity = component_x.tabulator1.getColumn("total_allocated_quantity")
                            if (total_allocated_quantity==undefined || total_allocated_quantity==null || total_allocated_quantity=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }else{
                                    component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }else{
                                component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }
                        }
                    }
                }

            },
            revenue: function(){
                if (this.revenue == 'R'){
                    this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                }else if(this.revenue =='T'){
                    this.revenueSiteId = this.requestingSite.key || 0
                }
            },
            supplierDetails: function(){
                if (this.currentDocumentTypeCode == 'ORIPOX' || this.currentDocumentTypeCode=='RECDEL'){
                    if (this.documentStatus != 'Posted' && this.documentStatus != 'Voided' && this.documentStatus != 'Saved'){
                       this.updateValueOfSupplierCurrency()
                    }
                }
            }
        }
    };

</script>

<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";

/* #135: "X" button for search product vertical align */
.autocomplete__icon.autocomplete--clear {
    height: 100%;
}

.tabulator-calcs-holder{
    display: none;
}

.sticky-header {
    z-index: 100;
}

.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
    width: 250px;
}

// .tabulator-menu {
//     position: absolute;
//     z-index: 999999;
//     background-color: white;
//     border: groove;
//     padding: 10px;
//     cursor: pointer;
// }

// .tabulator-menu-item:hover {
//     background-color: whitesmoke;
// }

</style>

<style scoped>
@media (min-width: 1200px) {
    .container {
        max-width: 100%;
    }
}
.table-scroll {
	position:relative;
	max-width:600px;
	margin:auto;
	overflow:hidden;
	border:1px solid #000;
}
.table-wrap {
	width:100%;
	overflow:auto;
}
.table-scroll table {
	width:100%;
	margin:auto;
	border-collapse:separate;
	border-spacing:0;
}
.table-scroll th, .table-scroll td {
	padding:5px 10px;
	border:1px solid #000;
	background:#fff;
	white-space:nowrap;
	vertical-align:top;
}
.fixed-side {
	border:1px solid #000;
	background:#eee;
	visibility:visible;
}
.refresh-document {
    margin: 0 10px;
    font-size: 20px;
    display: flex;
    align-items: center;
    height: 26px;
    color: inherit !important;
}
</style>
